(function() {
    'use strict';

    angular
        .module('madApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            // 'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            // 'angular-loading-bar',
            'angular.filter',
            'vljslib'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler','$rootScope', '$location'];

    function run(stateHandler, translationHandler,$rootScope, $location) {
        stateHandler.initialize();
        translationHandler.initialize();
        $rootScope.$location = $location;

        Highcharts.theme = {
          colors: [
            '#7cb5ec','#90ed7d','#59595a'
          ],}
          Highcharts.setOptions(Highcharts.theme);
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('vl', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig)
        .run(stateRun);

    stateConfig.$inject = ['$stateProvider', '$urlRouterProvider'];
    stateRun.$inject = ['$rootScope', '$state'];

    function stateRun($rootScope, $state) {
        $rootScope.state = $state;
      }

    function stateConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('vl.dashboards.revenue', {
                parent: 'vl.dashboards',
                url: '/revenue',
                data: {
                    pageTitle: 'home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/vl/dashboards/revenue/views/revenue.html',
                        controller: 'dorRevenueController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('revenue');
                        return $translate.refresh();
                    }]
                }
            })
            .state('vl.dashboards.revenue.collections', {
                url: '/collections/:type/:id',
                params : {fromDate:null, toDate:null},
                templateUrl: 'app/vl/dashboards/revenue/views/revenue.collections.html'
            })
            .state('vl.dashboards.revenue.dcb', {
                url: '/dcb/total/:type/:id',
                params : {fromDate:null, toDate:null},
                templateUrl: 'app/vl/dashboards/revenue/views/revenue.dcb.html'
            })
            .state('vl.dashboards.revenue.dcbprivate', {
                url: '/dcb/private/:type/:id',
                params : {fromDate:null, toDate:null},
                templateUrl: 'app/vl/dashboards/revenue/views/revenue.dcb.html'
            })
            .state('vl.dashboards.revenue.dcbstate', {
                url: '/dcb/state/:type/:id',
                params : {fromDate:null, toDate:null},
                templateUrl: 'app/vl/dashboards/revenue/views/revenue.dcb.html'
            })
            .state('vl.dashboards.revenue.dcbcentral', {
                url: '/dcb/central/:type/:id',
                params : {fromDate:null, toDate:null},
                templateUrl: 'app/vl/dashboards/revenue/views/revenue.dcb.html'
            })
            .state('vl.dashboards.revenue.dcbvacant', {
                url: '/dcb/vacant/:type/:id',
                params : {fromDate:null, toDate:null},
                templateUrl: 'app/vl/dashboards/revenue/views/revenue.dcb.html'
            })
            .state('vl.dashboards.revenue.dcbcourt', {
                url: '/dcb/court/:type/:id',
                params : {fromDate:null, toDate:null},
                templateUrl: 'app/vl/dashboards/revenue/views/revenue.dcb.html'
            })
            .state('vl.dashboards.revenue.receipts', {
                url: '/receipts/:type/:id',
                params : {fromDate:null, toDate:null},
                templateUrl: 'app/vl/dashboards/revenue/views/revenue.receipts.html'
            })
            .state('vl.dashboards.revenue.top10', {
                url: '/top10/:type/:id',
                params : {fromDate:null, toDate:null},
                templateUrl: 'app/vl/dashboards/revenue/views/revenue.top10.html'
            })
            .state('vl.dashboards.revenue.bottom10', {
                url: '/bottom10/:type/:id',
                params : {fromDate:null, toDate:null},
                templateUrl: 'app/vl/dashboards/revenue/views/revenue.bottom10.html'
            })
            .state('vl.dashboards.revenue.top100defaulters', {
                url: '/top100defaulters/:type/:id',
                params : {fromDate:null, toDate:null},
                templateUrl: 'app/vl/dashboards/revenue/views/revenue.top100defaulters.html'
            })
            .state('vl.dashboards.revenue.collectionranking', {
                url: '/collectionranking/:parentofficertype/:officertype/:type/:id/',
                params : {fromDate:null, toDate:null},
                templateUrl: 'app/vl/dashboards/revenue/views/revenue.collectionranking.html'
            })
            .state('blocked', {
                url: '/blocked',
                data: {
                    pageTitle: 'Access Denied'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/vl/dashboards/revenue/views/blocked.html',
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('revenue');
                        return $translate.refresh();
                    }]
                }
            });

         $urlRouterProvider.when('/revenue', '/revenue/collections/DISTRICT/');

    }
})();

(function () {
    'use strict';
    angular.module('madApp')
    .factory('RevenueServices', RevenueServices);
    RevenueServices.$inject = ['$resource'];

    function RevenueServices($resource) {
        var statecollection ={
        };
        var propertyType = null;
        var service =  {
            getCollections: getCollections,
            getDCB: getDCB,
            getReceipts: getReceipts,
            getTop10: getTop10,
            getBottom10: getBottom10,
            getTop100Defaulters: getTop100Defaulters,
            getCollectionTableData: getCollectionTableData,
            listAllUlBs:listAllUlBs,
            setstate:setstate,
            getstate:getstate,
            getPropertyType:getPropertyType,
            setPropertyType:setPropertyType,
            getCollectionRankingData: getCollectionRankingData
        };
        return service;

        function setPropertyType(input) {
            propertyType = input;
        }

        function getPropertyType() {
            return propertyType;
        }

        function setstate(input,type) {
            statecollection[type] = input;
        }

        function getstate(type) {
            return statecollection[type];
        }

        function getCollections() {
            var resourceUrl = 'api/childCollectionData';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET',  cache: true, isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

        function getDCB() {
            var resourceUrl = 'api/childDCBData';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET', cache: true, isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

        function getReceipts() {
            var resourceUrl = 'api/childReceiptsData';

            return $resource(resourceUrl, {cache: true}, {
                'query': {
                    method: 'GET', cache:true, isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

        function getTop10() {
            var resourceUrl = 'api/top10Data';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET', isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }
        function getBottom10() {
            var resourceUrl = 'api/bottom10Data';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET', cache: true, isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

        function getTop100Defaulters() {
            var resourceUrl = 'api/top100DefaultersData';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET', cache: true, isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

        function getCollectionRankingData() {
            var resourceUrl = 'api/collectionRankingData';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET', cache: true, isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

        function getCollectionTableData() {
            var resourceUrl = 'api/collectionTableData';

            return $resource(resourceUrl, {cache: true}, {
                'get': {
                    method: 'GET',  cache: true, isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

        function listAllUlBs() {
            var resourceUrl = 'api/getAllULBData';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET', isArray: false, cache: true,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('madApp')
        .controller('dorRevenueController', dorRevenueController)
    ;

    dorRevenueController.$inject = ['$scope', '$state', '$filter', 'dorStateSummariesService', 'RevenueServices', 'AlertService','Principal'];
    function dorRevenueController($scope, $state, $filter, dorStateSummariesService, RevenueServices, AlertService,Principal) {
        var vm = this;
        vm.stateSummaryData = {};
        vm.currentState = 'vl.dashboards.revenue.collections';
        vm.queryData = {};
        vm.loadingAllUlbDataRecords = true;
        vm.loadingStateSummary = true;
        vm.firstcall = true;
        vm.loadingInner = true;
        vm.showDates = true;
        vm.formHidden = true;
        vm.ulbtype= null;
        vm.showAll = false;
        vm.conversionType = "Crores";
        vm.currencyUnits = "Crs";
        vm.flag = false;
        vm.officerType = null;
        vm.parentofficerType = null;
        vm.showdcbpenalties = Principal.isAuthenticated;
        vm.dcbpenaltyType = 'without_penalties';

	//TODO:move to state params
        $scope.$watch('vm.conversionType', function (newValue, oldValue) {
            if (newValue && newValue!=oldValue) {
              vm.conversionType = newValue;
              if(vm.conversionType == "Crores"){
                vm.currencyUnits = "Crs";
              }
              if(vm.conversionType == "Lakhs"){
                vm.currencyUnits = "Lacs";
              }
              vm.flag = true ;
              if ('vl.dashboards.revenue.collections' === vm.currentState) {
                loadCollectionsData();
              }
              else if('vl.dashboards.revenue.receipts' === vm.currentState){
                loadReceiptsData();
              }
              else if('vl.dashboards.revenue.top10' === vm.currentState){
                loadTop10Data();
              }
              else if('vl.dashboards.revenue.bottom10' === vm.currentState){
                loadBottom10Data();
              }
              else if('vl.dashboards.revenue.top100defaulters' === vm.currentState){
                loadDefaultersData();
              }
              else if('vl.dashboards.revenue.collectionranking' === vm.currentState){
                loadCollectionRankingData();
              }
              else if('vl.dashboards.revenue.dcbcourt' === vm.currentState
                        || 'vl.dashboards.revenue.dcbcentral' === vm.currentState ||
                        'vl.dashboards.revenue.dcbvacant' === vm.currentState ||
                        'vl.dashboards.revenue.dcbstate' === vm.currentState ||
                        'vl.dashboards.revenue.dcbprivate' === vm.currentState ||
                        'vl.dashboards.revenue.dcb' === vm.currentState
                    ){
                        callDCB();
              }
            }
          });
        
          $scope.$watch('vm.dcbpenaltyType', function (newValue, oldValue) {
            console.log(newValue)
            if (newValue && newValue!=oldValue) {
              vm.dcbpenaltyType = newValue;
              callDCB();
            }
          });

        vm.tabs = [
            {
                title: $filter('translate')("revenue.tabs.collections.title"),
                route: 'vl.dashboards.revenue.collections',
                loadingData: true,
                active: false
            },
            {
                title: $filter('translate')("revenue.tabs.dcb.title"),
                route: 'vl.dashboards.revenue.dcb',
                active: false

            },
            {
                title: $filter('translate')("revenue.tabs.receipts.title"),
                route: "vl.dashboards.revenue.receipts",
                active: false
            },
            {
                title: $filter('translate')("revenue.tabs.top10.title"),
                route: "vl.dashboards.revenue.top10",
                active: false
            },
            {
                title: $filter('translate')("revenue.tabs.bottom10.title"),
                route: "vl.dashboards.revenue.bottom10",
                active: false
            },
            {
                title: $filter('translate')("revenue.tabs.top100defaulters.title"),
                route: "vl.dashboards.revenue.top100defaulters",
                active: false
            },
            {
                title: $filter('translate')("revenue.tabs.collectionranking.title"),
                route: "vl.dashboards.revenue.collectionranking",
                active: false
            }
        ];

        vm.active = function (route) {
            return $state.is(route);
        };
        $scope.$on("$stateChangeSuccess", function () {

          if(vm.ulbtype !== null){
            if(($state.params.type==="ULB" || $state.params.type==="ULB_BILL" || $state.params.type==="ULB_REVENUE_INSPECTOR"
            || $state.params.type === "ULB_REVENUE_OFFICER") && $state.params.id){
              vm.conversionType = "Lakhs";
              vm.currencyUnits = "Lacs";
            }
            else{
              vm.conversionType = "Crores";
              vm.currencyUnits = "Crs";
            }
          }
          else{
            if(($state.params.type==="ULB" || $state.params.type==="ULB_BILL" || $state.params.type==="ULB_REVENUE_INSPECTOR"
            || $state.params.type === "ULB_REVENUE_OFFICER") && $state.params.id){
              vm.conversionType = "Lakhs";
              vm.currencyUnits = "Lacs";
            }

            else if($state.params.type==="ALL_WARD"){
              vm.conversionType = "Lakhs";
              vm.currencyUnits = "Lacs";
            }
            else{
              if(vm.currentState === $state.current.name){
                vm.conversionType = vm.conversionType;
                vm.currencyUnits = vm.currencyUnits;
              }else{
                vm.conversionType = "Crores";
                vm.currencyUnits = "Crs";
              }
            }
          }

          vm.ftype = $state.params.type;
          vm.fkey = $state.params.id;
          vm.formHidden = true;
          vm.ulbtype = null;
          vm.propertyType = null;
          vm.showProperty = false;
          vm.showAll = false;

          if(vm.ftype==='' && vm.fkey===''){
            vm.queryData = {
                    fromDate: null,
                    toDate: null,
                    gradeType: 'district',
                    grade: null,
                    selectedULB: null
                };
          }

          if($state.params.type === "ALL_ULB" || $state.params.type === "ALL_WARD" ||  $state.params.type === "ALL_SEC_WARD"){
            vm.showAll = true;
          }


            // vm.tabs.forEach(function (tab) {
            //     tab.active = vm.active(tab.route);
            //     if (tab.active) {
            //         vm.currentState = tab.route;
            //     }
            // });
            vm.currentState = $state.current.name;
            RevenueServices.setPropertyType(null);
            // All Load calls go here
            vm.officerType = null;
            vm.parentofficerType = null;
            if ('vl.dashboards.revenue.collections' === vm.currentState) {
                vm.showDates = true;
                if(($state.params.type==="ULB" || $state.params.type==="ULB_BILL" || $state.params.type==="ULB_REVENUE_INSPECTOR"
                || $state.params.type === "ULB_REVENUE_OFFICER" || $state.params.type === "ULB_WARD"  || $state.params.type === "ULB_SEC_WARD_SECRETARY" 
                || $state.params.type === "ULB_SEC_REVENUE_INSPECTOR" || $state.params.type === "ULB_SEC_REVENUE_OFFICER") && $state.params.id)
                {
                    vm.ulbtype = $state.params.type;
                }
                else{
                    vm.ulbtype = null;
                }
                callCollection();
            }
            if ('vl.dashboards.revenue.dcb' === vm.currentState) {
                vm.showDates = true;
                if(($state.params.type==="ULB" || $state.params.type==="ULB_BILL" || $state.params.type==="ULB_REVENUE_INSPECTOR"
                || $state.params.type === "ULB_REVENUE_OFFICER" || $state.params.type === "ULB_WARD"  || $state.params.type === "ULB_SEC_WARD_SECRETARY" 
                || $state.params.type === "ULB_SEC_REVENUE_INSPECTOR" || $state.params.type === "ULB_SEC_REVENUE_OFFICER") && $state.params.id)
                {
                    vm.ulbtype = $state.params.type;
                }
                else{
                    vm.ulbtype = null;
                }
                vm.officerType = null;
                // if(vm.dcb!=undefined)
                //   vm.dcb["options"] = null;
                callDCB();
            }
            if ('vl.dashboards.revenue.dcbprivate' === vm.currentState) {
                vm.showDates = true;
                if(($state.params.type==="ULB" || $state.params.type==="ULB_BILL" || $state.params.type==="ULB_REVENUE_INSPECTOR"
                || $state.params.type === "ULB_REVENUE_OFFICER" || $state.params.type === "ULB_WARD"  || $state.params.type === "ULB_SEC_WARD_SECRETARY" 
                || $state.params.type === "ULB_SEC_REVENUE_INSPECTOR" || $state.params.type === "ULB_SEC_REVENUE_OFFICER") && $state.params.id)
                {
                    vm.ulbtype = $state.params.type;
                }
                else{
                    vm.ulbtype = null;
                }
                vm.propertyType = "Private";
                // if(vm.dcb!=undefined)
                //   vm.dcb["options"] = null;
                callDCB();
            }
            if ('vl.dashboards.revenue.dcbstate' === vm.currentState) {
                vm.showDates = true;
                if(($state.params.type==="ULB" || $state.params.type==="ULB_BILL" || $state.params.type==="ULB_REVENUE_INSPECTOR"
                || $state.params.type === "ULB_REVENUE_OFFICER" || $state.params.type === "ULB_WARD"  || $state.params.type === "ULB_SEC_WARD_SECRETARY" 
                || $state.params.type === "ULB_SEC_REVENUE_INSPECTOR" || $state.params.type === "ULB_SEC_REVENUE_OFFICER") && $state.params.id)
                {
                    vm.ulbtype = $state.params.type;
                }
                else{
                    vm.ulbtype = null;
                }
                vm.propertyType = "State Government";
                // if(vm.dcb!=undefined)
                //   vm.dcb["options"] = null;
                callDCB();
            }
            if ('vl.dashboards.revenue.dcbcentral' === vm.currentState) {
                vm.showDates = true;
                if(($state.params.type==="ULB" || $state.params.type==="ULB_BILL" || $state.params.type==="ULB_REVENUE_INSPECTOR"
                || $state.params.type === "ULB_REVENUE_OFFICER" || $state.params.type === "ULB_WARD"  || $state.params.type === "ULB_SEC_WARD_SECRETARY" 
                || $state.params.type === "ULB_SEC_REVENUE_INSPECTOR" || $state.params.type === "ULB_SEC_REVENUE_OFFICER") && $state.params.id)
                {
                    vm.ulbtype = $state.params.type;
                }
                else{
                    vm.ulbtype = null;
                }
                vm.propertyType = "CENTRAL_GOVT";
                // if(vm.dcb!=undefined)
                //   vm.dcb["options"] = null;
                callDCB();
            }
            if ('vl.dashboards.revenue.dcbvacant' === vm.currentState) {
                vm.showDates = true;
                if(($state.params.type==="ULB" || $state.params.type==="ULB_BILL" || $state.params.type==="ULB_REVENUE_INSPECTOR"
                || $state.params.type === "ULB_REVENUE_OFFICER" || $state.params.type === "ULB_WARD"  || $state.params.type === "ULB_SEC_WARD_SECRETARY" 
                || $state.params.type === "ULB_SEC_REVENUE_INSPECTOR" || $state.params.type === "ULB_SEC_REVENUE_OFFICER") && $state.params.id)
                {
                    vm.ulbtype = $state.params.type;
                }
                else{
                    vm.ulbtype = null;
                }
                vm.propertyType = "Vacant Land";
                // if(vm.dcb!=undefined)
                //   vm.dcb["options"] = null;
                callDCB();
            }
            if ('vl.dashboards.revenue.dcbcourt' === vm.currentState) {
                vm.showDates = true;
                if(($state.params.type==="ULB" || $state.params.type==="ULB_BILL" || $state.params.type==="ULB_REVENUE_INSPECTOR"
                || $state.params.type === "ULB_REVENUE_OFFICER" || $state.params.type === "ULB_WARD"  || $state.params.type === "ULB_SEC_WARD_SECRETARY" 
                || $state.params.type === "ULB_SEC_REVENUE_INSPECTOR" || $state.params.type === "ULB_SEC_REVENUE_OFFICER") && $state.params.id)
                {
                    vm.ulbtype = $state.params.type;
                }
                else{
                    vm.ulbtype = null;
                }
                vm.propertyType = "Courtcases";
                // if(vm.dcb!=undefined)
                //   vm.dcb["options"] = null;
                callDCB();
            }
            if ('vl.dashboards.revenue.receipts' === vm.currentState) {
                vm.showDates = true;


                 if(($state.params.type === "ULB" || $state.params.type === "ULB_WARD") && $state.params.id)
                {
                    vm.ulbtype = $state.params.type;
                }
                else{
                    vm.ulbtype = null;
                }
                // if(vm.reciepts!=undefined)
                //   vm.reciepts["options"] = null;
                callreceipts();
            }
            if ('vl.dashboards.revenue.top10' === vm.currentState) {
                vm.showDates = true;
                if( ($state.params.type==="ULB" || $state.params.type==="ULB_BILL" || $state.params.type==="ULB_REVENUE_INSPECTOR"
                || $state.params.type === "ULB_REVENUE_OFFICER"  || $state.params.type === "ULB_WARD"  || $state.params.type === "ULB_SEC_WARD_SECRETARY" 
                || $state.params.type === "ULB_SEC_REVENUE_INSPECTOR" || $state.params.type === "ULB_SEC_REVENUE_OFFICER") && $state.params.id)
                {
                    vm.ulbtype = $state.params.type;
                }
                else{
                    vm.ulbtype = null;
                }
                calltop10();
            }
            if ('vl.dashboards.revenue.bottom10' === vm.currentState) {
                vm.showDates = true;
                if(($state.params.type==="ULB" || $state.params.type==="ULB_BILL" || $state.params.type==="ULB_REVENUE_INSPECTOR"
                || $state.params.type === "ULB_REVENUE_OFFICER"  || $state.params.type === "ULB_WARD"  || $state.params.type === "ULB_SEC_WARD_SECRETARY" 
                || $state.params.type === "ULB_SEC_REVENUE_INSPECTOR" || $state.params.type === "ULB_SEC_REVENUE_OFFICER") && $state.params.id)
                {
                    vm.ulbtype = $state.params.type;
                }
                else{
                    vm.ulbtype = null;
                }
                callbottom10();
            }
            if ('vl.dashboards.revenue.top100defaulters' === vm.currentState) {
                vm.showDates = false;
                vm.showProperty = true;
                vm.officerType = null;
                vm.parentofficerType = null;
                calldefaulters();
            }
            if ('vl.dashboards.revenue.collectionranking' === vm.currentState) {
                vm.showDates = false;
                vm.parentofficerType = 'secretariatward';
                vm.officerType = "wardsecretary";
                callCollectionRanking();
            }
        });
        loadStateSummary();
        function loadStateSummary() {
            dorStateSummariesService.stateSummaries.summary().$promise.then(dorStateSummaryCallSuccess, dorStateSummaryCallError);
            function dorStateSummaryCallSuccess(data) {
                vm.loadingStateSummary = false;
                vm.stateSummaryData = {
                    formattedDate: $filter('date')(data.calculatedOn, "dd-MMM-yyyy"),
                    formattedTime: $filter('date')(data.calculatedOn, "hh:mm a"),
                    totalRevenueAmount: ($filter('number')(data.totalRevenueCollected.amount)),
                    totalRevenueUnit: getAmountUnits(data.totalRevenueCollected.amount),
                    propertyTax: {
                        collected: {
                            amount: ($filter('number')(data.propertyTax.collected.amount)),
                            amountUnit: getAmountUnits(data.propertyTax.collected.amount),
                            variance: (data.propertyTax.varianceOverLastYear),
                            achievement: (data.propertyTax.achievementPercent)
                        },
                        lastYear: {
                            amount: ($filter('number')(data.propertyTax.collectedLastYear.amount)),
                            amountUnit: getAmountUnits(data.propertyTax.collectedLastYear.amount)
                        },
                        target: {
                          amount: ($filter('number')(data.propertyTax.target.amount)),
                          amountUnit: getAmountUnits(data.propertyTax.target.amount)}
                    },
                    waterCharges: {
                        collected: {
                            amount: ($filter('number')(data.waterCharges.collected.amount)),
                            amountUnit: getAmountUnits(data.waterCharges.collected.amount),
                            variance: (data.waterCharges.varianceOverLastYear),
                            achievement: (data.waterCharges.achievementPercent)
                        },
                        lastYear: {
                            amount: ($filter('number')(data.waterCharges.collectedLastYear.amount)),
                            amountUnit: getAmountUnits(data.waterCharges.collectedLastYear.amount)
                        },
                        target: {
                          amount: ($filter('number')(data.waterCharges.target.amount)),
                          amountUnit: getAmountUnits(data.waterCharges.target.amount)}

                    },
                    others: {
                        collected: {
                            amount: ($filter('number')(data.others.collected.amount)),
                            amountUnit: getAmountUnits(data.others.collected.amount),
                            variance: (data.others.varianceOverLastYear),
                            achievement: (data.others.achievementPercent)
                        },
                        lastYear: {
                            amount: ($filter('number')(data.others.collectedLastYear.amount)),
                            amountUnit: getAmountUnits(data.others.collectedLastYear.amount)
                        },
                        target: {
                          amount: ($filter('number')(data.others.target.amount)),
                          amountUnit: getAmountUnits(data.others.target.amount)}
                    }
                };
                vm.loadingStateSummary = false;
            }

            function dorStateSummaryCallError(error) {
              vm.loadingStateSummary = false;
              AlertService.error(error.data.message);

            }
        }

        function getAmountUnits(amount){
          if(amount){
            return "Crs";
          }else{
            return null;
          }
        }

        loadAllULBData();
        function loadAllULBData() {
            if (vm.ulbList) return;
            vm.loadingAllUlbDataRecords = true;
            RevenueServices.listAllUlBs().query().$promise.then(allUlbSuccess, allUlbError);
            function allUlbSuccess(data) {
                if (data.data) {
                    vm.ulbList = data.data;
                    vm.loadingAllUlbDataRecords = false;
                }
            }

            function allUlbError(error) {
                vm.loadingAllUlbDataRecords = false;
                AlertService.error(error.data.message);
            }

        }

        function setdates(from, to) {
            if (from) {
                $state.params.fromDate = from;
            }
            if (to) {
                $state.params.toDate = to;
            }
        }

        // callCollection();
        //    setTimeout(function () {
        //      callDCB();
        //      callreceipts();
        //      calltop10();
        //      callbottom10();
        //      calldefaulters();
        //    }, 8000);


        function callCollection(key, type, from, to) {
            //setdates(from, to);
            //collectionData(key, type);

            loadCollectionsData();
        }

        function callDCB(key, type, from, to) {
            //setdates(from, to);
            //dcbData(key, type);

            loadDCBData();
        }

        function callreceipts(key, type, from, to) {
            //setdates(from, to);
            //receiptsData(key, type);
            loadReceiptsData();
        }

        function calltop10(key, type, from, to) {
            //setdates(from, to);
            //top10Data(key, type);
            loadTop10Data();
        }

        function callbottom10(key, type, from, to) {
            //setdates(from, to);
            //bottom10Data(key, type);
            loadBottom10Data();
        }

        function calldefaulters(key, type, from, to) {
            //setdates(from, to);
            //top100DefaultersData(key, type);
            loadDefaultersData();
        }

        function callCollectionRanking(key, type, from, to) {
            //setdates(from, to);
            //top100DefaultersData(key, type);
            loadCollectionRankingData();
        }

        function convertDateTimezone(input){
            if(input){
                var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
                var localISOTime = (new Date(input - tzoffset)).toISOString();
                return localISOTime;
            }else{
                return input;
            }

        }

        function isInitDistrict(){
          if(!$state.params.id && (!$state.params.type || $state.params.type==="DISTRICT") && !$state.params.fromDate && !$state.params.toDate && !vm.flag){
            return true;
          }
          else{
            return false;
          }
        }

        function formatTableData(tableData){
          var tablesList = angular.copy(tableData);
          var tables = tablesList["records"];
          angular.forEach(tables,function(table){
            var headersList  = [];
            var firstCol = [];
            var secondCol = [];
            var sortIndex = 0;
            var dataTypes = [];
            angular.forEach(table.headers,function(header){
              if(!header.span){
                header["sortIndex"] = sortIndex;
                header["rows"] = 2;
                header["cols"] = 1;
                firstCol.push(header);
                dataTypes.push(header.dataType);
                sortIndex++;
              }else if (header.span) {
                if(header.topHeader){
                  header.topHeader["rows"] = 1;
                  header.topHeader["cols"] = header.colspan;
                  firstCol.push(header.topHeader);
                }
                header["sortIndex"] = sortIndex;
                header["rows"] = 1;
                header["cols"] = 1;
                secondCol.push(header);
                dataTypes.push(header.dataType);
                sortIndex++;
              }
            });
            headersList.push(firstCol);
            headersList.push(secondCol);
            table.headers = headersList;
            table["dataTypes"] = dataTypes;
          });
          return tablesList;
        }


        var districtOrderList = [];
        function loadCollectionsData() {

            if(vm.collection!=undefined)
              vm.collection.options =null;
              var query = {
                  locKey: $state.params.id || null,
                  locationType : $state.params.type || null,
                  currencyUnit : vm.conversionType
              };
              if ($state.params.fromDate) {
                  query.fromDate = convertDateTimezone($state.params.fromDate);
              }
              if ($state.params.toDate) {
                  query.toDate =  convertDateTimezone($state.params.toDate);
              }
            if(isInitDistrict()==true && RevenueServices.getstate("collection")){
              collectionsSuccess(RevenueServices.getstate("collection"));
              return;
            }

            vm.tabs[0].loadingData = true;

            RevenueServices.getCollections().query(query).$promise.then(collectionsSuccess, anyCallFail);
            //, collectionsSuccess, anyCallFail);
            function collectionsSuccess(data) {
                console.log('Collection success!');
                var collection ={};
                collection.id = "coll_line";
                collection.TrendData = {
                    formattedFromDate: $filter('date')(data.trendData.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.trendData.toDate, "dd-MMM-yyyy"),
                    monthArray: ['Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
                    chartData: data.trendData.chartData
                };
                collection.TotalSummary = {
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy"),
                    totalSummary: data.totalSummary
                };
                collection.TableData = {
                    records: data.revenueRecords,
                    locType: data.locationType,
                    formattedFromDate: data.fromDate,
                    formattedToDate: data.toDate
                };

                collection.options = {
                    xAxisArray: ['Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
                    seriesData: data.trendData.chartData,
                    modifyYear:true
                };
                collection.key = query.locKey;
                collection.type = query.locationType;

                if($state.params.type === "ALL_ULB" || $state.params.type === "ALL_WARD"){
                  collection.TableData.records[0].limit =50;
                  collection.TableData.records[0].infiniteScroll = true;
                }



                if(isInitDistrict()==true){
                  RevenueServices.setstate(data,"collection");
                }
                collection.TableData = formatTableData(collection.TableData);
                vm.collection = collection;
                //after first collection call all other dashboards calls are made in background
                //only called when the page reloads
                if(vm.firstcall===true){
                     vm.propertyType = "Private";
                    //  callDCB();
                    //  callreceipts();
                    //  calltop10();
                    //  callbottom10();
                    //  calldefaulters();
                     vm.firstcall = false;
                   };
                   vm.tabs[0].loadingData = false;
            }



        }

        function loadDCBData() {
            console.log('Loading DCB content');



            if(vm.dcb!=undefined)
              vm.dcb.options =null;
              var query = {
                  locKey: $state.params.id || null,
                  locationType : $state.params.type || null,
                  currencyUnit : vm.conversionType,
                  penaltyType: vm.dcbpenaltyType
              };
              if ($state.params.fromDate) {
                  query.fromDate = convertDateTimezone($state.params.fromDate);
              }
              if ($state.params.toDate) {
                  query.toDate =  convertDateTimezone($state.params.toDate);
              }
              if(vm.propertyType){
                query.propertyType = vm.propertyType;
              }
            // if(isInitDistrict()==true && RevenueServices.getstate("DCB") && !vm.propertyType){
            //   DCBSuccess(RevenueServices.getstate("DCB"));
            //   console.log("caaa")
            //   return;
            // }
            vm.tabs[1].loadingData = true;

            RevenueServices.getDCB().query(query).$promise.then(DCBSuccess, anyCallFail);
            //, collectionsSuccess, anyCallFail);
            function DCBSuccess(data) {
                console.log('DCB success!');
                var dcb ={};
                dcb.id="dcb_line";
                dcb.TrendData = {
                    formattedFromDate: $filter('date')(data.trendData.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.trendData.toDate, "dd-MMM-yyyy"),
                    monthArray: ['Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
                    chartData: data.trendData.chartData
                };
                dcb.TotalSummary ={
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy"),
                    totalSummary:data.totalSummary
                };
                dcb.TableData = {
                    records:data.revenueRecords,
                    locType:data.locationType,
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy")
                };
                dcb.options= {
                    xAxisArray: ['Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
                    seriesData: data.trendData.chartData,
                    modifyYear:true
                }
                dcb.key=  query.locKey;
                dcb.type = query.locationType;

                if($state.params.type === "ALL_ULB" || $state.params.type === "ALL_WARD"){
                  dcb.TableData.records[0].limit =50;
                  dcb.TableData.records[0].infiniteScroll = true;
                }
                dcb.TableData = formatTableData(dcb.TableData);
                vm.dcb = dcb;
                vm.tabs[1].loadingData = false;
                if(isInitDistrict()==true && !vm.propertyType){
                  RevenueServices.setstate(data,"DCB");
                }
            }

        }

        function loadReceiptsData() {
            console.log('Loading Receipts content');
            if(vm.receipts!=undefined)
              vm.receipts.options = null;
              vm.tabs[2].loadingData = true;
              var query = {
                  locKey: $state.params.id || null,
                  locationType : $state.params.type || null,
                  currencyUnit : vm.conversionType
              };
              if ($state.params.fromDate) {
                  query.fromDate = convertDateTimezone($state.params.fromDate);
              }
              if ($state.params.toDate) {
                  query.toDate =  convertDateTimezone($state.params.toDate);
              }
            if(isInitDistrict()==true && RevenueServices.getstate("Receipts")){
              ReceiptsSuccess(RevenueServices.getstate("Receipts"));
              return;
            }

            RevenueServices.getReceipts().query(query).$promise.then(ReceiptsSuccess, anyCallFail);
            //, collectionsSuccess, anyCallFail);
            function ReceiptsSuccess(data) {
                console.log('Receipts success!');
                var receipts={};
                receipts.id="receipts_line";
                receipts.TrendData = {
                    formattedFromDate: $filter('date')(data.trendData.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.trendData.toDate, "dd-MMM-yyyy"),
                    monthArray: ['Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
                    chartData: data.trendData.chartData
                };
                receipts.TotalSummary ={
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy"),
                    totalSummary:data.totalSummary
                };
                receipts.TableData = {
                    records:data.revenueRecords,
                    locType:data.locationType,
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy")
                };
                receipts.options= {
                    xAxisArray: ['Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
                    seriesData: data.trendData.chartData,
                    modifyYear:false
                };
                if($state.params.type === "ALL_ULB" || $state.params.type === "ALL_WARD"){
                  receipts.TableData.records[0].limit =50;
                  receipts.TableData.records[0].infiniteScroll = true;
                }
                receipts.key=  query.locKey;
                receipts.type = query.locationType;
                receipts.TableData = formatTableData(receipts.TableData);
                vm.receipts =receipts
                vm.tabs[2].loadingData = false;
                if(isInitDistrict()==true){
                  RevenueServices.setstate(data,"Receipts");
                }
            }

        }

        function loadTop10Data() {
            console.log('Loading Top 10 content');
            vm.tabs[3].loadingData = true;
            var query = {
                locKey: $state.params.id || null,
                locationType : $state.params.type || null,
                currencyUnit : vm.conversionType
            };
            if ($state.params.fromDate) {
                query.fromDate = convertDateTimezone($state.params.fromDate);
            }
            if ($state.params.toDate) {
                query.toDate =  convertDateTimezone($state.params.toDate);
            }
            if(isInitDistrict()==true && RevenueServices.getstate("Top10")){
              Top10Success(RevenueServices.getstate("Top10"));
              return;
            }

            RevenueServices.getTop10().query(query).$promise.then(Top10Success, anyCallFail);
            //, collectionsSuccess, anyCallFail);
            function Top10Success(data) {
                console.log('Top10 success!');
                var top10 ={};
                top10.TrendData = {};
                top10.TotalSummary ={};
                top10.TableData = {
                    records:data.revenueRecords,
                    locType:data.revenueRecords[0].locationType || "ULB",
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy"),
                };
                top10.options= {}
                top10.key=  query.locKey;
                top10.type = query.locationType;
                top10.TableData = formatTableData(top10.TableData);
                vm.top10 = top10;
                vm.tabs[3].loadingData = false;
                if(isInitDistrict()==true){
                  RevenueServices.setstate(data,"Top10");
                }

            }


        }

        function loadBottom10Data() {
            console.log('Loading Bottom10 content');
            vm.tabs[4].loadingData = true;
            var query = {
                locKey: $state.params.id || null,
                locationType : $state.params.type || null,
                currencyUnit : vm.conversionType
            };
            if ($state.params.fromDate) {
                query.fromDate = convertDateTimezone($state.params.fromDate);
            }
            if ($state.params.toDate) {
                query.toDate =  convertDateTimezone($state.params.toDate);
            }
            if(isInitDistrict()==true && RevenueServices.getstate("Bottom10")){
              Bottom10Success(RevenueServices.getstate("Bottom10"));
              return;
            }


            RevenueServices.getBottom10().query(query).$promise.then(Bottom10Success, anyCallFail);
            //, collectionsSuccess, anyCallFail);
            function Bottom10Success(data) {
                console.log('Bottom10 success!');
                var bottom10 ={};
                bottom10.TrendData = {};
                bottom10.TotalSummary ={};
                bottom10.TableData = {
                    records:data.revenueRecords,
                    locType:data.revenueRecords[0].locationType || "ULB",
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy")
                };
                bottom10.options= {}
                bottom10.key=  query.locKey;
                bottom10.type = query.locationType;
                bottom10.TableData = formatTableData(bottom10.TableData);
                vm.bottom10 =bottom10;
                vm.tabs[4].loadingData = false;
                if(isInitDistrict()==true){
                  RevenueServices.setstate(data,"Bottom10");
                }

            }

        }

        function loadDefaultersData() {
            console.log('Loading Defaulters content');
            vm.tabs[5].loadingData = true;
            var query = {
                locKey: $state.params.id || null,
                locationType : $state.params.type || null,
                currencyUnit : vm.conversionType
            };
            if ($state.params.fromDate) {
                query.fromDate = convertDateTimezone($state.params.fromDate);
            }
            if ($state.params.toDate) {
                query.toDate =  convertDateTimezone($state.params.toDate);
            }
            if(isInitDistrict()==true && RevenueServices.getstate("defaulters")){
              Top100DefaultersSuccess(RevenueServices.getstate("defaulters"));
              return;
            }


            RevenueServices.getTop100Defaulters().query(query).$promise.then(Top100DefaultersSuccess, anyCallFail);
            //, collectionsSuccess, anyCallFail);
            function Top100DefaultersSuccess(data) {
                console.log('Defaulters success!');
                var top100Defaulters ={};
                top100Defaulters.TrendData = {};
                top100Defaulters.TotalSummary ={};
                top100Defaulters.TableData = {
                    records:data.revenueRecords,
                    locType:data.locationType,
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy")
                };
                top100Defaulters.options= {}
                top100Defaulters.key=  query.locKey;
                top100Defaulters.type = query.locationType;
                top100Defaulters.TableData = formatTableData(top100Defaulters.TableData);
                vm.top100Defaulters =top100Defaulters;
                vm.tabs[5].loadingData = false;
                if(isInitDistrict()==true){
                  RevenueServices.setstate(data,"defaulters");
                }

            }

        }

        function loadCollectionRankingData() {
            console.log('Loading Collection Ranking Data');
            if($state.params.officertype){
              vm.officerType = $state.params.officertype;
            }
            if($state.params.officertype){
                vm.parentofficerType = $state.params.parentofficertype;
            }
            vm.tabs[6].loadingData = true;
            var query = {
                locKey: $state.params.id || null,
                locationType : $state.params.type || null,
                currencyUnit : vm.conversionType,
                officerType: vm.officerType,
                parentofficerType:vm.parentofficerType
            };
            if ($state.params.fromDate) {
                query.fromDate = convertDateTimezone($state.params.fromDate);
            }
            if ($state.params.toDate) {
                query.toDate =  convertDateTimezone($state.params.toDate);
            }
            // if(isInitDistrict()==true && RevenueServices.getstate("collectionRanking")){
            //   collectionRankingSuccess(RevenueServices.getstate("collectionRanking"));
            //   return;
            // }
            RevenueServices.getCollectionRankingData().query(query).$promise.then(collectionRankingSuccess, anyCallFail);
            //, collectionsSuccess, anyCallFail);
            function collectionRankingSuccess(data) {
                // console.log("data is ",data);
                console.log('Collection ranking success!');
                var collectionRankingData ={};
                collectionRankingData.TableData = {
                    records:data.revenueRecords,
                    locType:data.locationType,
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy")
                };
                collectionRankingData.options= {}
                collectionRankingData.key=  query.locKey;
                collectionRankingData.type = query.locationType;
                collectionRankingData.TableData = formatTableData(collectionRankingData.TableData);
                vm.collectionRankingData = collectionRankingData;
                vm.tabs[6].loadingData = false;
                // if(isInitDistrict()==true){
                //   RevenueServices.setstate(data,"collectionRanking");
                // }
            }
        }

        function anyCallFail(error) {
            vm.tabs[0].loadingData = false;
            vm.tabs[1].loadingData = false;
            vm.tabs[2].loadingData = false;
            vm.tabs[3].loadingData = false;
            vm.tabs[4].loadingData = false;
            vm.tabs[5].loadingData = false;
            AlertService.error(error.data.message);
        }


    }


})();

(function () {
    'use strict';
    angular.module('madApp')
        .filter('positive', function () {

            return function (input) {
                if (!input) {
                    return input;
                }
                return Math.abs(input);
            };
        })
        .filter('camelCase', function () {
            return function (input) {
                if (input) {
                    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
                }

            };

        })
        .filter('getLastYear', function () {
            return function (input) {
                if (input) {
                    var start = new Date(input);
                    var y = start.getFullYear();
                    return start.setFullYear(y - 1);
                }
            };
        })

});

angular
    .module('madApp')
    .directive('revenueTable', revenueTableDirective);

function revenueTableDirective() {
    var directive = {
        restrict: 'A',
        templateUrl: 'app/vl/dashboards/directives/table/revenue.table.html',
        scope: {
            details: "=details",
            totalSummary: "=totalSummary",
            callfunc:"&callfunc",
            type:"=ftype",
            key:"=fkey",
            throb:"=throb",
            show:"=show",
            ulbtype: "=ulbtype",
            officertype: "=officertype",
            parentofficertype: "=parentofficertype"
        },
        link: linkFunc,
        controller: 'RevenueTableDirectiveController'
    };

    return directive;

    function linkFunc(scope, element, attrs) {
        
      
    }
}

angular
    .module('madApp')
    .controller('RevenueTableDirectiveController', RevenueTableDirectiveController)
;

RevenueTableDirectiveController.$inject = ['$scope', '$state', '$stateParams', '$filter', 'ParseLinks', 'AlertService','RevenueServices'];
function RevenueTableDirectiveController($scope, $state, $stateParams, $filter, ParseLinks, AlertService,RevenueServices) {

    
    $scope.revenueOfficerOrInspector = false;
    if($state.current.name === "vl.dashboards.revenue.collections" || $state.current.name === "vl.dashboards.revenue.dcbprivate" ||
    $state.current.name === "vl.dashboards.revenue.dcbstate" || $state.current.name === "vl.dashboards.revenue.dcbcentral" ||
    $state.current.name === "vl.dashboards.revenue.dcbcourt" || $state.current.name === "vl.dashboards.revenue.dcbvacant" ||
    $state.current.name === "vl.dashboards.revenue.dcb" ||  $state.current.name === "vl.dashboards.revenue.top10"
    ||  $state.current.name === 'vl.dashboards.revenue.bottom10' ){
      $scope.revenueOfficerOrInspector = true;

    }


   var revnueWardTypes = ['ULB_WARD','ULB_BILL','ULB_REVENUE_INSPECTOR','ULB_REVENUE_OFFICER'];
   

   $scope.parentulbtype = 'ULB';
    if(revnueWardTypes.includes($scope.ulbtype)){
      $scope.parentulbtype = 'ULB_WARD';
    }else{
      $scope.parentulbtype = 'ULB';
    }
    $scope.checkULBWardType = function(){
      return $scope.parentulbtype === 'ULB_WARD';
    }
    $scope.checkSecretariatWardType = function(){
      return $scope.parentulbtype === 'ULB';
    }
  
    $scope.parseFloat = parseFloat;
    $scope.submit = function (key) {
         $state.go($state.current.name, {id: key,type:$scope.details.locType});
    };


    $scope.search = function(value){
      if(RevenueServices.getPropertyType() && $state.current.name==="vl.dashboards.revenue.top100defaulters"){
        if(value[1].value.indexOf(RevenueServices.getPropertyType())!= -1)
          return value;
      }else{
        return value;
      }
    }

    $scope.$watch("parentulbtype", function (newValue, oldValue) {
      if (newValue && newValue != oldValue) {
        if (newValue === "ULB") {
          $scope.ulbtype = "ULB";
        } else {
          $scope.ulbtype = "ULB_WARD";
        }
      }
    });

    $scope.send = function (type,key) {
        if(type && key){
            $state.go($state.current.name, {id: key,type:type});
        }
        else {
            $state.go($state.current.name,{id: null,type:null});
        }
    };

        $scope.setSortOrder = function(index,parentIndex){
          if(index!=undefined && index!=null){

            if($scope.details.records[parentIndex].infiniteScroll || $scope.details.records[parentIndex].modal){
              $scope.details.records[parentIndex].limit =50;
            }else{
              //$scope.showAll(parentIndex);
            }


            if($scope.details.records[parentIndex].sortIndex ===index){
                $scope.details.records[parentIndex].sortOrder = !$scope.details.records[parentIndex].sortOrder;
            }else{
                $scope.details.records[parentIndex].sortOrder = false;
            }
            $scope.details.records[parentIndex].sortIndex = index;
          }
        };

        $scope.compare = function (v1,v2) {
          if (isNaN(v1.value) === false || isNaN(v2.value) === false) {
            return (parseFloat(v1.value) > parseFloat(v2.value)) ? -1 : 1;
          }
          if(v1.value!=undefined && v2.value!=undefined){
            // return v1.value.localeCompare(v2.value);
            var ax = [], bx = [];
            var a = v1.value;
            var b = v2.value;
            a.replace(/(\d+)|(\D+)/g, function(_, $1, $2) { ax.push([$1 || Infinity, $2 || ""]) });
            b.replace(/(\d+)|(\D+)/g, function(_, $1, $2) { bx.push([$1 || Infinity, $2 || ""]) });

            while(ax.length && bx.length) {
                var an = ax.shift();
                var bn = bx.shift();
                var nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
                if(nn) return nn;
            }

            return ax.length - bx.length;
          }

        };

        $scope.$watch('officertype', function (newValue, oldValue) {
          if (newValue && newValue!=oldValue && $state.params.officertype!=undefined) {
              var stateParams = {};
              stateParams["id"] = $state.params.id;
              stateParams["officertype"] = $scope.officertype;
              stateParams["parentofficertype"] = $scope.parentofficertype;
              if ($state.params.fromDate) {
                stateParams["fromDate"] = $state.params.fromDate;
              }
              if ($state.params.toDate) {
                stateParams["toDate"] = $state.params.toDate;
              }
              $state.go($state.current.name, stateParams);
          }
        });

        $scope.$watch('parentofficertype', function (newValue, oldValue) {
         
          if (newValue && newValue != oldValue) {
              if(newValue == 'ward'){
                  $scope.officertype = 'revenueinspector';
              }else{
                  $scope.officertype = 'wardsecretary';
              }
              var stateParams = {};
              stateParams["id"] = $state.params.id;
              stateParams["officertype"] = $scope.officertype;
              stateParams["parentofficertype"] = $scope.parentofficertype;
              if ($state.params.fromDate) {
                stateParams["fromDate"] = $state.params.fromDate;
              }
              if ($state.params.toDate) {
                stateParams["toDate"] = $state.params.toDate;
              }
              $state.go($state.current.name, stateParams);  
          }
        });

        $scope.getColorClass = function(color,code){
          if(color==="color1" && code==1){
            return true;
          }else if(color==="color2" && code==2){
            return true;
          }else{
            return false;
          }
        }

        $scope.loadMore = function(tableIndex) {
          if($scope.details.records[tableIndex].infiniteScroll){
            if ($scope.details.records[tableIndex].limit + 50 < $scope.details.records[tableIndex].recordData.length) {
                $scope.details.records[tableIndex].limit += 50;
            } else {
                $scope.details.records[tableIndex].limit = $scope.details.records[tableIndex].recordData.length;
            }
          }
       };
}

(function () {
    'use strict';
    angular.module('madApp')
        .factory('dorStateSummariesService', dorStateSummariesService);

    dorStateSummariesService.$inject = ['$resource'];
    /**
     *
     * @param $resource
     * @returns {*}
     */
    function dorStateSummariesService($resource) {
        return {
            stateSummaries: stateSummaries()
        };
        function stateSummaries() {
            var resourceUrl = 'api/stateSummaries';

            return $resource(resourceUrl, {}, {
                'summary': {
                    method: 'GET', cache: true, isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }
    }
})();

angular
    .module('madApp')
    .directive('dorStateSummary', dorStateSummary);

//revenueSummaryDirective.$inject = [];

function dorStateSummary() {
    var directive = {
        restrict: 'A',
        templateUrl: 'app/vl/dashboards/directives/summary/state.summary.html',
        scope: {
            title: "@title",
            icon: "&icon",
            summary: "=summary",
            url: "@url"
        },
        link: linkFunc
    };

    return directive;

    function linkFunc(scope, element, attrs) {
        scope.icon = attrs.icon;
        scope.title = attrs.title;

        element.bind('click', function(event) {
          if(!scope.url) {
            event.preventDefault();
          }
        });
    }
}

angular
    .module('madApp')
    .directive('vlFilterForm', vlFilterForm);

vlFilterForm.$inject = ['$filter'];

function vlFilterForm($filter) {
    var directive = {
        restrict: 'A',
        templateUrl: 'app/vl/dashboards/directives/filterForm/filterForm.html',
        scope: {
            title: "@title",
            icon: "&icon",
            summary: "=summary",
            queryData: "=queryData",
            ulbList: "=ulbList",
            vlSubmit: "&",
            showDates: '=showDates',
            showProperty:"=showProperty",
            type:"=ftype",
            key:"=fkey",
            formHidden:"=formHidden",
            ulbtype: "=ulbtype",
            officertype: "=officertype"
        },
        link: linkFunc,
        controller: 'vlFilterFormController'
    };

    return directive;

    function linkFunc(scope, element, attrs) {
        scope.icon = attrs.icon;
        scope.title = attrs.title;
    }
}

angular
    .module('madApp')
    .controller('vlFilterFormController', vlFilterFormController)
;

vlFilterFormController.$inject = ['$scope', '$state', '$stateParams', '$filter', '$translate', '$translatePartialLoader', 'ParseLinks', 'AlertService','RevenueServices'];
function vlFilterFormController($scope, $state, $stateParams, $filter, $translate, $translatePartialLoader, ParseLinks, AlertService,RevenueServices) {
    $translatePartialLoader.addPart('vassar');
    $translate.refresh();
    /**
     * Mont constant, fixed to April of this year
     *
     * @type {Date}
     */
     $scope.revenueOfficerOrInspectorFilter = false;
     if($state.current.name === "vl.dashboards.revenue.collections" || $state.current.name === "vl.dashboards.revenue.dcbprivate" ||
     $state.current.name === "vl.dashboards.revenue.dcbstate" || $state.current.name === "vl.dashboards.revenue.dcbcentral" ||
     $state.current.name === "vl.dashboards.revenue.dcbcourt" || $state.current.name === "vl.dashboards.revenue.dcbvacant" ||
     $state.current.name === "vl.dashboards.revenue.dcb"  ||  $state.current.name === "vl.dashboards.revenue.top10"
     ||  $state.current.name === 'vl.dashboards.revenue.bottom10'){
       $scope.revenueOfficerOrInspectorFilter = true;
     }
  var minMonth = new Date();
  var current_year = minMonth.getFullYear()-1;
  if(minMonth.getMonth()<=3){
    current_year = current_year -1;
  }
  minMonth.setMonth(3); //TODO: Constant - make it configurable
  minMonth.setDate(1);
  minMonth.setFullYear(current_year);
    /**
     * Query data to be populated from the UI.
     * @type {{fromDate: null, toDate: null, gradeType: string, grade: null, selectedULB: null}}
     */
    $scope.queryData = {
        fromDate: null,
        toDate: null,
        gradeType: 'district',
        grade: null,
        selectedULB: null
    };

    $scope.formHidden = true;
    /**
     * toggle form
     */
    $scope.toggleForm = function () {
        $scope.formHidden = !$scope.formHidden;
    };
    // Date picker format
    $scope.format = 'shortDate';
    $scope.fromDate = {
        opened: false
    };

    $scope.toDate = {
        opened: false
    };
    /**
     * From date picker configuration
     * @type {{minDate: Date, maxDate: Date, datepickerMode: string, maxMode: string, minMode: string}}
     */
    $scope.fromDateOptions = {
        minDate: minMonth,
        maxDate: new Date(),
        datepickerMode: 'day',
        maxMode: 'day',
        minMode: 'day'
    };
    /**
     * To date picker configuration
     * @type {{minDate: Date, maxDate: Date, datepickerMode: string, maxMode: string, minMode: string}}
     */
    $scope.toDateOptions = {
        minDate: $scope.queryData.fromDate || minMonth,
        maxDate: new Date(),
        datepickerMode: 'day',
        maxMode: 'day',
        minMode: 'day'
    };
    /**
     * Open from-date date-picker popup.
     */
    $scope.fromDatePickerOpen = function () {
        $scope.fromDate.opened = true;
    };
    /**
     * Open the to-date date-picker popup.
     */
    $scope.toDatePickerOpen = function () {
        $scope.toDate.opened = true;
    };

    var revnueWardTypes = [
      "ULB_WARD",
      "ULB_BILL",
      "ULB_REVENUE_INSPECTOR",
      "ULB_REVENUE_OFFICER",
    ];

    $scope.parentulbtype = "ULB";


    $scope.checkULBWardType = function () {
      return $scope.parentulbtype === "ULB_WARD";
    };
    $scope.checkSecretariatWardType = function () {
      return $scope.parentulbtype === "ULB";
    };

    $scope.$watch("parentulbtype", function (newValue, oldValue) {
      if (newValue && newValue != oldValue) {
        if (newValue === "ULB") {
          $scope.ulbtype = "ULB";
        } else {
          $scope.ulbtype = "ULB_WARD";
        }
      }
    });


    $scope.$watch('queryData.fromDate', function (newValue, oldValue) {
        if (newValue) {
            $scope.toDateOptions.minDate = newValue;
            $scope.queryData.toDate = null;
        }
    });

  $scope.$watch('queryData.gradeType', function (newValue, oldValue) {
    if (newValue) {
      $scope.queryData.grade = null;
      $scope.queryData.selectedULB = null;
    }
  });
  $scope.$watch('queryData.grade', function (newValue, oldValue) {
    if (newValue) {
      $scope.queryData.selectedULB = null;
    }
  });

  $scope.$watch('ulbtype', function (newValue, oldValue) {
    if (newValue && newValue!=oldValue && $state.params.type!=undefined) {

      if (revnueWardTypes.includes($scope.ulbtype)) {
        $scope.parentulbtype = "ULB_WARD";
      } else {
        $scope.parentulbtype = "ULB";
      }
      
      if($state.params.type==="ULB" || $state.params.type==="ULB_BILL" || $state.params.type==="ULB_REVENUE_OFFICER" 
      || $state.params.type==="ULB_REVENUE_INSPECTOR"  || $state.params.type === "ULB_WARD"  || $state.params.type === "ULB_SEC_WARD_SECRETARY" 
      || $state.params.type === "ULB_SEC_REVENUE_INSPECTOR" || $state.params.type === "ULB_SEC_REVENUE_OFFICER"){
        var stateParams = {};
        stateParams["id"] = $state.params.id;
        stateParams["type"] = $scope.ulbtype;
        if ($state.params.fromDate) {
          stateParams["fromDate"] = $state.params.fromDate;
        }
        if ($state.params.toDate) {
          stateParams["toDate"] = $state.params.toDate;
        }
        $state.go($state.current.name, stateParams);
      }
    }
  });

  /**
  * Get all ULB for based on selected Grade and Grade-Type
  * @returns {*}
  */
  $scope.getULBForGrade = function () {
    var searchFilter = {};
    searchFilter[$scope.queryData.gradeType] = $scope.queryData.grade;
    return $filter('filter')($scope.ulbList, searchFilter);

  };
  /**
  * Get labels for null option, sets a new value based on the gradeType selected
  * @returns {*}
  */
  $scope.getDefaultGradeTypeLabel = function () {
    if ('district' === $scope.queryData.gradeType) return $filter('translate')('vassar.directives.revenue.detail.option.label.All Districts');
    if ('region' === $scope.queryData.gradeType) return $filter('translate')('vassar.directives.revenue.detail.option.label.All Regions');
    if ('grade' === $scope.queryData.gradeType) return $filter('translate')('vassar.directives.revenue.detail.option.label.All ULB Types');
  };

  /**
  * Process request
  */

  $scope.vlSubmit = function () {
    $scope.propertyType = null;
    if($scope.queryData.selectedULB){
      $state.go($state.current.name, {id: $scope.queryData.selectedULB,type:"ULB",
      fromDate:$scope.queryData.fromDate,
      toDate:$scope.queryData.toDate});
    }
    else {
      $state.go($state.current.name, {
        id: $scope.queryData.grade, type: $scope.queryData.gradeType.toUpperCase(),
        fromDate: $scope.queryData.fromDate,
        toDate: $scope.queryData.toDate},{
        });

      }
      $scope.formHidden = true;
    };

    $scope.send = function (type,key) {
      $scope.propertyType = null;
      if(type && key){
        $state.go($state.current.name, {id: key,type:type});
      }
      else {
        $state.go($state.current.name,{id: null,type:null});
      }
    };


    $scope.getULBGradeDesc = function (ulbGrade) {
      if(ulbGrade === "I") return "Grade I";
      else if(ulbGrade === "II") return "Grade II";
      else if(ulbGrade === "III") return "Grade III";
      else if(ulbGrade === "NP") return "Nagar Panchayat";
      else if(ulbGrade === "Special") return "Special Grade";
      else if(ulbGrade === "Corp") return "Corporation";
      else return ulbGrade;
    };

    $scope.$watch("propertyType",function(newValue,oldValue){
      if (newValue!=oldValue){
        RevenueServices.setPropertyType(newValue);
      }
    });

    $scope.checkTopLevel = function (){
      if($scope.queryData.gradeType === "all_ulb" || $scope.queryData.gradeType === "all_ward" ||  $scope.queryData.gradeType === "all_sec_ward" ){
        return false;
      }
      return true;
    }

    $scope.showAll = function (){
      if($state.current.name.indexOf('dcb')!= -1 || $state.current.name.indexOf('collections')!= -1
      || $state.current.name.indexOf('receipts')!= -1){
        return true;
      }
      return false;
    }
}

angular
    .module('madApp')
    .directive('consolidatedSummary', consolidatedSummaryDirective);

function consolidatedSummaryDirective() {
    var directive = {
        restrict: 'A',
        templateUrl: 'app/vl/dashboards/directives/consolidated/consolidated.summary.html',
        scope: {
            totalSummary: "=totalSummary",
            throb:"=throb",
            currencyUnits: "=currencyUnits"
        },
        link: linkFunc,
    };

    return directive;

    function linkFunc(scope, element, attrs) {
        scope.parseFloat = parseFloat;
    }
}

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$urlRouterProvider'];

    function stateConfig($stateProvider,$urlRouterProvider) {
        $stateProvider.state('vl.dashboards', {
            abstract: true,
            parent: 'vl',
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('vassar');
                    return $translate.refresh();
                }]
            }
        });
        var today = new Date();

        // if(today.getHours()<= 9 || today.getHours() >=14){
        //     $urlRouterProvider.when('/','/revenue');
        // }
        // else{
        //   $urlRouterProvider.when('/','/blocked');
        // }
        $urlRouterProvider.when('/','/revenue');
        $urlRouterProvider.when('/cdma','/revenue');
        $urlRouterProvider.when('/cdma/','/revenue');

    }
})();
/**
 *
 * @version v0.1.0


/* commonjs package manager support (eg componentjs) */
if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
  module.exports = 'vljslib';
}

(function (window, angular, undefined) {
'use strict';

  /**
   *@ngdoc object
   *@name vljslib
   *@description
   *
   *This is the module vjslib for drawing chart components
  **/
  angular
      .module('vljslib',[])


  angular
      .module('vljslib')
      .constant('vljslibConstants', {
                  title : '',
                  legendTitle : '',
                  valueTitle : '',
                  unitm : '',
                  units : ''
      });

angular.module('vljslib').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('vljslib/asterTmpl',
    "<section class=\"panel\"><header class=\"panel-heading no-b h4 no-m\"><strong>{{title}}</strong></header><div class=\"panel-body\" id=\"panel-body-2\"><vl-chart-data-error image=\"{{nodataimage}}\" ng-show=\"showError\"></vl-chart-data-error><div style=\"height: 400px;overflow:visible\"><div class=\"three-quarters-loader\" ng-show=\"{{showThrobber}}\"></div><div id=\"{{id}}aster\" style=\"height: 95%;width:44%; margin:0 auto;position:relative;padding-top:40px;overflow:visible\"></div><div class=\"center-block\" style=\"float:none;margin:0 auto;padding-left:20%\" ng-hide=\"dataError\"><div ng-repeat=\"(key,value) in  AsterLegend track by $index\" style=\"display:inline\"><div class=\"legend-code\"><span style=\"background:{{value.color}}\" class=\"color-block\"></span><p style=\"text-transform:Capitalize\">{{value.name}}</p></div></div></div></div></div></section>"
  );


  $templateCache.put('vljslib/candleStickchartTmpl',
    "<section class=\"panel\"><header class=\"panel-heading no-b h4 no-m\"><strong>{{title}}</strong></header><div class=\"panel-body\"><!-- TODO: edit image for no data set it to candleStickNoData.png   --><vl-chart-data-error image=\"{{nodataimage}}\" ng-show=\"showError\"></vl-chart-data-error><div><div class=\"three-quarters-loader\" ng-show=\"{{showThrobber}}\"></div><span><div id=\"{{id}}cdl\" style=\"height: 400px; margin: 0 auto\"></div></span></div></div></section>"
  );


  $templateCache.put('vljslib/dualAxischartTmpl',
    "<section class=\"panel\"><header class=\"panel-heading h4 no-b no-m pl0 grid-block\"><strong>{{title}}</strong></header><div class=\"panel-body\"><vl-chart-data-error image=\"{{nodataimage}}\" ng-show=\"showError\"></vl-chart-data-error><div class=\"three-quarters-loader\" ng-show=\"{{showThrobber}}\"></div><div id=\"{{id}}dax\" style=\"min-width: 310px; height: 400px; margin: 0 auto\"></div></div></section>"
  );


  $templateCache.put('vljslib/gaugeTmpl',
    "<!-- Missing Throbber --><section class=\"panel\"><header class=\"panel-heading no-b h4 no-m\"><strong>{{title}}</strong></header><div class=\"panel-body\"><!-- TODO: edit image for no data set it to gaugeNoData.png   --><vl-chart-data-error image=\"{{nodataimage}}\" ng-show=\"showError\"></vl-chart-data-error><div style=\"height: 400px; margin: 0 auto\"><div class=\"three-quarters-loader\" ng-show=\"{{showThrobber}}\"></div><span><div id=\"{{id}}gauge\" style=\"position: relative; margin: auto;vertical-align:middle;top:30px\"></div></span></div></div></section>"
  );


  $templateCache.put('vljslib/innerStackbarchartTmpl',
    "<section class=\"panel\"><header class=\"panel-heading no-b h4 no-m\"><strong>{{title}}</strong></header><div class=\"panel-body\" id=\"panel-body-1\"><vl-chart-data-error image=\"{{nodataimage}}\" ng-show=\"showError\"></vl-chart-data-error><div class=\"three-quarters-loader\" ng-show=\"{{showThrobber}}\"></div><div id=\"{{id}}ibr\" style=\"min-width: 310px; height: 400px; margin: 0 auto\"></div></div></section>"
  );


  $templateCache.put('vljslib/linechartTmpl',
    "<section class=\"panel\"><header class=\"panel-heading h4 no-b no-m pl0 grid-block\"><strong class=\"no-m\">{{::title}}</strong></header><vl-chart-data-error image=\"{{nodataimage}}\" ng-show=\"showError\"></vl-chart-data-error><div id=\"{{id}}line\" style=\"width:auto;height: 400px; margin: 0 auto\"></div><div class=\"three-quarters-loader\" ng-show=\"{{showThrobber}}\"></div></section>"
  );


  $templateCache.put('vljslib/multiAxischartTmpl',
    "<section class=\"panel\"><header class=\"panel-heading h4 no-b no-m pl0 grid-block\"><strong class=\"no-m\">{{title}}</strong></header><vl-chart-data-error image=\"{{nodataimage}}\" ng-show=\"showError\"></vl-chart-data-error><div class=\"three-quarters-loader\" ng-show=\"{{showThrobber}}\"></div><div id=\"{{id}}max\" style=\"min-width: 310px; height: 400px; margin: 0 auto\"></div></section>"
  );


  $templateCache.put('vljslib/piechartTmpl',
    "<section class=\"panel\"><header class=\"panel-heading no-b h4 no-m\" style=\"height:50px\"><strong>{{::title}}</strong></header><div class=\"panel-body pt0\"><vl-chart-data-error image=\"{{nodataimage}}\" ng-show=\"showError\"></vl-chart-data-error><div id=\"{{id}}pie\" style=\"min-width: 310px; height: 400px;  margin: 0 auto\"></div><div class=\"three-quarters-loader\" ng-show=\"{{showThrobber}}\"></div></div></section>"
  );


  $templateCache.put('vljslib/stackBarchartTmpl',
    "<section class=\"panel\"><header class=\"panel-heading no-b h4 no-m\" style=\"height:50px\"><strong>{{::title}}</strong></header><div class=\"panel-body pt0\"><vl-chart-data-error image=\"{{nodataimage}}\" ng-show=\"showError\"></vl-chart-data-error><div id=\"{{id}}bar\" style=\"min-width: 310px; height: 400px; margin: 0 auto\"></div><div class=\"three-quarters-loader\" ng-show=\"{{showThrobber}}\"></div></div></section>"
  );

}]);


angular
.module('vljslib')
.directive('vlAster',vlAster)

vlAster.$inject = ['$timeout','aster','$compile','$document','$templateCache','vljslibConstants'];

/**
* @ngdoc directive
* @name vljslib.directive:vlAster
* @description
*
* The Data fomat this directive requires is
*<pre>
* $scope.data = {
*     title : '',
*     valuetitle : '',
*     data : [{
*       name : '',
*       id : '',
*       weight : '',
*       score : '',
*       color: '',
*       order : '',
*       width : ''
*     },{
*       .....
*     }]
* }
*</pre>
*
*## Usage

* <pre>
* <vl-aster data="data" throbber="boolean_var" id="gw_aster"></vl-aster>
* </pre>
* @restrict E
* @module vljslib
* # component
* @example
<example module="exampleApp">
<file name="index.html">
<div ng-controller="ExampleController">
<p>window.document title: <b ng-bind="title"></b></p>
<vl-aster data="asData" throbber="gwtrend_chart" id="gw_aster"></vl-aster>


</file>

<file name="script.js">
angular.module('exampleApp', ['vljslib'])
.controller('ExampleController', ['$scope','$timeout','aster', function($scope,$timeout,aster) {

$scope.title = "AmCharts Aster Chart"
$scope.gwtrend_chart = true;

var  _data = JSON.parse('{"title":"Aster ","valueTitle":"currentStorage","data":[{"name":"Dowleswaram Barrage","label":"Dowleswaram Barrage","id":214,"weight":0.014917481,"score":12.36,"color":"#A52A2A","order":0,"width":0.014917481},{"name":"Polavaram Project","label":"Polavaram Project","id":215,"weight":0.21823426,"score":92.15,"color":"#FF0000","order":1,"width":0.21823426},{"name":"Nagarjuna Sagar Dam","label":"Nagarjuna Sagar Dam","id":217,"weight":0.5190034,"score":51.9,"color":"#1F77B4","order":2,"width":0.5190034},{"name":"Prakasam Barrage","label":"Prakasam Barrage","id":218,"weight":0.054830957,"score":16.66,"color":"#A52A2A","order":3,"width":0.054830957},{"name":"Srisailam Dam","label":"Srisailam Dam","id":219,"weight":0.50613683,"score":73.18,"color":"#1F77B4","order":4,"width":0.50613683},{"name":"Kandaleru Dam","label":"Kandaleru Dam","id":220,"weight":0.3447204,"score":91.75,"color":"#FF0000","order":5,"width":0.3447204},{"name":"Sunkesula","label":"Sunkesula","id":222,"weight":0.025460664,"score":46.87,"color":"#1F77B4","order":6,"width":0.025460664},{"name":"Mylavaram Dam","label":"Mylavaram Dam","id":224,"weight":0.037670244,"score":13.02,"color":"#A52A2A","order":7,"width":0.037670244},{"name":"PABR Dam","label":"PABR Dam","id":225,"weight":0.14683545,"score":67.35,"color":"#1F77B4","order":8,"width":0.14683545},{"name":"MPR Dam","label":"MPR Dam","id":226,"weight":0.13486621,"score":91.55,"color":"#FF0000","order":9,"width":0.13486621},{"name":"Yeleru Reservoir","label":"Yeleru Reservoir","id":228,"weight":0.027095016,"score":35.08,"color":"#1F77B4","order":10,"width":0.027095016},{"name":"Lower Sileru Dam","label":"Lower Sileru Dam","id":230,"weight":0.29258132,"score":90.52,"color":"#FF0000","order":11,"width":0.29258132},{"name":"Donkarayi Dam","label":"Donkarayi Dam","id":231,"weight":0.15942958,"score":38.35,"color":"#1F77B4","order":12,"width":0.15942958}]}');
$scope.asData = {};
//  $scope.asData = _data;

$timeout(function() {
$scope.asData = _data;
$scope.asData.legendData = JSON.parse('{"flood":{"min":0,"max":0,"color":"#FF0000","name":"Flood"},"normal":{"min":0,"max":0,"color":"#1F77B4","name":"Normal"},"dead":{"min":0,"max":0,"color":"#A52A2A","name":"Dead Storage"}}');
$scope.gwtrend_chart = false;
}, 4000);

$timeout(function() {
$scope.asData = _data;
$scope.asData.legendData = JSON.parse('{"flood":{"min":1,"max":0,"color":"#FF0000","name":"Flood"},"normal":{"min":0,"max":0,"color":"#1F77B4","name":"Normal"},"dead":{"min":0,"max":0,"color":"#A52A2A","name":"Dead Storage"}}');
$scope.gwtrend_chart = false;
}, 9000);



}]);
</file>
</example>
*
* Directive to draw highCharts components
*/
function vlAster($timeout,aster,$compile,$document,$templateCache,vljslibConstants){

    var directive = {
        restrict: 'EA',
        tarnsclude: true,
        template: $templateCache.get('vljslib/asterTmpl'),
        scope: {
            id: '@',
            class: '@',
            data: '=',
            value: '=',
            showThrobber: '=throbber',
            options: '=',
            nodataimage: '@',
        },
        controller:['$scope',function($scope){
            $scope.nodataimage = angular.isDefined($scope.nodataimage) ? $scope.nodataimage : "img/NoDataImages/DefaultImages/asterChartNoData.png";
        }],
        link: linkFunc,

    };

    return directive;

    function linkFunc(scope, el, attr, ctrl) {

        var unregisterDataWatch;
        var unregisterThrobberWatch;
        var id = scope.id;


        $timeout(function () {

            unregisterThrobberWatch = scope.$watch('showThrobber', function (newVal,oldval) {
                $compile(el.contents())(scope.$new());
            })

            unregisterDataWatch = scope.$watch('data', function (dataValue) {
                scope.dataError = false;
                aster.destroy();
                //this thing is fastest
                if(dataValue == undefined || dataValue==null || Object.keys(dataValue).length === 0){
                    scope.dataError = true;
                } else {
                    /**
                     * This is very important because the d3 component is copy/pasted and it will be not redrawn on data
                     * change instead it will add another svg element
                     **/
                    if(d3.select('#'+scope.id+'aster')[0][0].childElementCount > 0){
                        d3.select('#'+scope.id+'aster')[0][0].innerHTML = "";
                    }

                    drawComponent(scope,dataValue);
                }
                scope.showError = !scope.showThrobber && scope.dataError;
            })
        })

        function toggleSideBarHandler(){
            aster.reflow();
        }

        /** This is related to toggle event reflow **/
        $document.on("click", ".toggle-sidebar", toggleSideBarHandler);

        scope.$on('$destroy',function(){

          console.log("vljslib:: AsterChart : $destroy called started deregistering the events");

          $document.off('click',toggleSideBarHandler);

          aster.destroy();

          if(unregisterDataWatch){
            unregisterDataWatch();
            unregisterDataWatch = null;
          }

          if(unregisterThrobberWatch){
            unregisterThrobberWatch();
            unregisterThrobberWatch = null;
          }
      })

    }

    function drawComponent(scope,data){

        var _data = data.data;
        if(_data!=null && Object.keys(_data).length !== 0) {
            scope.title = (_data.title == undefined || _data.title == null) ? vljslibConstants.title : _data.title ;
            scope.valueTitle = (_data.valueTitle == undefined || _data.valueTitle == null) ?  vljslibConstants.valueTitle : _data.valueTitle;
            scope.AsterLegend = (scope.data.legendData == undefined || scope.data.legendData == null) ? vljslibConstants.legendTitle : scope.data.legendData;

            if(_data.data !=null && Object.keys(_data.data).length !== 0) {
                aster.drawAsterchart(scope.id+'aster',_data,scope.valueTitle);
            }
            else scope.dataError = true;
        }
        else scope.dataError = true;
    }
}

/**
 * @ngdoc service
 * @name vljslib.aster
 * @description
 * # component
 * Service to draw highCharts Aster Chart components
 */
angular.module('vljslib')
    .factory('aster', aster)


function aster() {
    //define variables

    var service = {
        drawAsterchart: drawAsterchart,
        asterDataFilter: asterDataFilter,
        reflow: reflow,
        destroy : destroy
    };

    return service;

     /**
      * @ngdoc function
      * @name vljslib.aster#drawAsterchart
      * @module vljslib
      * @kind function
      * @methodOf vljslib.aster
      *
      * @description
      * Method to draw highCharts aster component
      *#The Data format is
      *<pre>
      * var data = {
      *     title : '',
      *     valuetitle : '',
      *     data : [{
      *       name : '',
      *       id : '',
      *       weight : '',
      *       score : '',
      *       color: '',
      *       order : '',
      *       width : ''
      *     },{
      *       .....
      *     }]
      * }
      *</pre>
      *
      *
      * @example
        <example module="exampleApp">
          <file name="index.html">
            <div ng-controller="ExampleController">
            <p>window.document title: <b ng-bind="title"></b></p>
             <div id="asterchart" style="min-width: 310px; height: 400px; margin: 0 auto"></div>


          </file>
        <file name="script.js">
          angular.module('exampleApp', ['vljslib'])
            .controller('ExampleController', ['$scope','aster', function($scope,aster) {

              $scope.title = "HighCharts Aster Chart"

              var  data = JSON.parse('{"title":"Aster ","valueTitle":"currentStorage","data":[{"name":"Dowleswaram Barrage","label":"Dowleswaram Barrage","id":214,"weight":0.014917481,"score":12.36,"color":"#A52A2A","order":0,"width":0.014917481},{"name":"Polavaram Project","label":"Polavaram Project","id":215,"weight":0.21823426,"score":92.15,"color":"#FF0000","order":1,"width":0.21823426},{"name":"Nagarjuna Sagar Dam","label":"Nagarjuna Sagar Dam","id":217,"weight":0.5190034,"score":51.9,"color":"#1F77B4","order":2,"width":0.5190034},{"name":"Prakasam Barrage","label":"Prakasam Barrage","id":218,"weight":0.054830957,"score":16.66,"color":"#A52A2A","order":3,"width":0.054830957},{"name":"Srisailam Dam","label":"Srisailam Dam","id":219,"weight":0.50613683,"score":73.18,"color":"#1F77B4","order":4,"width":0.50613683},{"name":"Kandaleru Dam","label":"Kandaleru Dam","id":220,"weight":0.3447204,"score":91.75,"color":"#FF0000","order":5,"width":0.3447204},{"name":"Sunkesula","label":"Sunkesula","id":222,"weight":0.025460664,"score":46.87,"color":"#1F77B4","order":6,"width":0.025460664},{"name":"Mylavaram Dam","label":"Mylavaram Dam","id":224,"weight":0.037670244,"score":13.02,"color":"#A52A2A","order":7,"width":0.037670244},{"name":"PABR Dam","label":"PABR Dam","id":225,"weight":0.14683545,"score":67.35,"color":"#1F77B4","order":8,"width":0.14683545},{"name":"MPR Dam","label":"MPR Dam","id":226,"weight":0.13486621,"score":91.55,"color":"#FF0000","order":9,"width":0.13486621},{"name":"Yeleru Reservoir","label":"Yeleru Reservoir","id":228,"weight":0.027095016,"score":35.08,"color":"#1F77B4","order":10,"width":0.027095016},{"name":"Lower Sileru Dam","label":"Lower Sileru Dam","id":230,"weight":0.29258132,"score":90.52,"color":"#FF0000","order":11,"width":0.29258132},{"name":"Donkarayi Dam","label":"Donkarayi Dam","id":231,"weight":0.15942958,"score":38.35,"color":"#1F77B4","order":12,"width":0.15942958}]}');
              aster.drawAsterchart('asterchart',data,'Meters');
          }]);
        </file>
      </example>
      *
      * @param {String} elementId String id passed from div in html
      * @param {Object} data Object as specified above
      */

     function drawAsterchart(elementId, _data) {
         var svg = {};
         var elId = "#"+elementId;
         var width = angular.element(elId).width(),
             height = angular.element(elId).height(),
             radius = Math.min(width, height) / 2,
             innerRadius = 0.2 * radius;
         var color = d3.scale.category20c();
         var pie = d3.layout.pie()
             .sort(null)
             .value(function(d) {
             return d.width;
         });

         var tip = d3.tip()
             .attr('class', 'd3-tip')
             .offset([0, 0])
             .html(function(d) {
             return "<span style='font-weight:bold'></span>" + d.data.label + "<br><span>"+_data.value2Title+"</span> <span style='color:orangered;font-weight:bold'> :" + d.data.capacity + " TMC</span>"+ "<br><span>"+_data.valueTitle+"</span> <span style='color:orangered;font-weight:bold'> :" + d.data.score + " %</span>";
         });

         var arc = d3.svg.arc()
             .innerRadius(innerRadius)
             .outerRadius(function(d) {
             return (radius - innerRadius) * (d.data.score / 100.0) + innerRadius;
         });

         var outlineArc = d3.svg.arc()
             .innerRadius(function(d) {
             return (radius - innerRadius) * (d.data.score / 100.0) + innerRadius;
         })
             .outerRadius(radius);

          svg = d3.select(elId).append("svg:svg")
             .attr("style", 'height:90%;display:block;margin:auto;width:100%;overflow:visible')
             .attr('viewBox', '0 0 ' + Math.min(width, height) + ' ' + Math.min(width, height))
             .attr('preserveAspectRatio', 'xMinYMin')
             .append("svg:g")
             .attr("transform", "translate(" + Math.min(width, height) / 2 + "," + Math.min(width, height) / 2 + ")");

         svg.call(tip);

         var labelr = radius + 8;

         var dataSource = _data.data;
         var data = dataSource;
         data.sort(function(a,b) {
             return a.order-b.order;
         });
         data.forEach(function(d) {
             //d.id = d.id;
             d.order = +d.order;
             d.color = d.color;
             d.weight = +d.weight;
             d.score = +d.score;
             d.width = +d.weight;
             d.label = d.name;
         });

         data = data.sort(function(a,b){
             return b.capacity-a.capacity;
         });

         var topTen = data.slice(0,10);
         var restData = data.slice(10,data.length);
         var finalData = [];
         var scale = Math.floor(restData.length/10);
         var count = 0;
         var highcount = 0;
         var highcountStart = 0;
         var highcountEnd = topTen.length-1;
         var highCountFlag = true;

         /*
         topTen[] - It has the top 10 elements if it exists.
         finalData[] - It is the aggregate of all the final data to be send.
         scale - floor((totalcount-10)/10);
         For the elements other than top 10 iterated the loop backwards.
         Insertion Procedure into finalData[]
         1)Inserted Least 5
         2)Largest element
         3)Second Least 5
         4)Last element from top 10
         5)Repeat these steps for remaining elements.
         */

         for (var i = restData.length-1; i >= 0; i--) {
             count++;
             if(count==scale) {
                 if(highcountStart<=highcountEnd){
                     if(highCountFlag===true) {
                         if(topTen[highcountStart]!=undefined)
                         finalData.push(topTen[highcountStart]);
                         highcountStart++;
                         count=0;
                         highCountFlag=false;
                     } else{
                         if(topTen[highcountEnd]!=undefined)
                         finalData.push(topTen[highcountEnd]);
                         highcountEnd--;
                         count=0;
                         highCountFlag=true;
                     }
                 }
             }
             if(restData[i]!=undefined)
             finalData.push(restData[i]);
         }
         data=finalData;
         dataSource=finalData;

         var designCapacity=[];
         for(var i in data) {
             designCapacity.push({id:data[i].id,capacity:data[i].capacity});
         }

         designCapacity.sort(function(a,b) {
             return b.capacity-a.capacity;
         });
         designCapacity = designCapacity.slice(0,10);
         //console.log(designCapacity);
         var maxIds={};
         for(var i in designCapacity) {
             maxIds[designCapacity[i].id]=designCapacity[i].capacity;
         }
         var path = svg.selectAll(".solidArc")
         .data(pie(dataSource))
         .enter().append("path")
         .attr("fill", function(d) {
             return d.data.color;
         })
         .attr("class", "solidArc")
         .attr("stroke", "white")
         .attr("isShadow", "true")
         .attr("stroke-opacity", "0.9")
         .attr("stroke-width", "0.1")
         .attr("d", arc)
         .on('mouseover', tip.show)
         .on('mouseout', tip.hide);

         var outerPath = svg.selectAll(".outlineArc")
         .data(pie(dataSource))
         .enter();


         outerPath.append("path")
         .attr("fill", "white")
         .attr("stroke", "rgb(201, 195, 195)")
         .attr("stroke-width", "0.7")
         .attr("class", "outlineArc")
         .attr("d", outlineArc)
         .on('mouseover', tip.show)
         .on('mouseout', tip.hide);

         outerPath.append("svg:text")
         .data(pie(dataSource))
         .attr("transform", function(d) {
             var c = arc.centroid(d),
             x = c[0],
             y = c[1],
             // pythagorean theorem for hypotenuse
             h = Math.sqrt(x * x + y * y);
             return "translate(" + (x / h * labelr) + ',' + (y / h * labelr) + ")";
         })
         .attr("dy", ".35em")
         .attr("dx", ".35em")
         .style("font-size","10px")
         .attr("text-anchor", function(d) {
             return (d.endAngle + d.startAngle) / 2 > Math.PI ? "end" : "start";
         }).style("text-overflow","ellipsis")
         .style("overflow","hidden")
         .text(function(d) {
             if(maxIds.hasOwnProperty(d.data.id)) {
                 if(d.data.label.length > 20) {
                     return d.data.label.substring(0,20)+'...';
                 }
                 else {
                     return d.data.label;
                 }
             }
         });

         var score = data.reduce(function(a, b) {
             return a + (b.score * b.weight);
         }, 0) / data.reduce(function(a, b) {
             return a + b.weight;
         }, 0);

         svg.append("svg:text")
             .attr("class", "aster-score")
             .attr("dy", ".35em")
             .attr("text-anchor", "middle") // text-align: right
         .text(Math.round(score));

     }

     function destroy(elId){
          if(angular.element("#" + elId)){
              angular.element("#" + elId).empty();
          }
     }

     function reflow(elementId) {
         var elId = '#' + elementId;
     }

     function asterDataFilter(data) {
       return data;
     }
 }


angular
.module('vljslib')
.directive('vlCandleStick',vlCandleStick)

vlCandleStick.$inject = ['$timeout','candleStick','$compile','$document','$templateCache','vljslibConstants'];

/**
* @ngdoc directive
* @name vljslib.directive:vlCandleStick
* @description
* The data format this directive requires is
*<pre>
*  $scope.data = {
*     title : '',
*     data : [{
*       name : 'first',
*       open : '10.00',
*       high : '11.00',
*       low : '12.00',
*       close : '13.00'
*     },{
*       .....
*     }]
* }
*</pre>
*
*##Usage
*<pre>
*<vl-candle-stick data="data" throbber="boolean_var" id="gw_candleStick"></vl-candle-stick>
*</pre>
*
* @restrict E
* @module vljslib
* # component
* @example
<example module="exampleApp">
<file name="index.html">
<div ng-controller="ExampleController">
<p>window.document title: <b ng-bind="title"></b></p>
<vl-candle-stick data="data" throbber="gwtrend_chart" id="gw_candleStick"></vl-candle-stick>


</file>

<file name="script.js">
angular.module('exampleApp', ['vljslib'])
.controller('ExampleController', ['$scope','$timeout','candleStick', function($scope,$timeout,candleStick) {

$scope.title = "AmCharts CandleStick Chart"
$scope.gwtrend_chart = true;

var data = JSON.parse('[{"name":"Dowleswaram Barrage","open":7,"high":7.42,"low":4.06,"close":6.42},{"name":"Polavaram Project","open":73.41,"high":73.79,"low":66.76,"close":69.7},{"name":"Nagarjuna Sagar Dam","open":149.06,"high":203.17,"low":143.05,"close":166.08},{"name":"Prakasam Barrage","open":14.38,"high":19.51,"low":9.93,"close":11.29},{"name":"Srisailam Dam","open":89.53,"high":206.22,"low":42.23,"close":103.43},{"name":"Kandaleru Dam","open":106.75,"high":112.38,"low":105.63,"close":106.21},{"name":"Sunkesula","open":6.14,"high":8.04,"low":6.14,"close":6.88},{"name":"Mylavaram Dam","open":9.22,"high":18.02,"low":9.22,"close":11.03},{"name":"PABR Dam","open":57.39,"high":57.58,"low":44.42,"close":48.99},{"name":"MPR Dam","open":44.52,"high":44.97,"low":36.94,"close":41.44},{"name":"Yeleru Reservoir","open":9.39,"high":9.59,"low":8.41,"close":8.91},{"name":"Lower Sileru Dam","open":88.81,"high":94.63,"low":84.95,"close":89.78},{"name":"Donkarayi Dam","open":48.43,"high":64.26,"low":47.28,"close":57.1}]');
$scope.data = data;
$timeout(function() {
$scope.gwtrend_chart = false;
}, 4000);


}]);
</file>
</example>
*
* Directive to draw highCharts components
*/
function vlCandleStick($timeout,candleStick,$compile,$document,$templateCache,vljslibConstants){

    var directive = {
        restrict: 'EA',
        template: $templateCache.get('vljslib/candleStickchartTmpl'),
        scope: {
            id: '@',
            class: '@',
            data: '=',
            value: '=',
            showThrobber: '=throbber',
            options: '=',
            nodataimage: '@',
        },
        controller:['$scope',function($scope){
            $scope.nodataimage = angular.isDefined($scope.nodataimage) ? $scope.nodataimage : "img/NoDataImages/DefaultImages/candleStickChartNoData.png";
        }],
        link: linkFunc,

    };

    return directive;

    function linkFunc(scope, el, attr, ctrl) {

        var unregisterDataWatch;
        var unregisterThrobberWatch;
        var id = scope.id;

        $timeout(function () {

            unregisterThrobberWatch = scope.$watch('showThrobber', function (newVal,oldval) {
                $compile(el.contents())(scope.$new());
            });

            unregisterDataWatch = scope.$watch('data', function (dataValue) {
                scope.dataError = false;
                if(angular.element("#"+id+'cdl')){
                    candleStick.destroy();
                }
                //this thing is fastest
                if(dataValue == undefined || dataValue==null || Object.keys(dataValue).length === 0){
                    scope.dataError = true;
                }  else {
                    //surely data will be there after ajax success
                    scope.dataError = false;
                    drawComponent(scope,dataValue)
                }
                 scope.showError = !scope.showThrobber && scope.dataError;
            });
        });

        function toggleSideBarHandler(){
            candleStick.reflow();
        }

        /** This is related to toggle event reflow **/
        $document.on("click", ".toggle-sidebar", toggleSideBarHandler);

        scope.$on('$destroy',function(){

          console.log("vljslib:: CandleStick : $destroy called started deregistering the events");

          $document.off('click',toggleSideBarHandler);

          if(angular.element("#"+id+'cdl')){
              candleStick.destroy();
          }

          if(unregisterDataWatch){
            unregisterDataWatch();
            unregisterDataWatch = null;
          }

          if(unregisterThrobberWatch){
            unregisterThrobberWatch();
            unregisterThrobberWatch = null;
          }
      })

    }

    function drawComponent(scope,data){

        var _data = data;
        if(_data!=null && Object.keys(_data).length !== 0){
            scope.title = (_data.title == undefined || _data.title == null) ? vljslibConstants.title : _data.title ;
            if(_data.data!=null && Object.keys(_data.data).length !== 0){
                candleStick.drawCandleStickchart(scope.id+'cdl',_data.data);
            }
            else scope.dataError = true;
        }
        else scope.dataError = true;
    }
}


  /**
    * @ngdoc service
    * @name vljslib.candleStick
    * @description
    * # component
    * Service to draw highCharts CandleStick Chart components
  */
  angular
      .module('vljslib')
      .factory('candleStick',candleStick)


  function candleStick(){
    //define variables

    var chart;

    var service = {
      drawCandleStickchart : drawCandleStickchart,
      candleStickDataFilter :   candleStickDataFilter,
      reflow: reflow,
      destroy : destroy
    };

    return service;


    /**
     * @ngdoc function
     * @name vljslib.candleStick#drawCandleStickchart
     * @module vljslib
     * @kind function
     * @methodOf vljslib.candleStick
     *
     * @description
     * Method to draw highCharts candleStick component
     * #The Data format is
     *<pre>
     *  var data = {
     *     title : '',
     *     data : [{
     *       name : 'first',
     *       open : '10.00',
     *       high : '11.00',
     *       low : '12.00',
     *       close : '13.00'
     *     },{
     *       .....
     *     }]
     * }
     *</pre>
     *
     * @example
       <example module="exampleApp">
         <file name="index.html">
           <div ng-controller="ExampleController">
           <p>window.document title: <b ng-bind="title"></b></p>
            <div id="candleStickchart" style="height: 400px"></div>


         </file>
       <file name="script.js">
         angular.module('exampleApp', ['vljslib'])
           .controller('ExampleController', ['$scope','candleStick', function($scope,candleStick) {

             $scope.title = "AmCharts CandleStick Chart"
             var data = JSON.parse('[{"name":"Dowleswaram Barrage","open":7,"high":7.42,"low":4.06,"close":6.42},{"name":"Polavaram Project","open":73.41,"high":73.79,"low":66.76,"close":69.7},{"name":"Nagarjuna Sagar Dam","open":149.06,"high":203.17,"low":143.05,"close":166.08},{"name":"Prakasam Barrage","open":14.38,"high":19.51,"low":9.93,"close":11.29},{"name":"Srisailam Dam","open":89.53,"high":206.22,"low":42.23,"close":103.43},{"name":"Kandaleru Dam","open":106.75,"high":112.38,"low":105.63,"close":106.21},{"name":"Sunkesula","open":6.14,"high":8.04,"low":6.14,"close":6.88},{"name":"Mylavaram Dam","open":9.22,"high":18.02,"low":9.22,"close":11.03},{"name":"PABR Dam","open":57.39,"high":57.58,"low":44.42,"close":48.99},{"name":"MPR Dam","open":44.52,"high":44.97,"low":36.94,"close":41.44},{"name":"Yeleru Reservoir","open":9.39,"high":9.59,"low":8.41,"close":8.91},{"name":"Lower Sileru Dam","open":88.81,"high":94.63,"low":84.95,"close":89.78},{"name":"Donkarayi Dam","open":48.43,"high":64.26,"low":47.28,"close":57.1}]');
             //var monthsdata = JSON.parse('["Aug-14","Sep-14","Oct-14","Nov-14","Dec-14","Jan-15","Feb-15","Mar-15","Apr-15","May-15","Jun-15","Jul-15","Aug-15"]')
             //var _data = candleStick.formatCandleStickData(data,monthsdata,'levelValue1');
             candleStick.drawCandleStickchart("candleStickchart",data);
         }]);
       </file>
     </example>
     *
     * @param {String} elementId String id passed from div in html
     * @param {Object} data Object as specified above
     */

    function drawCandleStickchart(elementId,data){

        if(angular.element("#"+elementId+'cdl')){
            destroy();
        }

      chart = AmCharts.makeChart(elementId, {
            "type": "serial",
            "theme": "light",
            "dataDateFormat": "YYYY-MM-DD",
            "valueAxes": [{
                "position": "left"
            }],
            "responsive": {
                "enabled": true
            },
            "graphs": [{
                "id": "g1",
                "balloonText": "Open:<b>[[open]]</b><br>Low:<b>[[low]]</b><br>High:<b>[[high]]</b><br>Close:<b>[[close]]</b><br>",
                "closeField": "close",
                "fillColors": "#1F77B4",
                "highField": "high",
                "lineColor": "#1F77B4",
                "lineAlpha": 1,
                "lowField": "low",
                "fillAlphas": 0.9,
                "negativeFillColors": "#ff0000",
                "negativeLineColor": "#ff0000",
                "openField": "open",
                "title": "Price:",
                "type": "candlestick",
                "valueField": "close"
            }],
            // "chartScrollbar": {
            //        "graph": "g1",
            //       "graphType": "line",
            //       "scrollbarHeight": 30
            // },
            "chartCursor": {
                "valueLineEnabled": true,
                "valueLineBalloonEnabled": true
            },
            "categoryField": "name",
            "categoryAxis": {
                "autoGridCount": true,
                "labelRotation": 45
            },
            "dataProvider": data,
            "export": {
                "enabled": false,
                "position": "bottom-right"
            },
            "autoresize": true,
        });



    }

    function reflow(elementId){
      if(chart !== undefined){
          chart.validateNow();
      }
    }

    function destroy(){
        if(chart){
            chart.clear();
            chart = null;
        }
    }

    function candleStickDataFilter(data,param){



    }
}


  angular
      .module('vljslib')
      .directive('vlDualAxis',vlDualAxis)

  vlDualAxis.$inject = ['$timeout','dualAxis','$compile','$document','$templateCache','vljslibConstants'];

  /**
    * @ngdoc directive
    * @name vljslib.directive:vlDualAxis
    * @description
    * The Data fomat this directive requires is
    *<pre>
    * $scope.data = {
    *     title1 : '',
    *     title2 : '',
    *     unit1 : '',
    *     unit2 : '',
    *     legendTitle : '',
    *     xAxisArray : ['col1','col2','col3',....],
    *     seriesdata :  [[
    *       '','','',....
    *     ],[
    *       '','','',....
    *     ]]
    * }
    *</pre>
    *##Usage
    *<pre>
    *<vl-dual-axis data="data" throbber="boolean_var" id="gw_bar"></vl-dual-axis>
    *</pre>
    * @restrict E
    * @module vljslib
    * # component
    * @example
      <example module="exampleApp">
        <file name="index.html">
          <div ng-controller="ExampleController">
          <p>window.document title: <b ng-bind="title"></b></p>
           <vl-dual-axis data="data" throbber="gw_barchart" id="gw_bar"></vl-dual-axis>


      </file>

      <file name="script.js">
        angular.module('exampleApp', ['vljslib'])
          .controller('ExampleController', ['$scope','$timeout','dualAxis', function($scope,$timeout,dualAxis) {

            $scope.title = "HighCharts Dual Axis Chart"
            $scope.gw_barchart = true;
            $scope.data ;

            $timeout(function() {
            var data = JSON.parse('{"xAxisArray":["Aug-14","Sep-14","Oct-14","Nov-14","Dec-14","Jan-15","Feb-15","Mar-15","Apr-15","May-15","Jun-15","Jul-15","Aug-15"],"seriesData":[[9.82,10.95,11,10.56,10.29,15.77,16.14,16.76,16.53,16.19,15.87,15.7,16.21],[50.16,47.25,50.85,49.05,48.14,45.23,44.22,50.71,46.42,51.76,54.15,45.54,48.21]]}');
            $scope.data = data;
                  $scope.gw_barchart = false;
            }, 4000);


        }]);
      </file>
    </example>
    *
    * Directive to draw highCharts components
  */
  function vlDualAxis($timeout,dualAxis,$compile,$document,$templateCache,vljslibConstants){
    var directive = {
        restrict: 'E',
        template: $templateCache.get('vljslib/dualAxischartTmpl'),
        scope: {
          id: '@',
          class: '@',
          data: '=',
          value: '=',
          showThrobber: '=throbber',
          options: '=',
          nodataimage: '@',
        },
        controller:['$scope',function($scope){
              $scope.nodataimage = angular.isDefined($scope.nodataimage) ? $scope.nodataimage : "img/NoDataImages/DefaultImages/dualAxisChartNoData.png";
        }],
        link: linkFunc,

    };

    return directive;

    function linkFunc(scope, el, attr, ctrl) {

      var throbberl = attr.showthrobber;
      var unregisterDataWatch;
      var unregisterThrobberWatch;
      var id = scope.id;

      $timeout(function () {

          unregisterThrobberWatch = scope.$watch('showThrobber', function (newVal,oldval) {
            $compile(el.contents())(scope.$new());
          });


          unregisterDataWatch = scope.$watch('data', function (dataValue) {

              scope.dataError = false;
              if(angular.element("#"+id+'dax').highcharts()){
                  angular.element("#"+id+'dax').highcharts().destroy();
              }
              //this thing is fastest
              if(dataValue == undefined || dataValue==null || Object.keys(dataValue).length === 0){
                  scope.dataError = true;
              } else {
                  //surely data will be there after ajax success
                drawComponent(scope,dataValue)
              }
              scope.showError = !scope.showThrobber && scope.dataError;
          });

        });

        function toggleSideBarHandler(){
          dualAxis.reflow(id+'dax');
        }

        /** This is related to toggle event reflow **/
        $document.on("click", ".toggle-sidebar", toggleSideBarHandler);

        scope.$on('$destroy',function(){

          console.log("vljslib:: dualAxisChart : $destroy called started deregistering the events");

          $document.off('click',toggleSideBarHandler);

          if(angular.element("#"+id+'dax').highcharts()){
              angular.element("#"+id+'dax').highcharts().destroy();
          }

          if(unregisterDataWatch){
            unregisterDataWatch();
            unregisterDataWatch = null;
          }

          if(unregisterThrobberWatch){
            unregisterThrobberWatch();
            unregisterThrobberWatch = null;
          }
        })

    }

    function isEmptyData(data){
      if(data.xAxisArray.length <= 0) {
          return true;
      }

      for(var key in data.seriesData) {
          for (var key2 in data.seriesData[key]) {
              if(data.seriesData[key][key2] !=null && data.seriesData[key][key2] !=undefined){
                  return false;
              }
        }
      }
      return true;
    }

    function drawComponent(scope,data){

      var _data   = dualAxis.formatDualAxisData(data);
      var chartId = scope.id;
      if(_data!=null && Object.keys(_data).length !== 0) {
          var _title1    = (_data.title1 == undefined || _data.title1 == null) ? vljslibConstants.title : _data.title1 ;
          var _title2    = (_data.title2 == undefined || _data.title2 == null) ? vljslibConstants.title : _data.title2 ;
          scope.title = (_data.title == undefined || _data.title == null) ? vljslibConstants.title : _data.title ;
          if(!isEmptyData(_data)) {
            dualAxis.drawDualaxischart(chartId+'dax',_data,_title1,_title2);
          }
          else {
		       var chart = angular.element("#"+chartId+'dax').highcharts();
               if(chart !== undefined) {
		           if(chart.series !== undefined){
		               while( chart.series.length > 0 ) {
			               chart.series[0].remove( false );
		               }
		               chart.redraw();
		           }
		       }

	           scope.dataError = true;
		      if(angular.element("#"+chartId+'dax').highcharts() !== undefined)
		            angular.element("#"+chartId+'dax').highcharts().redraw();
	     }
      }
      else scope.dataError = true;
    }
  }


  /**
    * @ngdoc service
    * @name vljslib.dualAxis
    * @description
    * # component
    * Service to draw highCharts Dual Axis components
  */
  angular
      .module('vljslib')
      .factory('dualAxis',dualAxis)


  function dualAxis(){
    //define variables

    var service = {
      drawDualaxischart : drawDualaxischart,
      formatDualAxisData : formatDualAxisData,
      reflow : reflow
    };

    return service;

    /**
     * @ngdoc function
     * @name vljslib.dualAxis#formatDualAxisData
     * @module vljslib
     * @kind function
     * @methodOf vljslib.dualAxis
     *
     * @description
     * Method to format data for Dual Axis Chart component
     *
     * @param {Object}  Data which neds to bee formetted for highcharts dualAxisChart
     * @return {Object} Formatted Data
     **/
     function formatDualAxisData(data){
       return data;
     }


    /**
     * @ngdoc function
     * @name vljslib.dualAxis#drawDualaxischart
     * @module vljslib
     * @kind function
     * @methodOf vljslib.dualAxis
     *
     * @description
     * Method to draw highCharts Dual Axis Chart component
     *#The Data format is
     *<pre>
     * var data = {
     *     title1 : '',
     *     title2 : '',
     *     legendTitle : '',
     *     xAxisArray : ['col1','col2','col3',....],
     *     seriesdata :  [[
     *       '','','',....
     *     ],[
     *       '','','',....
     *     ]]
     * }
     *</pre>
     *
     * @example
       <example module="exampleApp">
         <file name="index.html">
           <div ng-controller="ExampleController">
           <p>window.document title: <b ng-bind="title"></b></p>
            <div id="dualAxis" style="min-width: 310px; height: 400px; margin: 0 auto"></div>


         </file>
       <file name="script.js">
         angular.module('exampleApp', ['vljslib'])
           .controller('ExampleController', ['$scope','dualAxis', function($scope,dualAxis) {

             $scope.title = "HighCharts Stock Bar Chart"
             var data = JSON.parse('{"xAxisArray":["Aug-14","Sep-14","Oct-14","Nov-14","Dec-14","Jan-15","Feb-15","Mar-15","Apr-15","May-15","Jun-15","Jul-15","Aug-15"],"seriesData":[[9.82,10.95,11,10.56,10.29,15.77,16.14,16.76,16.53,16.19,15.87,15.7,16.21],[50.16,47.25,50.85,49.05,48.14,45.23,44.22,50.71,46.42,51.76,54.15,45.54,48.21]]}');
             dualAxis.drawDualaxischart('dualAxis',data,'t1','t2');
         }]);
       </file>
     </example>
     *
     * @param {String} elementId String id passed from div in html
     * @param {Object} data Object as specified above
     * @param {String} Title1 title of the first y axis
     * @param {String} Title2 title of the second y axis
     */

    function drawDualaxischart(elementId,data,title1,title2){

      var elId = '#'+elementId;
      if(angular.element(elId).highcharts()){
          angular.element(elId).highcharts().destroy();
      }

      angular.element(elId).highcharts({
        plotOptions: {
          spline: {
              connectNulls: true
          },
          line: {
              connectNulls: true
          },
        },
        chart: {
          zoomType: 'xy'
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        xAxis: [{
          categories: data.xAxisArray,
          crosshair: true
        }],
        yAxis: [{ // Primary yAxis
          labels: {
            format: '{value} m',
            style: {
              color: Highcharts.getOptions().colors[1]
            }
          },
          title: {
            text: title2,
            style: {
              color: Highcharts.getOptions().colors[1]
            }
          }
        }, { // Secondary yAxis
          title: {
            text: title1,
            style: {
              color: Highcharts.getOptions().colors[0]
            }
          },
          labels: {
            format: '{value} mm',
            style: {
              color: Highcharts.getOptions().colors[0]
            }
          },
          opposite: true
        }],
        tooltip: {
          shared: true
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom',
          borderWidth: 0
        },
        series: [{
          name: title1,
          type: 'column',
          yAxis: 1,
          data: data.seriesData[1],
          tooltip: {
            valueSuffix: ' mm'
          }
        }, {
          name: title2,
          type: 'spline',
          data: data.seriesData[0],
          tooltip: {
            valueSuffix: 'm'
          }
        }]
      });



    }

    function reflow(elementId){

      var elId = '#'+elementId;

      if(angular.element(elId).length){
         angular.element(elId).highcharts().reflow();
      }

    }



  }

(function () {

    'use strict';

    angular
    	.module('vljslib')
    	.directive('vlChartDataError',vlChartDataError)

      vlChartDataError.$inject = ['$rootScope'];

     function vlChartDataError($rootScope){
	    return {

	      restrict: 'EA',
	      scope : {
	      	image: '@',
	      },
	      template: '<div class="vsr-error-box"><img class="watermark" ng-src={{image}}><p class = "vsr-error-text">{{::errorText}}</p></div>',
	      link: function (scope, element, attrs) {
	          scope.errorHead = "Data Error";
	          scope.errorText = "No data to display";

            scope.$on('$destroy',function(){
              console.log("Vsr Error module : destroy called");
            })
	      }
	    }
		};
	})
();


angular
.module('vljslib')
.directive('vlGauge',vlGauge)

vlGauge.$inject = ['$timeout','$window','gauge','$compile','$document','$templateCache','vljslibConstants'];

/**
* @ngdoc directive
* @name vljslib.directive:vlGauge
* @description
*The Data fomat this directive requires is
*<pre>
*  $scope.data = {
*     title : '',
*     data : [""]
* }
*</pre>
*#Usage
*<pre>
* <vl-gauge data="data" throbber="boolean_var" id="gw_gauge"></vl-gauge>
*</pre>
* @restrict E
* @module vljslib
* # component
* @example
<example module="exampleApp">
<file name="index.html">
<div ng-controller="ExampleController">
<p>window.document title: <b ng-bind="title"></b></p>
<vl-gauge data="data" throbber="gwtrend_chart" id="gw_gauge"></vl-gauge>


</file>

<file name="script.js">
angular.module('exampleApp', ['vljslib'])
.controller('ExampleController', ['$scope','$timeout','gauge', function($scope,$timeout,gauge) {

$scope.title = "HighCharts Gauge Chart"
$scope.gwtrend_chart = true;

var data = JSON.parse('{"title":"deviation","data":["30"]}');
$scope.data = data;

$timeout(function() {
$scope.gwtrend_chart = false;
}, 4000);


}]);
</file>
</example>
*
* Directive to draw highCharts components
*/
function vlGauge($timeout,$window,gauge,$compile,$document,$templateCache,vljslibConstants){

    var directive = {
        restrict: 'EA',
        template: $templateCache.get('vljslib/gaugeTmpl'),
        scope: {
            id: '@',
            class: '@',
            data: '=',
            value: '=',
            showThrobber: '=throbber',
            options: '=',
            nodataimage: '@',
        },
        controller:['$scope',function($scope){
            $scope.nodataimage = angular.isDefined($scope.nodataimage) ? $scope.nodataimage : "img/NoDataImages/DefaultImages/gaugeChartNoData.png";
        }],
        link: linkFunc,

    };

    return directive;

    function linkFunc(scope, el, attr, ctrl) {

        var unregisterDataWatch;
        var unregisterThrobberWatch;
        var id = scope.id;
        $timeout(function () {

            unregisterThrobberWatch = scope.$watch('showThrobber', function (newVal,oldval) {
                $compile(el.contents())(scope.$new());
            });

            unregisterDataWatch = scope.$watch('data', function (dataValue) {
                scope.dataError = false;
                if(angular.element("#"+id+'gauge')){
                    gauge.destroy();
                }
                //this thing is fastest
                if(dataValue == undefined || dataValue==null || Object.keys(dataValue).length === 0){
                    scope.dataError = true;
                } else {
                    scope.dataError = false;
                    //surely data will be there after ajax success
                    drawComponent(scope,dataValue)
                }
                 scope.showError = !scope.showThrobber && scope.dataError;
            });
        });

        function toggleSideBarHandler(){
            gauge.reflow(id+'gauge',scope.data.data);
        }

        function doResize(){
            scope.$apply(function() {
                //do something to update current scope based on the new innerWidth and let angular update the view.
                toggleSideBarHandler();
            });
        }

        /** This is related to toggle event reflow **/
        $document.on("click", ".toggle-sidebar", toggleSideBarHandler);

        angular.element($window).on("resize.doResize" , doResize);

        scope.$on('$destroy',function(){

          console.log("vljslib:: Gauge : $destroy called started deregistering the events");

          $document.off('click',toggleSideBarHandler);

         angular.element($window).off("resize.doResize" , doResize);

          if(angular.element("#"+id+'gauge')){
              gauge.destroy();
          }

          if(unregisterDataWatch){
            unregisterDataWatch();
            unregisterDataWatch = null;
          }

          if(unregisterThrobberWatch){
            unregisterThrobberWatch();
            unregisterThrobberWatch = null;
          }
        })

    }

    function drawComponent(scope,data){

        var _data = data;
        if(_data!=null && Object.keys(_data).length !== 0)
        {
            scope.title = (_data.title == undefined || _data.title == null) ? vljslibConstants.title : _data.title ;
            if(_data.data!=null && Object.keys(_data.data).length !== 0)
            {
                gauge.drawGaugechart(scope.id+'gauge',_data.data);
            }
            else scope.dataError = true;
        }
        else scope.dataError = true;
    }
}


  /**
    * @ngdoc service
    * @name vljslib.gauge
    * @description
    * # component
    * Service to draw highCharts Gauge Chart components
  */
  angular
      .module('vljslib')
      .factory('gauge',gauge)


  function gauge(){
    //define variables

    var chart;

    var service = {
      drawGaugechart : drawGaugechart,
      formatGaugeData : formatGaugeData,
      reflow: reflow,
      destroy : destroy
    };

    return service;

    /**
     * @ngdoc function
     * @name vljslib.gauge#formatGaugeData
     * @module vljslib
     * @kind function
     * @methodOf vljslib.gauge
     *
     * @description
     * Method to format data for gaugeChart component
     *
     * @param {Object}  Data DataSource for Gauge
     * @return {Object} Formatted Data
     **/
     function formatGaugeData(data){
         return data;
     }


    /**
     * @ngdoc function
     * @name vljslib.gauge#drawGaugechart
     * @module vljslib
     * @kind function
     * @methodOf vljslib.gauge
     *
     * @description
     * Method to draw highCharts gauge component
     *
     * #The Data format is
     *<pre>
     *  var data = {
     *     title : '',
     *     data : [""]
     * }
     *</pre>
     *
     * @example
       <example module="exampleApp">
         <file name="index.html">
           <div ng-controller="ExampleController">
           <p>window.document title: <b ng-bind="title"></b></p>
            <div id="gaugechart" style="height: 400px"></div>


         </file>
       <file name="script.js">
         angular.module('exampleApp', ['vljslib'])
           .controller('ExampleController', ['$scope','gauge', function($scope,gauge) {

             $scope.title = "AmCharts Gauge Chart"
             var data = JSON.parse('{"title":"deviation","data":["50"]}');
             gauge.drawGaugechart("gaugechart",data);
         }]);
       </file>
     </example>
     *
     * @param {String} elementId String id passed from div in html
     * @param {Object} data Data as specified above
     * @param {String} label label at the bottom
     * @param {Array}  colors array of colors in the inteervals
     */
     //Todo for ticks and interval generic intervals
     //This old plugin  needs jquery.migrate really hell
   function drawGaugechart(elementId,data,label,intervalColors){
       if(angular.element("#"+elementId+'gauge')){
           gauge.destroy();
       }
        var elId = elementId;
        var position;
        var label;
        if(data[0]!= Number.MIN_VALUE) {
          position = data[0];
          label = 'Deviation : '+position+'%';
        } else {
          position = 0;
          label = 'Deviation : Data Not available';
        }
        var max = 100;
        var min = -100;
        if(!(Math.abs(data[0]) < 100)){
          var quo = Math.floor((Math.abs(data[0]))/100);
          quo = quo +1;
          max = (quo * 100);
          min = -(quo * 100);
        }

       chart = $.jqplot(elId, [data], {
                        seriesDefaults: {
                            renderer: $.jqplot.MeterGaugeRenderer,
                            rendererOptions: {
                                label: label,
                                labelPosition: 'bottom',
                                labelHeightAdjust: -5,
                                intervalOuterRadius: 100,
                                ticks: [min, min/2, 0, max/2, max],
                                intervals: [0, max],
                                intervalColors: ['#FF0000', '#1F77B4']
                            }
                        }
                    });


    }

    function destroy(){
        if(chart !== undefined){
            chart.destroy();
        }
    }


    function reflow(elementId,data,label,intervalColors){
      if(chart !== undefined){
          chart.destroy();
          drawGaugechart(elementId,data,label,intervalColors);
      }
    }


}


  angular
      .module('vljslib')
      .directive('vlInnerStackBar',vlInnerStackBar)

  vlInnerStackBar.$inject = ['$timeout','innerStackBar','$compile','$document','$templateCache','vljslibConstants'];

  /**
    * @ngdoc directive
    * @name vljslib.directive:vlInnerStackBar
    * @description
     *The Data format this directive requires is
    * <pre>
     *  $scope.data = {
     *     title : '',
     *     legendTitle'',
     *     xAxisArray : ['col1','col2','col3','',....]
     *     seriesData : [{
     *        name : '',
     *        data : ['1','2','3',......],
     *        stack : '',
     *        level : ['1-10','10-20','20-30',......],
     *        color : ''
     *     }]
     * }
     *</pre>
    *#Usage
    *<pre>
    * <vl-inner-stack-bar data="data" throbber="boolean_var" id="gw_bar"></vl-inner-stack-bar>
    *</pre>
    * @restrict E
    * @module vljslib
    * # component
    * @example
      <example module="exampleApp">
        <file name="index.html">
          <div ng-controller="ExampleController">
          <p>window.document title: <b ng-bind="title"></b></p>
           <vl-inner-stack-bar data="data" throbber="gw_barchart" id="gw_bar"></vl-inner-stack-bar>


      </file>

      <file name="script.js">
        angular.module('exampleApp', ['vljslib'])
          .controller('ExampleController', ['$scope','$timeout','innerStackBar', function($scope,$timeout,innerStackBar) {

            $scope.title = "HighCharts Stock Bar Chart"
            $scope.gw_barchart = true;


            $timeout(function() {
            var data = JSON.parse('{"title":"Reservoir Levels","legendTitle":"Reservoir bar legends title","data":{"locationTypeLocationList":[{"locationTypeMdID":1,"locationDataList":{"locationDataList":[{"locationId":2583,"locationUuid":"1a837a05-e220-4554-a444-d62a31f40dcc","externalId":"12041","displayName":"PENNAR RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167810,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"1a837a05-e220-4554-a444-d62a31f40dcc","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":12.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":283.0,"levelRanges":[20,60,20]},"innerCircleRadius":0.00622923588039867,"outerCircleRadius":0.14690614617940198,"color":"#A52A2A","storageFraction":4.240282685512367,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2584,"locationUuid":"13c7d756-b5a5-4938-bc90-f380c1bdf324","externalId":"12047","displayName":"PRAKASAM BARRAGE","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167811,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"13c7d756-b5a5-4938-bc90-f380c1bdf324","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":17.02,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":78.75,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":149.8,"levelRanges":[20,60,20]},"innerCircleRadius":0.040879360465116275,"outerCircleRadius":0.07776162790697674,"color":"#1F77B4","storageFraction":52.57009345794392,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2585,"locationUuid":"418aa16b-ceaa-4ec0-9435-8383b9b61cbc","externalId":"12048","displayName":"MUNIYERU PROJECT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167814,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"418aa16b-ceaa-4ec0-9435-8383b9b61cbc","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":66.93,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":2.92,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":29.88,"levelRanges":[20,60,20]},"innerCircleRadius":0.00151578073089701,"outerCircleRadius":0.01551079734219269,"color":"#A52A2A","storageFraction":9.772423025435074,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2586,"locationUuid":"52f0e841-9f3f-4f08-9e2e-80782055ddcf","externalId":"12049","displayName":"PULICHINTHALA PROJECT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167815,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"52f0e841-9f3f-4f08-9e2e-80782055ddcf","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":30.11,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":19.08,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":1296.06,"levelRanges":[20,60,20]},"innerCircleRadius":0.009904485049833886,"outerCircleRadius":0.6727886212624584,"color":"#A52A2A","storageFraction":1.472154066941345,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2587,"locationUuid":"eeb82fe7-e68a-4c75-9eb7-456b2581083c","externalId":"12050","displayName":"THATIPUDI RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167818,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"eeb82fe7-e68a-4c75-9eb7-456b2581083c","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":89.36,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":81.17,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":94.3,"levelRanges":[20,60,20]},"innerCircleRadius":0.04213558970099668,"outerCircleRadius":0.04895141196013288,"color":"#FF0000","storageFraction":86.07635206786851,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2588,"locationUuid":"0ee778a9-845d-4235-b933-998f6803986b","externalId":"12051","displayName":"ANDRA RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167820,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"0ee778a9-845d-4235-b933-998f6803986b","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":140.59,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":8.26,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":27.75,"levelRanges":[20,60,20]},"innerCircleRadius":0.004287790697674418,"outerCircleRadius":0.014405107973421927,"color":"#1F77B4","storageFraction":29.765765765765767,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2589,"locationUuid":"7ab12b05-aacb-43e4-b2b3-47b8c089367d","externalId":"12052","displayName":"PEDDAGEDDA RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167823,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"7ab12b05-aacb-43e4-b2b3-47b8c089367d","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":211.51,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":19.97,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":30.3,"levelRanges":[20,60,20]},"innerCircleRadius":0.010366486710963454,"outerCircleRadius":0.015728820598006645,"color":"#1F77B4","storageFraction":65.9075907590759,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2590,"locationUuid":"57b13ab7-4d94-4962-b1f6-7046686a4257","externalId":"12053","displayName":"VENGALRAYA SAGARAM","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167829,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"57b13ab7-4d94-4962-b1f6-7046686a4257","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":159.4,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":29.22,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":47.57,"levelRanges":[20,60,20]},"innerCircleRadius":0.015168189368770763,"outerCircleRadius":0.024693729235880396,"color":"#1F77B4","storageFraction":61.425268026066846,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2591,"locationUuid":"b972c684-1c96-4683-8d27-1735d3b983e9","externalId":"12054","displayName":"VATTIGEDDA RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167830,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"b972c684-1c96-4683-8d27-1735d3b983e9","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":27.12,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":0.014078073089700997,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2592,"locationUuid":"72bbeb08-db07-4f24-a200-f5aeb92a86ac","externalId":"12055","displayName":"RAMA THIRTHAM","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167833,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"72bbeb08-db07-4f24-a200-f5aeb92a86ac","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":75.36,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":8.34,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":44.43,"levelRanges":[20,60,20]},"innerCircleRadius":0.004329318936877076,"outerCircleRadius":0.02306374584717608,"color":"#A52A2A","storageFraction":18.7711006076975,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2593,"locationUuid":"cb4a8d34-5463-40af-8bea-976b10d1705a","externalId":"12056","displayName":"THOTAPALLI REGULATOR / BARRAGE","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167835,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"cb4a8d34-5463-40af-8bea-976b10d1705a","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":102.03,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":27.54,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":70.79,"levelRanges":[20,60,20]},"innerCircleRadius":0.01429609634551495,"outerCircleRadius":0.03674730066445183,"color":"#1F77B4","storageFraction":38.90379997174742,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2594,"locationUuid":"089338af-eaa5-4a94-8866-89839c8b045c","externalId":"12057","displayName":"DAMODARAM SAGARAM","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167838,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"089338af-eaa5-4a94-8866-89839c8b045c","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":1.0,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":5.191029900332225E-4,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2595,"locationUuid":"7d3fce4b-7d20-4039-ae7e-65122b662eae","externalId":"12058","displayName":"CUM BUM TANK","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167840,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"7d3fce4b-7d20-4039-ae7e-65122b662eae","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":83.59,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":0.043391818936877075,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2596,"locationUuid":"6debdff4-2932-448f-9cde-e3bc566e05b4","externalId":"12059","displayName":"KALINGADAL PROJECT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167842,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"6debdff4-2932-448f-9cde-e3bc566e05b4","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":1.0,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":5.191029900332225E-4,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2597,"locationUuid":"129ef2e7-05f7-409f-bfca-2dda47669060","externalId":"12060","displayName":"GOTTA BARRAGE","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167843,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"129ef2e7-05f7-409f-bfca-2dda47669060","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":37.24,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":10.65,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":18.75,"levelRanges":[20,60,20]},"innerCircleRadius":0.00552844684385382,"outerCircleRadius":0.009733181063122922,"color":"#1F77B4","storageFraction":56.8,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2598,"locationUuid":"a4086f01-47d9-435e-8bc8-16967e03f033","externalId":"12061","displayName":"MOPADU RESERVOIR PROJECT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167845,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"a4086f01-47d9-435e-8bc8-16967e03f033","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":91.87,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.99,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":59.22,"levelRanges":[20,60,20]},"innerCircleRadius":5.139119601328903E-4,"outerCircleRadius":0.030741279069767438,"color":"#A52A2A","storageFraction":1.6717325227963526,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2599,"locationUuid":"219808bd-c4c0-41f8-b5c0-517600c78f14","externalId":"12062","displayName":"GAJJILIGEDDA RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167846,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"219808bd-c4c0-41f8-b5c0-517600c78f14","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":1.0,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":5.191029900332225E-4,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2600,"locationUuid":"5e347ef6-c791-4753-a7b5-e1fb79b6d633","externalId":"12063","displayName":"RALLAPADU RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167848,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"5e347ef6-c791-4753-a7b5-e1fb79b6d633","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":36.93,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":5.82,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":31.33,"levelRanges":[20,60,20]},"innerCircleRadius":0.0030211794019933554,"outerCircleRadius":0.016263496677740862,"color":"#A52A2A","storageFraction":18.576444302585383,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2601,"locationUuid":"2047859b-a4c5-4f4b-a9e6-35d06bdf0fab","externalId":"12064","displayName":"YELERU RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167849,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"2047859b-a4c5-4f4b-a9e6-35d06bdf0fab","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":71.8,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":159.49,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":682.72,"levelRanges":[20,60,20]},"innerCircleRadius":0.08279173588039868,"outerCircleRadius":0.3544019933554817,"color":"#1F77B4","storageFraction":23.36096789313335,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2602,"locationUuid":"da004729-21dc-4987-829e-4dda45350d2a","externalId":"12065","displayName":"MADDIGEDDA PROJECT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167851,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"da004729-21dc-4987-829e-4dda45350d2a","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":13.74,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":0.0071324750830564785,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2603,"locationUuid":"8a964e98-4ee4-482c-89f8-aa665b257965","externalId":"12066","displayName":"SUREMPALEM RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167853,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"8a964e98-4ee4-482c-89f8-aa665b257965","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":101.51,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":2.68,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":7.93,"levelRanges":[20,60,20]},"innerCircleRadius":0.0013911960132890367,"outerCircleRadius":0.004116486710963455,"color":"#1F77B4","storageFraction":33.79571248423708,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2604,"locationUuid":"2648f159-1f97-4b04-bdd9-24d5fd3c6f08","externalId":"12067","displayName":"BHUPATIPALEM RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167855,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"2648f159-1f97-4b04-bdd9-24d5fd3c6f08","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":198.27,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":9.42,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":21.2,"levelRanges":[20,60,20]},"innerCircleRadius":0.004889950166112957,"outerCircleRadius":0.011004983388704318,"color":"#1F77B4","storageFraction":44.43396226415094,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2605,"locationUuid":"f03b0998-3644-4e67-9a16-e7258c136475","externalId":"12068","displayName":"GUNDLAKAMMA RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167856,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"f03b0998-3644-4e67-9a16-e7258c136475","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":22.64,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":61.6,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":109.27,"levelRanges":[20,60,20]},"innerCircleRadius":0.03197674418604651,"outerCircleRadius":0.056722383720930226,"color":"#1F77B4","storageFraction":56.37411915438822,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2606,"locationUuid":"06d4797e-33e0-499f-b6b4-f34f8ffc1191","externalId":"12069","displayName":"SIR AURTHUR COTTON BARRAGE","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167858,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"06d4797e-33e0-499f-b6b4-f34f8ffc1191","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":1.0,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":5.191029900332225E-4,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2607,"locationUuid":"dac92ec0-e1ac-4383-81cd-43c569d0af1e","externalId":"12070","displayName":"GANDIPALEM RESERVOIR PROJECT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167859,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"dac92ec0-e1ac-4383-81cd-43c569d0af1e","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":139.41,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":3.85,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":53.24,"levelRanges":[20,60,20]},"innerCircleRadius":0.001998546511627907,"outerCircleRadius":0.02763704318936877,"color":"#A52A2A","storageFraction":7.231404958677686,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2608,"locationUuid":"d61f5d35-82fe-4361-a05a-b067cba27fe5","externalId":"12071","displayName":"TANDAVA RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167861,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"d61f5d35-82fe-4361-a05a-b067cba27fe5","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":109.26,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":34.48,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":140.45,"levelRanges":[20,60,20]},"innerCircleRadius":0.017898671096345513,"outerCircleRadius":0.0729080149501661,"color":"#1F77B4","storageFraction":24.549661801352794,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2609,"locationUuid":"79562fd0-acce-4b24-92d9-6d6a8590b59d","externalId":"12072","displayName":"VARAHA RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167863,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"79562fd0-acce-4b24-92d9-6d6a8590b59d","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":138.79,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":10.9,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":13.17,"levelRanges":[20,60,20]},"innerCircleRadius":0.005658222591362126,"outerCircleRadius":0.006836586378737541,"color":"#FF0000","storageFraction":82.76385725132877,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2610,"locationUuid":"16ae6e6a-58e7-4354-bc0a-b89ea57b3853","externalId":"12073","displayName":"SANGAM ANICUT / BARRGE","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167863,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"16ae6e6a-58e7-4354-bc0a-b89ea57b3853","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":1.0,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":5.191029900332225E-4,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2611,"locationUuid":"11865ac5-953d-4ca9-bcbf-5f6a5f98c348","externalId":"12074","displayName":"PEDDERU RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167864,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"11865ac5-953d-4ca9-bcbf-5f6a5f98c348","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":135.91,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":8.51,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":13.4,"levelRanges":[20,60,20]},"innerCircleRadius":0.0044175664451827235,"outerCircleRadius":0.006955980066445182,"color":"#1F77B4","storageFraction":63.50746268656716,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2612,"locationUuid":"19a1219a-34e9-43f9-9f48-f04299108349","externalId":"12075","displayName":"KANIGIRI RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167864,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"19a1219a-34e9-43f9-9f48-f04299108349","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":100.64,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":0.05224252491694352,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2613,"locationUuid":"1a361403-398b-499d-98c7-f750c57ceb3f","externalId":"12076","displayName":"KONAM RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167865,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"1a361403-398b-499d-98c7-f750c57ceb3f","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":99.73,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":19.52,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":48.14,"levelRanges":[20,60,20]},"innerCircleRadius":0.010132890365448503,"outerCircleRadius":0.024989617940199334,"color":"#1F77B4","storageFraction":40.54840049854591,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2614,"locationUuid":"04affbff-36d4-458a-9c32-baa64eb6eab0","externalId":"12077","displayName":"KANDALERU RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167865,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"04affbff-36d4-458a-9c32-baa64eb6eab0","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":60.61,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":147.73,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":1926.4,"levelRanges":[20,60,20]},"innerCircleRadius":0.07668708471760796,"outerCircleRadius":1.0,"color":"#A52A2A","storageFraction":7.668708471760796,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2615,"locationUuid":"53a12642-b27f-4a34-9ac0-19bab3af825f","externalId":"12078","displayName":"RAIWADA RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167866,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"53a12642-b27f-4a34-9ac0-19bab3af825f","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":101.94,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":0.05291735880398671,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2616,"locationUuid":"e964c4dd-6a15-4147-9104-0a9626d1ac80","externalId":"12079","displayName":"MEHADRIGADD RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167866,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"e964c4dd-6a15-4147-9104-0a9626d1ac80","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":17.88,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":23.5,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":33.1,"levelRanges":[20,60,20]},"innerCircleRadius":0.012198920265780731,"outerCircleRadius":0.017182308970099668,"color":"#1F77B4","storageFraction":70.99697885196375,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2617,"locationUuid":"1765fa8a-3f21-441c-9bd5-526b37ba9aec","externalId":"12080","displayName":"SWARNAMUKHI BARRAGE CUM BRIDGE","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167867,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"1765fa8a-3f21-441c-9bd5-526b37ba9aec","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":6.91,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.04,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":1.0,"levelRanges":[20,60,20]},"innerCircleRadius":2.07641196013289E-5,"outerCircleRadius":5.191029900332225E-4,"color":"#A52A2A","storageFraction":4.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2618,"locationUuid":"5bba311b-8651-4dbb-859b-98e1e176d940","externalId":"12081","displayName":"SARVEPALLI RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167867,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"5bba311b-8651-4dbb-859b-98e1e176d940","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":12.35,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":0.0064109219269102985,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2619,"locationUuid":"3f7ccade-c202-4169-ae1f-e617dd29a3a1","externalId":"12082","displayName":"NARAYANAPURAM ANICUT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167868,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"3f7ccade-c202-4169-ae1f-e617dd29a3a1","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":1.0,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":5.191029900332225E-4,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2620,"locationUuid":"20f6ac7e-e464-4bc8-95e6-94c659ebb112","externalId":"12083","displayName":"MADDUVALASA PROJECT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167869,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"20f6ac7e-e464-4bc8-95e6-94c659ebb112","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":63.67,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":61.92,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":95.48,"levelRanges":[20,60,20]},"innerCircleRadius":0.03214285714285714,"outerCircleRadius":0.049563953488372094,"color":"#1F77B4","storageFraction":64.85127775450356,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2621,"locationUuid":"3c11003b-d0b7-4565-a318-b75bc3277a86","externalId":"12084","displayName":"PAMPA RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167869,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"3c11003b-d0b7-4565-a318-b75bc3277a86","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":24.9,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.39,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":14.1,"levelRanges":[20,60,20]},"innerCircleRadius":2.0245016611295682E-4,"outerCircleRadius":0.007319352159468438,"color":"#A52A2A","storageFraction":2.765957446808511,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2622,"locationUuid":"2c01a0fd-388d-4d3c-b790-726f8ca0d690","externalId":"12085","displayName":"SUNKESULA BARRAGE","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167870,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"2c01a0fd-388d-4d3c-b790-726f8ca0d690","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":291.95,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":34.4,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":34.99,"levelRanges":[20,60,20]},"innerCircleRadius":0.017857142857142856,"outerCircleRadius":0.018163413621262458,"color":"#FF0000","storageFraction":98.31380394398398,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2623,"locationUuid":"0e6be4a2-db2a-42c0-a01d-9de81d835a5e","externalId":"12086","displayName":"ALAGANURU BALANCING RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167870,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"0e6be4a2-db2a-42c0-a01d-9de81d835a5e","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":263.9,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":69.07,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":83.96,"levelRanges":[20,60,20]},"innerCircleRadius":0.03585444352159468,"outerCircleRadius":0.043583887043189364,"color":"#FF0000","storageFraction":82.26536445926631,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2624,"locationUuid":"9e2cb9f8-743b-473a-b966-7d11cb000a79","externalId":"12087","displayName":"VELOGODU BALANCING RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167871,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"9e2cb9f8-743b-473a-b966-7d11cb000a79","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":251.6,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":61.56,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":479.97,"levelRanges":[20,60,20]},"innerCircleRadius":0.031955980066445185,"outerCircleRadius":0.24915386212624585,"color":"#A52A2A","storageFraction":12.825801612600786,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2625,"locationUuid":"89fabc06-f306-4919-b057-6a749e68a277","externalId":"12088","displayName":"VARADARAJASWAMY GUDI PROJECT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167871,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"89fabc06-f306-4919-b057-6a749e68a277","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":353.7,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":19.23,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":11.02,"levelRanges":[20,60,20]},"innerCircleRadius":0.009982350498338871,"outerCircleRadius":0.005720514950166113,"color":null,"storageFraction":174.50090744101635,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2626,"locationUuid":"901e15e0-2d83-4546-bb15-5a60dafcf358","externalId":"12089","displayName":"ZURRERU RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167872,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"901e15e0-2d83-4546-bb15-5a60dafcf358","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":7.53,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":0.003908845514950166,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2627,"locationUuid":"c116d365-f5f4-4828-946b-59cc9df53284","externalId":"12090","displayName":"OWK RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167873,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"c116d365-f5f4-4828-946b-59cc9df53284","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":215.52,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":24.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":117.46,"levelRanges":[20,60,20]},"innerCircleRadius":0.012458471760797342,"outerCircleRadius":0.06097383720930232,"color":"#1F77B4","storageFraction":20.432487655372043,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2628,"locationUuid":"0baf751c-7060-4d25-aea1-62524b8d1f53","externalId":"12091","displayName":"CHAGALLU BALANCING RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167873,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"0baf751c-7060-4d25-aea1-62524b8d1f53","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":261.68,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":9.44,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":50.94,"levelRanges":[20,60,20]},"innerCircleRadius":0.004900332225913621,"outerCircleRadius":0.026443106312292356,"color":"#A52A2A","storageFraction":18.531605810757757,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2629,"locationUuid":"f29b32d3-cf35-4a18-a85d-79848a8b5f3c","externalId":"12092","displayName":"MID PENNAR RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167874,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"f29b32d3-cf35-4a18-a85d-79848a8b5f3c","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":360.44,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":74.01,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":147.25,"levelRanges":[20,60,20]},"innerCircleRadius":0.03841881229235881,"outerCircleRadius":0.07643791528239202,"color":"#1F77B4","storageFraction":50.26146010186758,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2630,"locationUuid":"1c20cc80-9c3f-4a6f-bc74-e16b29b5ad9a","externalId":"12093","displayName":"PENNA AHOBILAM BALANCING RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167874,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"1c20cc80-9c3f-4a6f-bc74-e16b29b5ad9a","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":431.65,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":95.7,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":314.32,"levelRanges":[20,60,20]},"innerCircleRadius":0.0496781561461794,"outerCircleRadius":0.1631644518272425,"color":"#1F77B4","storageFraction":30.44667854415882,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2631,"locationUuid":"d5e80539-c254-486e-8f06-d51d951a5bb1","externalId":"12094","displayName":"BHAIRAVANITHIPPA PROJECT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167875,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"d5e80539-c254-486e-8f06-d51d951a5bb1","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":56.66,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":0.02941237541528239,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2632,"locationUuid":"5f99ff1c-5c63-4c69-9929-b185336dea42","externalId":"12095","displayName":"YOGI VEMANA (MADDILERU) RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167875,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"5f99ff1c-5c63-4c69-9929-b185336dea42","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":375.96,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":7.16,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":25.49,"levelRanges":[20,60,20]},"innerCircleRadius":0.0037167774086378736,"outerCircleRadius":0.013231935215946842,"color":"#1F77B4","storageFraction":28.089446841898784,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2633,"locationUuid":"d8a1e0fc-ae8c-4438-b856-e919211549a6","externalId":"12096","displayName":"CHENNARAYA SWAMI GUDI PROJECT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167876,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"d8a1e0fc-ae8c-4438-b856-e919211549a6","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":4.81,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":0.0024968853820598004,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2634,"locationUuid":"e3b8a981-cbed-4e0f-a45a-58ff26348795","externalId":"12097","displayName":"KALANGI RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167877,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"e3b8a981-cbed-4e0f-a45a-58ff26348795","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":60.79,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.08,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":6.82,"levelRanges":[20,60,20]},"innerCircleRadius":4.15282392026578E-5,"outerCircleRadius":0.003540282392026578,"color":"#A52A2A","storageFraction":1.1730205278592374,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2635,"locationUuid":"aa64b669-3cd2-4483-b2f5-d1f123384726","externalId":"12098","displayName":"ARANIAR RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167877,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"aa64b669-3cd2-4483-b2f5-d1f123384726","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":78.94,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":2.94,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":52.47,"levelRanges":[20,60,20]},"innerCircleRadius":0.0015261627906976744,"outerCircleRadius":0.027237333887043188,"color":"#A52A2A","storageFraction":5.603201829616924,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2636,"locationUuid":"fd8d84e2-87a0-4ff8-87d2-eeda16cad00a","externalId":"12099","displayName":"KRISHNAPURAM PROJECT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167877,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"fd8d84e2-87a0-4ff8-87d2-eeda16cad00a","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":210.6,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":3.97,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":5.65,"levelRanges":[20,60,20]},"innerCircleRadius":0.002060838870431894,"outerCircleRadius":0.0029329318936877078,"color":"#1F77B4","storageFraction":70.2654867256637,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2637,"locationUuid":"d89c4ec1-4d16-4131-aff9-a0f1e0e26a45","externalId":"12100","displayName":"KALYANI DAM","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167878,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"d89c4ec1-4d16-4131-aff9-a0f1e0e26a45","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":25.79,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":0.01338766611295681,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2638,"locationUuid":"eb761fe7-4909-4df9-86ce-a8e62f1a1860","externalId":"12101","displayName":"SUBBAREDDY SAGAR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167878,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"eb761fe7-4909-4df9-86ce-a8e62f1a1860","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":78.9,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":1.87,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":6.63,"levelRanges":[20,60,20]},"innerCircleRadius":9.707225913621263E-4,"outerCircleRadius":0.0034416528239202657,"color":"#1F77B4","storageFraction":28.205128205128204,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2639,"locationUuid":"438c98a8-eb29-43c8-a06c-0938b938ed66","externalId":"12102","displayName":"PEDDERU RESERVOIR PROJECT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167880,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"438c98a8-eb29-43c8-a06c-0938b938ed66","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":469.62,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":2.45,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":15.86,"levelRanges":[20,60,20]},"innerCircleRadius":0.0012718023255813954,"outerCircleRadius":0.00823297342192691,"color":"#A52A2A","storageFraction":15.447667087011352,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2640,"locationUuid":"db007f1f-3df5-4d6d-abd4-e8667e138bd7","externalId":"12103","displayName":"NTR RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167881,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"db007f1f-3df5-4d6d-abd4-e8667e138bd7","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":108.48,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":3.45,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":5.77,"levelRanges":[20,60,20]},"innerCircleRadius":0.0017909053156146182,"outerCircleRadius":0.002995224252491694,"color":"#1F77B4","storageFraction":59.792027729636054,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2641,"locationUuid":"48384eca-f162-44bf-a484-f21bc4c47dbf","externalId":"12104","displayName":"GAJULADINNE PROJECT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167881,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"48384eca-f162-44bf-a484-f21bc4c47dbf","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":374.81,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":71.8,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":127.43,"levelRanges":[20,60,20]},"innerCircleRadius":0.03727159468438537,"outerCircleRadius":0.06614929401993355,"color":"#1F77B4","storageFraction":56.34465981323079,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2642,"locationUuid":"001ef564-fb77-47b7-8725-ef1c55f1fa49","externalId":"12105","displayName":"BUGGAVANKA RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167882,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"001ef564-fb77-47b7-8725-ef1c55f1fa49","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":169.25,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.12,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":14.33,"levelRanges":[20,60,20]},"innerCircleRadius":6.22923588039867E-5,"outerCircleRadius":0.007438745847176079,"color":"#A52A2A","storageFraction":0.837404047452896,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2643,"locationUuid":"32e583e8-18db-453e-bc0e-7187a58373be","externalId":"12106","displayName":"VELIGALLU RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167882,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"32e583e8-18db-453e-bc0e-7187a58373be","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":408.4,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":32.69,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":129.12,"levelRanges":[20,60,20]},"innerCircleRadius":0.016969476744186043,"outerCircleRadius":0.0670265780730897,"color":"#1F77B4","storageFraction":25.317534076827755,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2644,"locationUuid":"ee847fd6-6701-492b-8deb-862ecac3a0d3","externalId":"12107","displayName":"PINCHA PROJECT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167883,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"ee847fd6-6701-492b-8deb-862ecac3a0d3","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":9.28,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":0.0048172757475083055,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2645,"locationUuid":"16b17962-4e67-485c-b4e7-9cd18c7e6f68","externalId":"12108","displayName":"ANNAMAYYA (CHEYYERU) RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167883,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"16b17962-4e67-485c-b4e7-9cd18c7e6f68","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":191.36,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":7.86,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":63.16,"levelRanges":[20,60,20]},"innerCircleRadius":0.004080149501661129,"outerCircleRadius":0.03278654485049833,"color":"#A52A2A","storageFraction":12.444585180493984,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2646,"locationUuid":"022ebbcc-adba-4d59-8fd0-598f00b28571","externalId":"12109","displayName":"LOWER SAGILERU ANI CUT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167884,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"022ebbcc-adba-4d59-8fd0-598f00b28571","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":7.31,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":0.0037946428571428567,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2647,"locationUuid":"3a4daec9-661f-4400-9a21-cad79c1f758a","externalId":"12110","displayName":"BRAHMAMSAGAR RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167884,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"3a4daec9-661f-4400-9a21-cad79c1f758a","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":192.7,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":71.08,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":502.2,"levelRanges":[20,60,20]},"innerCircleRadius":0.036897840531561456,"outerCircleRadius":0.26069352159468434,"color":"#A52A2A","storageFraction":14.153723616089207,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2648,"locationUuid":"b1651343-8580-4b6d-ac5d-d6b4688260ec","externalId":"12111","displayName":"GANDIKOTA RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167885,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"b1651343-8580-4b6d-ac5d-d6b4688260ec","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":199.55,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":20.06,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":760.02,"levelRanges":[20,60,20]},"innerCircleRadius":0.010413205980066445,"outerCircleRadius":0.3945286544850498,"color":"#A52A2A","storageFraction":2.639404226204573,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2649,"locationUuid":"7e103cea-040e-464a-9dbe-d7a17bda3fc2","externalId":"12112","displayName":"CHITRAVATI BALANCING RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167885,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"7e103cea-040e-464a-9dbe-d7a17bda3fc2","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":285.05,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":23.84,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":283.17,"levelRanges":[20,60,20]},"innerCircleRadius":0.012375415282392025,"outerCircleRadius":0.14699439368770764,"color":"#A52A2A","storageFraction":8.418970936186742,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2650,"locationUuid":"b7629dc4-91c6-41ff-a9b7-1d49bbc2b806","externalId":"12113","displayName":"KOVVADAKALVA RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167886,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"b7629dc4-91c6-41ff-a9b7-1d49bbc2b806","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":12.35,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":0.0064109219269102985,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2651,"locationUuid":"fe6aeb9c-3d2a-48c3-9934-f17653b6926a","externalId":"12114","displayName":"JALLERU RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167886,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"fe6aeb9c-3d2a-48c3-9934-f17653b6926a","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":64.94,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":8.12,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":15.15,"levelRanges":[20,60,20]},"innerCircleRadius":0.004215116279069767,"outerCircleRadius":0.007864410299003323,"color":"#1F77B4","storageFraction":53.59735973597359,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2652,"locationUuid":"b0eda010-a7bd-49a4-a0b5-c10af6f93b16","externalId":"12115","displayName":"YERRAKALVA RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167887,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"b0eda010-a7bd-49a4-a0b5-c10af6f93b16","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":78.58,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":33.88,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":70.36,"levelRanges":[20,60,20]},"innerCircleRadius":0.01758720930232558,"outerCircleRadius":0.03652408637873754,"color":"#1F77B4","storageFraction":48.15235929505401,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2653,"locationUuid":"f47bcc5a-c8da-4c55-9eba-2ffd605e3efb","externalId":"12116","displayName":"BYNERU ANICUT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167887,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"f47bcc5a-c8da-4c55-9eba-2ffd605e3efb","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":1.0,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":5.191029900332225E-4,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2654,"locationUuid":"586ceeb9-3ad4-49bc-a92d-444015851593","externalId":"12117","displayName":"TAMMILERU RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167887,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"586ceeb9-3ad4-49bc-a92d-444015851593","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":100.7,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":4.16,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":31.29,"levelRanges":[20,60,20]},"innerCircleRadius":0.002159468438538206,"outerCircleRadius":0.016242732558139534,"color":"#A52A2A","storageFraction":13.294982422499201,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2655,"locationUuid":"f455494b-8345-4a83-af48-0f0b19b40d25","externalId":"12118","displayName":"VIJAYARAI ANICUT","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167888,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"f455494b-8345-4a83-af48-0f0b19b40d25","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":120.0,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":0.0,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":1.0,"levelRanges":[20,60,20]},"innerCircleRadius":0.0,"outerCircleRadius":5.191029900332225E-4,"color":"#A52A2A","storageFraction":0.0,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null},{"locationId":2656,"locationUuid":"37df32d4-09b4-4267-8a39-b86bde35eea2","externalId":"12119","displayName":"GONELAVAGU RESERVOIR","nameUid":null,"description":null,"descriptionUid":null,"isParent":1,"deleted":0,"insertTs":1444659167888,"updateTs":0,"userSessionId":0,"locationAssociationList":null,"locationTypeMdList":null,"waterQuantityEventList":null,"locationExtensionMdList":null,"waterQualityEventList":null,"extendedWaterQuantityList":{"extendedWaterQuantityList":[{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":"37df32d4-09b4-4267-8a39-b86bde35eea2","sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0.0,"customFloat2":0.0,"customFloat3":0.0,"customFloat4":0.0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":101.37,"levelMU1":0,"levelValue2":0.0,"levelMU2":0,"levelValue3":0.0,"levelMU3":0,"levelValue4":0.0,"levelMU4":0,"flowValueIn":0.0,"flowMUIn":0,"flowValueOut":0.0,"flowMUOut":0,"flowValue1":0.0,"flowMU1":0,"flowValue2":0.0,"flowMU2":0,"pressureValue1":0.0,"pressureMU1":0,"pressureValue2":0.0,"pressureMU2":0,"pressureValue3":0.0,"pressureMU3":0,"pressureValue4":0.0,"pressureMU4":0,"storageValue1":11.44,"storageMU1":0,"storageValue2":0.0,"storageMU2":0,"storageValue3":0.0,"storageMU3":0,"storageValue4":0.0,"storageMU4":0,"levelCode":null,"percentage":0.0,"minValue":0.0,"maxValue":0.0,"attributes":{"capacity":50.15,"levelRanges":[20,60,20]},"innerCircleRadius":0.005938538205980066,"outerCircleRadius":0.026033014950166113,"color":"#1F77B4","storageFraction":22.811565304087736,"inFlowFraction":0.0,"waterEventType":"WATER_QUANTITY_EVENT"}]},"locatioExtensionMdList":null}]},"name":"RESERVOIR"}]}}');

         var data1 = innerStackBar.formatBarData(data);
         var legendData = JSON.parse('{"flood":{"min":0.0,"max":0.0,"color":"#FF0000","name":"Flood"},"normal":{"min":0.0,"max":0.0,"color":"#1F77B4","name":"Normal"},"dead":{"min":0.0,"max":0.0,"color":"#A52A2A","name":"Dead Storage"}}');

//console.log(innerStackBar.formatBarData(data));
            $scope.data = innerStackBar.finalFormat(data1,legendData);
                  $scope.gw_barchart = false;
            }, 4000);


        }]);
      </file>
    </example>
    *
    * Directive to draw highCharts components
  */
  function vlInnerStackBar($timeout,innerStackBar,$compile,$document,$templateCache,vljslibConstants){
    var directive = {
        restrict: 'E',
        transclude: true,
        template: $templateCache.get('vljslib/innerStackbarchartTmpl'),
        scope: {
          id: '@',
          class: '@',
          data: '=',
          value: '=',
          showThrobber: '=throbber',
          options: '=',
          nodataimage: '@',
        },
        controller:['$scope',function($scope){
              $scope.nodataimage = angular.isDefined($scope.nodataimage) ? $scope.nodataimage : "img/NoDataImages/DefaultImages/innerStackBarChartNoData.png";
        }],
        link: linkFunc,

    };

    return directive;

    function linkFunc(scope, el, attr, ctrl) {

      var throbberl = attr.showthrobber;
      var unregisterDataWatch;
      var unregisterThrobberWatch;
      var id = scope.id;

      $timeout(function () {

          unregisterThrobberWatch = scope.$watch('showThrobber', function (newVal,oldval) {
              $compile(el.contents())(scope.$new());
          });


          unregisterDataWatch = scope.$watch('data', function (dataValue) {

              scope.dataError = false;

              if(angular.element("#"+id+'ibr').highcharts()){
                  angular.element("#"+id+'ibr').highcharts().destroy();
              }

              //this thing is fastest
              if(dataValue == undefined || dataValue==null || Object.keys(dataValue).length === 0){
                  scope.dataError = true;
              } else {
                  //surely data will be there after ajax success
                  drawComponent(scope,dataValue)
              }
              scope.showError = !scope.showThrobber && scope.dataError;
          });

        });

        function toggleSideBarHandler(){
            innerStackBar.reflow(id+'ibr');
        }

        /** This is related to toggle event reflow **/
        $document.on("click", ".toggle-sidebar", toggleSideBarHandler);

        scope.$on('$destroy',function(){

            console.log("vljslib:: innerStackBar : $destroy called started deregistering the events");

            $document.off('click',toggleSideBarHandler);

            if(angular.element("#"+id+'ibr').highcharts()){
                angular.element("#"+id+'ibr').highcharts().destroy();
            }

            if(unregisterDataWatch){
              unregisterDataWatch();
              unregisterDataWatch = null;
            }

            if(unregisterThrobberWatch){
              unregisterThrobberWatch();
              unregisterThrobberWatch = null;
            }
        });

    }


    function drawComponent(scope,data){

      var _data  = data;
      var chartId = scope.id;
      if(_data!=null && Object.keys(_data).length !== 0)
      {
        var _lgTitle    = (_data.legendTitle == undefined || _data.legendTitle == null) ? vljslibConstants.legendTitle : _data.legendTitle ;
        scope.title = (_data.title == undefined || _data.title == null) ? vljslibConstants.title : _data.title ;
        if(_data.xAxisArray.length > 0 ) {
          innerStackBar.drawBarchart(chartId+'ibr',_data,_lgTitle);
        }
        else scope.dataError = true;
      }
      else scope.dataError = true;
    }
  }


/**
* @ngdoc service
* @name vljslib.innerStackBar
* @description
* # component
* Service to draw highCharts innerStackBar components
*/
angular
.module('vljslib')
.factory('innerStackBar',innerStackBar)


function innerStackBar(){
    //define variables

    var service = {
        drawBarchart : drawBarchart,
        finalFormat : finalFormat,
        reflow : reflow
    };

    return service;

    function convertHex(hex, opacity) {
        hex = hex.replace('#', '');
        var r = parseInt(hex.substring(0, 2), 16);
        var g = parseInt(hex.substring(2, 4), 16);
        var b = parseInt(hex.substring(4, 6), 16);

        var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
        return result;
    }

    function finalFormat(stackdata ,ldata){

        var opacity = 0.75;
        var Finaldata = [{
            name: ldata.flood.name,
            data: stackdata.series.l3,
            stack: 'level',
            level:stackdata.level.l3,
            color: convertHex('#fe0000', opacity)
        },{
            name: ldata.normal.name,
            data: stackdata.series.l2,
            stack: 'level',
            level:stackdata.level.l2,
            color: convertHex('#38a700', opacity)
        },{
            name: ldata.dead.name,
            data: stackdata.series.l1,
            stack: 'level',
            level:stackdata.level.l1,
            color: convertHex(ldata.dead.color, opacity)
        }, {
            name: 'Current Storage',
            color: /*'#236D8C'*/
            convertHex(ldata.normal.color, 1),
            data: stackdata.series.in,
            pointPadding: 0.2,
        }];

        var _data = {
            title : stackdata.title,
            legendTitle : stackdata.legendTitle,
            xAxisArray : stackdata.series.main,
            seriesData : Finaldata,
        }

        return _data;
    }

    /**
    * @ngdoc function
    * @name vljslib.innerStackBar#drawBarchart
    * @module vljslib
    * @kind function
    * @methodOf vljslib.innerStackBar
    *
    * @description
    * Method to draw highCharts stackedBarChart component
    * #The Data format is
    *<pre>
    *  var data = {
    *     title : '',
    *     legendTitle'',
    *     xAxisArray : ['col1','col2','col3','',....]
    *     seriesData : [{
    *        name : '',
    *        data : ['1','2','3',......],
    *        stack : '',
    *        level : ['1-10','10-20','20-30',......],
    *        color : ''
    *     }]
    * }
    *</pre>
    *
    *
    * @example
    <example module="exampleApp">
    <file name="index.html">
    <div ng-controller="ExampleController">
    <p>window.document title: <b ng-bind="title"></b></p>
    <div id="barchart" style="min-width: 310px; height: 400px; margin: 0 auto"></div>


    </file>
    <file name="script.js">
    angular.module('exampleApp', ['vljslib'])
    .controller('ExampleController', ['$scope','innerStackBar', function($scope,innerStackBar) {

    $scope.title = "HighCharts Stock Bar Chart"
    var data = JSON.parse('{"xAxisArray":["East Godavari","Kadapa","Anantapur","Nellore","West Godavari","Srikakulam","Chittoor","Kurnool","Krishna","Visakhapatnam","Prakasam","Vizianagaram","Guntur"],"seriesData":[{"name":"Flood","data":[20,20,20,20,20,20,20,20,20,20,20,20,20],"stack":"level","level":["> 80","> 80","> 80","> 80","> 80","> 80","> 80","> 80","> 80","> 80","> 80","> 80","> 80"],"color":"rgba(254,0,0,0.75)"},{"name":"Normal","data":[60,60,60,60,60,60,60,60,60,60,60,60,60],"stack":"level","level":["20-80","20-80","20-80","20-80","20-80","20-80","20-80","20-80","20-80","20-80","20-80","20-80","20-80"],"color":"rgba(56,167,0,0.75)"},{"name":"Dead Storage","data":[20,20,20,20,20,20,20,20,20,20,20,20,20],"stack":"level","level":["< 20","< 20","< 20","< 20","< 20","< 20","< 20","< 20","< 20","< 20","< 20","< 20","< 20"],"color":"rgba(165,42,42,0.75)"},{"name":"Current Storage","color":"rgba(31,119,180,1)","data":[17.04,94.32,53.22,10.99,47.92,90.59,40.59,12.21,72.01,90.15,36.95,89.01,44.02],"pointPadding":0.2}]}');
    innerStackBar.drawBarchart('barchart',data,'Fluctuation in Meters');
}]);
</file>
</example>
*
* @param {String} elementId String id passed from div in html
* @param {Object} data Object as specified above
* @param {String} legendTitle legendTitle
*/

function drawBarchart(elementId,data,legendTitle){

    if(angular.element("#"+elementId).highcharts()){
        angular.element("#"+elementId).highcharts().destroy();
    }

    var elId = '#'+elementId;

    angular.element(elId).highcharts({
        chart: {
            type: 'column'
        },
        title: {
            text: '',
            useHTML: true,
        },
        xAxis: {
            categories: data.xAxisArray
        },
        yAxis: [{
            min: 0,
            title: {
                text: ''
            }
        }, {
            title: {
                text: ''
            },
            opposite: true
        }],
        legend: {
            shadow: false
        },
        tooltip: {
            shared: true,
            useHTML: true,
            formatter: function () {
                var points = this.points;
                var pointsLength = points.length;
                var tooltipMarkup = pointsLength ? '<span style="font-size: 10px">' + points[0].key + '</span><br/>' : '';
                var indexLevel = data.xAxisArray.indexOf(points[0].key);
                var index;
                var y_value_kwh;

                for(index = 0; index < pointsLength; index += 1) {
                    y_value_kwh = points[index].y;
                    /* need to made generic*/
                    if(points[index].series.name=='Current Storage') {
                        y_value_kwh = (points[index].y).toFixed(2);
                        tooltipMarkup += '<span style="color:' + points[index].series.color + '">\u25CF</span> ' + points[index].series.name + ': <b>' + y_value_kwh  + ' % </b><br/>';
                    } else {
                        y_value_kwh = data.seriesData[index].level[indexLevel];
                        tooltipMarkup += '<span style="color:' + points[index].series.color + '">\u25CF</span> ' + points[index].series.name + ': <b>' + y_value_kwh  + ' %</b><br/>';
                    }

                }

                return tooltipMarkup;
            }
        },
        plotOptions: {
            column: {
                depth: 25,
                pointPadding: 0,
                grouping: false,
                borderWidth: 0,
            },
            series: {
                stacking: 'normal',
                borderColor: "#FFFFFF",
                borderWidth: 1.5,
            }
        },
        series: data.seriesData
    });



}

function reflow(elementId){

    var elId = '#'+elementId;

    if(angular.element(elId).length){
        angular.element(elId).highcharts().reflow();
    }

}



}


  angular
      .module('vljslib')
      .directive('vlLine',vlLine)

  vlLine.$inject = ['$timeout','line','$compile','$document','$templateCache','vljslibConstants'];

  /**
    * @ngdoc directive
    * @name vljslib.directive:vlLine
    * @description
      * The data format this directive requires is
    * *<pre>
     *  $scope.data = {
     *     title : '',
     *     legendTitle : '',
     *     xAxisArray : ['col1','col2','col3',.......],
     *     seriesData : [{
     *        name : '',
     *        data : ['1','2','3',....]
     *     },{},.....],
     *
     * }
     *</pre>
     *#Usage
     *<pre>
     * <vl-line data="data" throbber="boolean_var" id="gw_line"></vl-line>
     *</pre>
    * @restrict E
    * @module vljslib
    * # component
    * @example
      <example module="exampleApp">
        <file name="index.html">
          <div ng-controller="ExampleController">
          <p>window.document title: <b ng-bind="title"></b></p>
           <vl-line data="data" throbber="gwtrend_chart" id="gw_line"></vl-line>


      </file>

      <file name="script.js">
        angular.module('exampleApp', ['vljslib'])
          .controller('ExampleController', ['$scope','$timeout','line', function($scope,$timeout,line) {

            $scope.title = "HighCharts Line Chart"
            $scope.gwtrend_chart = true;

            var data = JSON.parse('{"title": "Rainfall Trends Title","unit": "mm","data":{"East Godavari":{"Feb-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":13.563333333333333,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Mar-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":20.64666666666667,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Jun-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":20.66,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Oct-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":25.286666666666665,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Apr-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":23.86,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Dec-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":20.483333333333334,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Jan-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":13.449999999999998,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Aug-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":21.206666666666667,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Aug-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":24.323333333333327,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Sep-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":25.22666666666667,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Nov-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":21.85666666666667,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Jul-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":21.343333333333334,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"May-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":16.666666666666668,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"}}}}');
            var monthsdata = JSON.parse('["Aug-14","Sep-14","Oct-14","Nov-14","Dec-14","Jan-15","Feb-15","Mar-15","Apr-15","May-15","Jun-15","Jul-15","Aug-15"]')
            $scope.data = line.formatLineData(data,monthsdata,'levelValue1');
            $timeout(function() {
                  $scope.gwtrend_chart = false;
            }, 4000);


        }]);
      </file>
    </example>
    *
    * Directive to draw highCharts components
  */
  function vlLine($timeout,line,$compile,$document,$templateCache,vljslibConstants){

    var directive = {
        restrict: 'EA',
        template: $templateCache.get('vljslib/linechartTmpl'),
        scope: {
          id: '@',
          class: '@',
          data: '=',
          value: '=',
          showThrobber: '=throbber',
          options: '=',
          nodataimage: '@',
        },
        controller:['$scope',function($scope){
              $scope.nodataimage = angular.isDefined($scope.nodataimage) ? $scope.nodataimage : "img/NoDataImages/DefaultImages/lineChartNoData.png";
        }],
        link: linkFunc,

    };

    return directive;

    function linkFunc(scope, el, attr, ctrl) {

        var unregisterDataWatch;
        var unregisterThrobberWatch;
        var id = scope.id;

        $timeout(function () {
            unregisterThrobberWatch = scope.$watch('showThrobber', function (newVal,oldval) {
                $compile(el.contents())( scope.$new());
            });

            unregisterDataWatch = scope.$watch('data', function (dataValue,oldval) {
                scope.dataError = false;

                // if(dataValue === oldval)
                //   return ;

                if(angular.element("#"+id+'line').highcharts()){
                    angular.element("#"+id+'line').highcharts().destroy();
                }

                //this thing is fastest
                if(dataValue == undefined || dataValue==null || Object.keys(dataValue).length === 0){
                    scope.dataError = true;
                } else {
                    //surely data will be there after ajax success
                    drawComponent(scope,dataValue)
                }

                scope.showError = !scope.showThrobber && scope.dataError;
            });

        });

        function toggleSideBarHandler(){
            line.reflow(id+'line');
        }

        /** This is related to toggle event reflow **/
        $document.on("click", ".toggle-sidebar", toggleSideBarHandler);

        scope.$on('$destroy',function(){

            console.log("vljslib:: LineChart : $destroy called started deregistering the events");

            $document.off('click',toggleSideBarHandler);

            if(angular.element("#"+id+'line').highcharts()){
                angular.element("#"+id+'line').highcharts().destroy();
            }

            if(unregisterDataWatch){
              unregisterDataWatch();
              unregisterDataWatch = null;
            }

            if(unregisterThrobberWatch){
              unregisterThrobberWatch();
              unregisterThrobberWatch = null;
            }
        });

    }

    function isEmptyData(data){
      if(data.xAxisArray.length <= 0)
        return true;

      for(var key in data.seriesData){
        for (var key2 in data.seriesData[key].data)
        {
          if(data.seriesData[key].data[key2] !=null && data.seriesData[key].data[key2] !=undefined)
            return false;
        }
      }
      return true;
    }


    function drawComponent(scope,data){

      var _data  = data;
      var chartId = scope.id;
      // console.log("line chart data", _data);
      if(_data!=null && Object.keys(_data).length !== 0) {
        var  _unit  = (_data.unit == undefined || _data.unit == null) ? vljslibConstants.unitm : _data.unit ;
        scope.title = (_data.title == undefined || _data.title == null) ? vljslibConstants.title : _data.title ;
        if(!isEmptyData(_data)) {
          // scope.dataError = false;
          line.drawLinechart(chartId+'line',_data,_unit);
        }
        else {
            var chart = angular.element("#"+chartId+'line').highcharts();
            if(chart !== undefined){
                if(chart.series !== undefined){
                   while( chart.series.length > 0 ) {
                       chart.series[0].remove( false );
                   }
                   chart.redraw();
                }
            }
           scope.dataError = true;
           if(angular.element("#"+chartId+'line').highcharts() !== undefined)
               angular.element("#"+chartId+'line').highcharts().redraw();
           }
      }
      else scope.dataError = true;
    }
  }


  /**
    * @ngdoc service
    * @name vljslib.line
    * @description
    * # component
    * Service to draw highCharts Line Chart components
  */
  angular
      .module('vljslib')
      .factory('line',line)


  function line(){
    //define variables

    var service = {
      drawLinechart : drawLinechart,
      lineDataFilter :   lineDataFilter,
      reflow: reflow
    };

    return service;

    /**
     * @ngdoc function
     * @name vljslib.line#drawLinechart
     * @module vljslib
     * @kind function
     * @methodOf vljslib.line
     *
     * @description
     * Method to draw highCharts line component
     * #The Data format is
     *<pre>
     *  var data = {
     *     title : '',
     *     legendTitle : '',
     *     xAxisArray : ['col1','col2','col3',.......],
     *     seriesData : [{
     *        name : '',
     *        data : ['1','2','3',....]
     *     },{},.....],
     *
     * }
     *</pre>
     *
     * @example
       <example module="exampleApp">
         <file name="index.html">
           <div ng-controller="ExampleController">
           <p>window.document title: <b ng-bind="title"></b></p>
            <div id="linechart" style="min-width: 310px; height: 400px; margin: 0 auto"></div>


         </file>
       <file name="script.js">
         angular.module('exampleApp', ['vljslib'])
           .controller('ExampleController', ['$scope','line', function($scope,line) {

             $scope.title = "HighCharts Line Chart"
             var data = JSON.parse('{"East Godavari":{"Feb-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":13.563333333333333,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Mar-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":20.64666666666667,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Jun-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":20.66,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Oct-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":25.286666666666665,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Apr-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":23.86,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Dec-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":20.483333333333334,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Jan-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":13.449999999999998,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Aug-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":21.206666666666667,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Aug-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":24.323333333333327,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Sep-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":25.22666666666667,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Nov-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":21.85666666666667,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Jul-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":21.343333333333334,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"May-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":16.666666666666668,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":0,"flowMUIn":0,"flowValueOut":0,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":0,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"}}}');
             var monthsdata = JSON.parse('["Aug-14","Sep-14","Oct-14","Nov-14","Dec-14","Jan-15","Feb-15","Mar-15","Apr-15","May-15","Jun-15","Jul-15","Aug-15"]')
             var _data = line.formatLineData(data,monthsdata,'levelValue1');
             line.drawLinechart('linechart',_data,'Title1','Meters');
         }]);
       </file>
     </example>
     *
     * @param {String} elementId String id passed from div in html
     * @param {Object} data Data to be passed for creating lineChart
     * @param {String} unit of measure
     */

     function getYear(year,month,data){
       if(year && month && data["modifyYear"]){
         if(month=="Jan" || month=="Feb" || month=="Mar"){
           year=parseInt(year)+1;
           year=year.toString()
         }
       }

       return year;
     }

    function drawLinechart(elementId,data,unit){

      if(angular.element("#"+elementId).highcharts()){
          angular.element("#"+elementId).highcharts().destroy();
      }

      var elId = '#'+elementId;
        /*Highcharts.setOptions({
            lang : {
                numericSymbols : [ 'thousands', ' Lakhs', ' Crores' ]
            }
        });*/
    angular.element(elId).highcharts({
        plotOptions: {
          spline: {
              connectNulls: true
          },
          line: {
              connectNulls: true
          },
        },
        credits: {
            enabled: false
        },
        title: {
          text: '',
          x: -20 //center
        },
        xAxis: {
          categories: data.xAxisArray
        },
        yAxis: {
          title: {
            text: unit
          },
          plotLines: [{
            value: 0,
            width: 1,
            color: '#808080'
          }]
        },
        tooltip: {
          valueSuffix: '',
          useHTML: true,
          formatter: function () {
                var x = "<small>"+this.x+"</small><table>";
                x+='<tr><td><span style="color: '+this.series.color+'">●</span> ';
                x+=getYear(this.series.name,this.x,data);
                x+=': </td><td style="text-align: right"><b>'+this.y.toFixed(2)+' </b></td></tr>';
                return x;
            },
          footerFormat: '</table>',
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom',
          borderWidth: 0
        },
        series: data.seriesData
      });




      //angular.element(elId).highcharts().redraw();

    }

    function reflow(elementId){

      var elId = '#'+elementId;

      if(angular.element(elId).length){
         angular.element(elId).highcharts().reflow();

      }

    }

    /** call this function when calling from dropdown **/

    function lineDataFilter(data,param){

       var ids = {};
       var tempdata = {};

       if(data.seriesData){

        var arr = data.seriesData;
        param.forEach(function (bb) { ids[bb] = true; });
        var out = arr.filter(function (val) {
              return ids[val.name]
        });
        //deep copy
        for(var key in data){
              tempdata[key] = data[key];
        }
        tempdata.seriesData = out;
       }

        return tempdata;

   }
}


  angular
      .module('vljslib')
      .directive('vlMultiAxis',vlMultiAxis)

  vlMultiAxis.$inject = ['$timeout','multiAxis','$compile','$document','$templateCache','vljslibConstants'];

  /**
    * @ngdoc directive
    * @name vljslib.directive:vlMultiAxis
    * @description
      * The data format this directive requires is
    *<pre>
    *  var data = {
    *     title : '',
    *     legendTitle : '',
    *     xAxisArray : ['col1','col2','col3',.....],
    *     seriesData : [{
    *       name : 'first',
    *       data : ['1','2','3',...],
    *       tooltip : {valueSuffix : ''},
    *       type : 'column/spline'
    *     },{
    *       .....
    *     }],
    *     yAxisArray : [{
    *        labels : {format : '{value}',style: {color:''}},
    *        title : {style:{color:''},text:''}
    *     },{}]
    * }
    *</pre>
    *#Usage
    *<pre>
    * <vl-multi-axis data="data" throbber="boolean_var" id="gw_bar"></vl-multi-axis>
    *</pre>
    * @restrict E
    * @module vljslib
    * # component
    * @example
      <example module="exampleApp">
        <file name="index.html">
          <div ng-controller="ExampleController">
          <p>window.document title: <b ng-bind="title"></b></p>
           <vl-multi-axis data="data" throbber="gw_barchart" id="gw_bar"></vl-multi-axis>


      </file>

      <file name="script.js">
        angular.module('exampleApp', ['vljslib'])
          .controller('ExampleController', ['$scope','$timeout','multiAxis', function($scope,$timeout,multiAxis) {

            $scope.title = "HighCharts Multi Axis Chart"
            $scope.gw_barchart = true;
            $scope.data ;

            $timeout(function() {
            var data = JSON.parse('{"Donkarayi Dam":{"Feb-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":31.05,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":41.56,"flowMUIn":0,"flowValueOut":30.42,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":54.66,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Mar-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":59.06,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":16.98,"flowMUIn":0,"flowValueOut":26.66,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":62.01,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Jun-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":78.56,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":69.11,"flowMUIn":0,"flowValueOut":12.86,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":53.34,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Oct-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":27.39,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":24.84,"flowMUIn":0,"flowValueOut":32.38,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":59.8,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Apr-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":79.13,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":32.92,"flowMUIn":0,"flowValueOut":23.19,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":50.14,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Dec-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":56.51,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":33.05,"flowMUIn":0,"flowValueOut":45.74,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":51.49,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Jan-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":59.87,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":42.77,"flowMUIn":0,"flowValueOut":26.86,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":57.18,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Aug-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":41.23,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":61.54,"flowMUIn":0,"flowValueOut":20.28,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":60.29,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Aug-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":22.64,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":47.39,"flowMUIn":0,"flowValueOut":38.47,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":47.43,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Sep-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":44.27,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":12.04,"flowMUIn":0,"flowValueOut":8.47,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":56.34,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Nov-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":20.63,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":41.17,"flowMUIn":0,"flowValueOut":51.63,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":59.1,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Jul-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":7.35,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":60.32,"flowMUIn":0,"flowValueOut":9.21,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":64.26,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"May-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":24.2,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":51.41,"flowMUIn":0,"flowValueOut":52.41,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":58,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"}}}');
            var monthdata = JSON.parse('["Aug-14","Sep-14","Oct-14","Nov-14","Dec-14","Jan-15","Feb-15","Mar-15","Apr-15","May-15","Jun-15","Jul-15","Aug-15"]');
            var labelArray = JSON.parse('[{"name":"Storage","type":"column","property":"storageValue1","suffix":"TMC"},{"name":"inflow","type":"spline","property":"flowValueIn","suffix":"cusec"},{"name":"outflow","type":"spline","property":"flowValueOut","suffix":"cusec"}]');
            var _data = multiAxis.formatMultiAxisData(data,monthdata,labelArray,'Donkarayi Dam');
            $scope.data = _data;
                  $scope.gw_barchart = false;
            }, 4000);


        }]);
      </file>
    </example>
    *
    * Directive to draw highCharts components
  */
  function vlMultiAxis($timeout,multiAxis,$compile,$document,$templateCache,vljslibConstants){
    var directive = {
        restrict: 'E',
        template: $templateCache.get('vljslib/multiAxischartTmpl'),
        scope: {
          id: '@',
          class: '@',
          data: '=',
          value: '=',
          showThrobber: '=throbber',
          options: '=',
          nodataimage: '@',
        },
        controller:['$scope',function($scope){
              $scope.nodataimage = angular.isDefined($scope.nodataimage) ? $scope.nodataimage : "img/NoDataImages/DefaultImages/multiAxisChartNoData.png";
        }],
        link: linkFunc,

    };

    return directive;

    function linkFunc(scope, el, attr, ctrl) {

        var unregisterDataWatch;
        var unregisterThrobberWatch;
        var id = scope.id;


      $timeout(function () {

          unregisterThrobberWatch = scope.$watch('showThrobber', function (newVal,oldval) {
              $compile(el.contents())(scope.$new());
          });

          unregisterDataWatch = scope.$watch('data', function (dataValue) {
              scope.dataError = false;
              if(angular.element("#"+id+'max').highcharts()){
                  angular.element("#"+id+'max').highcharts().destroy();
              }
              //this thing is fastest
              if(dataValue == undefined || dataValue==null || Object.keys(dataValue).length === 0){
                  scope.dataError = true;
              }  else {
                  //surely data will be there after ajax success
                  drawComponent(scope,dataValue)
              }

              scope.showError = !scope.showThrobber && scope.dataError;
          });

        });


        function toggleSideBarHandler(){
            multiAxis.reflow(id+'max');
        }

        /** This is related to toggle event reflow **/
        $document.on("click", ".toggle-sidebar", toggleSideBarHandler);

        scope.$on('$destroy',function(){

            console.log("vljslib:: MultiAxis Chart : $destroy called started deregistering the events");

            $document.off('click',toggleSideBarHandler);

            if(angular.element("#"+id+'max').highcharts()){
                angular.element("#"+id+'max').highcharts().destroy();
            }

            if(unregisterDataWatch){
              unregisterDataWatch();
              unregisterDataWatch = null;
            }

            if(unregisterThrobberWatch){
              unregisterThrobberWatch();
              unregisterThrobberWatch = null;
            }
        });
    }

    function isEmptyData(data){
        if(data.xAxisArray.length <= 0)
        return true;

        for(var key in data.seriesData){
            for (var key2 in data.seriesData[key].data) {
                if(data.seriesData[key].data[key2] !== null && data.seriesData[key].data[key2] !== undefined)
                return false;
            }
        }
        return true;
    }

    function drawComponent(scope,data){

        var _data = data;
        var chartId = scope.id;
        if(_data!=null && Object.keys(_data).length !== 0) {
            scope.title = (_data.title == undefined || _data.title == null) ? vljslibConstants.title : _data.title ;
            if(!isEmptyData(_data)) {
                multiAxis.drawMultiaxischart(chartId+'max',_data);
            }
            else {
                var chart = angular.element("#"+chartId+'max').highcharts();

                if(chart !== undefined){
                    if(chart.series !== undefined){
                        while( chart.series.length > 0 ) {
                            chart.series[0].remove( false );
                        }
                        chart.redraw();
                    }
                }

                scope.dataError = true;
                if(angular.element("#"+scope.id+'max').highcharts() !== undefined)
                    angular.element("#"+scope.id+'max').highcharts().redraw();
            }
        }
        else scope.dataError = true;
    }
}


/**
* @ngdoc service
* @name vljslib.multiAxis
* @description
* # component
* Service to draw highCharts Multi Axis components
*/
angular
.module('vljslib')
.factory('multiAxis',multiAxis)


function multiAxis(){
    //define variables

    var service = {
        drawMultiaxischart : drawMultiaxischart,
        reflow : reflow
    };

    return service;

    /**
    * @ngdoc function
    * @name vljslib.multiAxis#drawMultiaxischart
    * @module vljslib
    * @kind function
    * @methodOf vljslib.multiAxis
    *
    * @description
    * Method to draw highCharts Multi Axis Chart component
    * #The Data format is
    *<pre>
    *  var data = {
    *     title : '',
    *     legendTitle : '',
    *     xAxisArray : ['col1','col2','col3',.....],
    *     seriesData : [{
    *       name : 'first',
    *       data : ['1','2','3',...],
    *       tooltip : {valueSuffix : ''},
    *       type : 'column/spline'
    *     },{
    *       .....
    *     }],
    *     yAxisArray : [{
    *        labels : {format : '{value}',style: {color:''}},
    *        title : {style:{color:''},text:''}
    *     },{}]
    * }
    *</pre>
    *
    * @example
    <example module="exampleApp">
    <file name="index.html">
    <div ng-controller="ExampleController">
    <p>window.document title: <b ng-bind="title"></b></p>
    <div id="multiAxis" style="min-width: 310px; height: 400px; margin: 0 auto"></div>


    </file>
    <file name="script.js">
    angular.module('exampleApp', ['vljslib'])
    .controller('ExampleController', ['$scope','multiAxis', function($scope,multiAxis) {

    $scope.title = "HighCharts Stock Bar Chart"
    var data = JSON.parse('{"Donkarayi Dam":{"Feb-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":31.05,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":41.56,"flowMUIn":0,"flowValueOut":30.42,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":54.66,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Mar-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":59.06,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":16.98,"flowMUIn":0,"flowValueOut":26.66,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":62.01,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Jun-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":78.56,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":69.11,"flowMUIn":0,"flowValueOut":12.86,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":53.34,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Oct-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":27.39,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":24.84,"flowMUIn":0,"flowValueOut":32.38,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":59.8,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Apr-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":79.13,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":32.92,"flowMUIn":0,"flowValueOut":23.19,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":50.14,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Dec-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":56.51,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":33.05,"flowMUIn":0,"flowValueOut":45.74,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":51.49,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Jan-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":59.87,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":42.77,"flowMUIn":0,"flowValueOut":26.86,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":57.18,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Aug-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":41.23,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":61.54,"flowMUIn":0,"flowValueOut":20.28,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":60.29,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Aug-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":22.64,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":47.39,"flowMUIn":0,"flowValueOut":38.47,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":47.43,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Sep-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":44.27,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":12.04,"flowMUIn":0,"flowValueOut":8.47,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":56.34,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Nov-14":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":20.63,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":41.17,"flowMUIn":0,"flowValueOut":51.63,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":59.1,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"Jul-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":7.35,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":60.32,"flowMUIn":0,"flowValueOut":9.21,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":64.26,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"},"May-15":{"rawDeviceDataUUID":null,"eventUUID":null,"locationUUID":null,"sourceLocationUUID":null,"sensorUUID":null,"sourceType":0,"eventGenTs":0,"eventReceivedTs":0,"eventValueType":0,"customFloat1":0,"customFloat2":0,"customFloat3":0,"customFloat4":0,"customLong1":0,"customLong2":0,"customLong3":0,"customLong4":0,"customString1":null,"customString2":null,"customString3":null,"customString4":null,"insertTs":0,"updateTs":0,"expirationTs":0,"deleted":0,"userSessionId":0,"waterQuantityEventDataId":0,"levelValue1":24.2,"levelMU1":0,"levelValue2":0,"levelMU2":0,"levelValue3":0,"levelMU3":0,"levelValue4":0,"levelMU4":0,"flowValueIn":51.41,"flowMUIn":0,"flowValueOut":52.41,"flowMUOut":0,"flowValue1":0,"flowMU1":0,"flowValue2":0,"flowMU2":0,"pressureValue1":0,"pressureMU1":0,"pressureValue2":0,"pressureMU2":0,"pressureValue3":0,"pressureMU3":0,"pressureValue4":0,"pressureMU4":0,"storageValue1":58,"storageMU1":0,"storageValue2":0,"storageMU2":0,"storageValue3":0,"storageMU3":0,"storageValue4":0,"storageMU4":0,"levelCode":null,"percentage":0,"minValue":0,"maxValue":0,"waterEventType":"WATER_QUANTITY_EVENT"}}}');
    var monthdata = JSON.parse('["Aug-14","Sep-14","Oct-14","Nov-14","Dec-14","Jan-15","Feb-15","Mar-15","Apr-15","May-15","Jun-15","Jul-15","Aug-15"]');
    var labelArray = JSON.parse('[{"name":"Storage","type":"column","property":"storageValue1","suffix":"TMC"},{"name":"inflow","type":"spline","property":"flowValueIn","suffix":"cusec"},{"name":"outflow","type":"spline","property":"flowValueOut","suffix":"cusec"}]');
    var _data = multiAxis.formatMultiAxisData(data,monthdata,labelArray,'Donkarayi Dam');
    multiAxis.drawMultiaxischart('multiAxis',_data);
}]);
</file>
</example>
*
* @param {String} elementId String id passed from div in html
* @param {Object} data Object as specified above
*/

function drawMultiaxischart(elementId,data){

    if(angular.element("#"+elementId+'max').highcharts()){
        angular.element("#"+elementId+'max').highcharts().destroy();
    }

    var elId = '#'+elementId;

    angular.element(elId).highcharts({
        plotOptions: {
            spline: {
                connectNulls: true
            },
            line: {
                connectNulls: true
            },
        },
        chart: {
            zoomType: 'xy'
        },
        title: {
            text: ''
        },
        subtitle: {
            text: ''
        },
        xAxis: [{
            categories: data.xAxisArray,
            crosshair: true
        }],
        yAxis: data.yAxisArray,
        tooltip: {
            shared: true
        },
        legend: {
            layout: 'horizontal',
            align: 'center',
            verticalAlign: 'bottom',
            borderWidth: 0
        },
        series: data.seriesData
    });



}

function reflow(elementId){

    var elId = '#'+elementId;

    if(angular.element(elId).length){
        angular.element(elId).highcharts().reflow();
    }

}



}



  angular
      .module('vljslib')
      .directive('vlPie',vlPie)

  vlPie.$inject = ['$timeout','pie','$compile','$document','$templateCache','vljslibConstants'];

  /**
    * @ngdoc directive
    * @name vljslib.directive:vlPie
    * @description
     *The data format this directive requires is
    *<pre>
    *  var data = {
    *     title : '',
    *     legendTitle : '',
    *     data : [{
    *       name : '',
    *       color : '',
    *       levelValue : '',
    *     },{
    *       .....
    *     }]
    * }
    *</pre>
    *#Usage
    *<pre>
    * <vl-pie data="data" throbber="boolean_var" id="gw_pie"></vl-pie>
    *</pre>
    * @restrict E
    * @module vljslib
    * # component
    * @example
      <example module="exampleApp">
        <file name="index.html">
          <div ng-controller="ExampleController">
          <p>window.document title: <b ng-bind="title"></b></p>
           <vl-pie data="data" throbber="gw_piechart" id="gw_pie"></vl-pie>


      </file>

      <file name="script.js">
        angular.module('exampleApp', ['vljslib'])
          .controller('ExampleController', ['$scope','$timeout','pie', function($scope,$timeout,pie) {

            $scope.title = "HighCharts Pie Chart"
            $scope.gw_piechart = true;

            var data = JSON.parse('{"title":"Pie Chart Title","legendTitle":"Pie Legend Title","data":{"1":{"name":"0-0.25","color":"#dededd","levelValue":0},"2":{"name":"0.25-25","color":"#d1fcc4","levelValue":0},"3":{"name":"25-65","color":"#97e994","levelValue":0},"4":{"name":"65-125","color":"#2d9d31","levelValue":0},"5":{"name":"125-250","color":"#fda3a5","levelValue":0},"6":{"name":"250-400","color":"#febf02","levelValue":0},"7":{"name":"400-600","color":"#9c34c7","levelValue":0},"8":{"name":"600-1500","color":"#951828","levelValue":0},"9":{"name":"1500-2500","color":"#afa5fc","levelValue":0}}}');
            $scope.data = data;
            $timeout(function() {
                  $scope.gw_piechart = false;
            }, 1000);


        }]);
      </file>
    </example>
    *
    * Directive to draw highCharts components
  */
  function vlPie($timeout,pie,$compile,$document,$templateCache,vljslibConstants){
    var directive = {
        restrict: 'EA',
        template: $templateCache.get('vljslib/piechartTmpl'),
        scope: {
          id: '@',
          class: '@',
          data: '=',
          value: '=',
          showThrobber: '=throbber',
          options: '=',
          nodataimage: '@',
        },
        controller:['$scope',function($scope){
              $scope.nodataimage = angular.isDefined($scope.nodataimage) ? $scope.nodataimage : "img/NoDataImages/DefaultImages/piChartNoData.png";
        }],
        link: linkFunc,

    };

    return directive;

    function linkFunc(scope, el, attr, ctrl) {

      var throbberl = attr.showthrobber;
      var unregisterDataWatch;
      var unregisterThrobberWatch;
      var id = scope.id;

      $timeout(function () {

          unregisterThrobberWatch = scope.$watch('showThrobber', function (newVal,oldval) {
            $compile(el.contents())(scope.$new());
          });

          unregisterDataWatch = scope.$watch('data', function (dataValue) {
              scope.dataError = false;
              if(angular.element("#"+id+'pie').highcharts()){
                  angular.element("#"+id+'pie').highcharts().destroy();
              }
              //this thing is fastest
              if(dataValue == undefined || dataValue==null || Object.keys(dataValue).length === 0){
                scope.dataError = true;
              } else {
                //surely data will be there after ajax success
                drawComponent(scope,dataValue)
              }

              scope.showError = !scope.showThrobber && scope.dataError;
          })
        })

        function toggleSideBarHandler(){
            pie.reflow(id+'pie');
        }

        /** This is related to toggle event reflow **/
        $document.on("click", ".toggle-sidebar", toggleSideBarHandler);

        scope.$on('$destroy',function(){

          console.log("vljslib:: PieChart : $destroy called started deregistering the events");

          $document.off('click',toggleSideBarHandler);

          if(angular.element("#"+id+'pie').highcharts()){
              angular.element("#"+id+'pie').highcharts().destroy();
          }

          if(unregisterDataWatch){
            unregisterDataWatch();
            unregisterDataWatch = null;
          }

          if(unregisterThrobberWatch){
            unregisterThrobberWatch();
            unregisterThrobberWatch = null;
          }
      })

    }


    function drawComponent(scope,data){
      var _data       = pie.formatPieData(data);
      var chartId     = scope.id;
      if(_data!=null && Object.keys(_data).length !== 0) {
          var _lgTitle    = (_data.legendTitle == undefined || _data.legendTitle == null) ? vljslibConstants.legendTitle : _data.legendTitle ;
          scope.title = (_data.title == undefined || _data.title == null) ? vljslibConstants.title : _data.title ;
          if(_data.data!=null && Object.keys(_data.data).length !== 0) {
            scope.dataError = false;
            pie.drawPiechart(chartId+'pie',_data.data,_lgTitle);
          } else {
	 	          var chart = angular.element("#"+chartId+'pie').highcharts();
              if(chart !== undefined){
                  if(chart.series !== undefined){
                      while( chart.series.length > 0 ) {
	                        chart.series[0].remove( false );
                      }
                      chart.redraw();
                  }
               }
               scope.dataError = true;
		           if(angular.element("#"+chartId+'pie').highcharts() !== undefined)
		               angular.element("#"+chartId+'pie').highcharts().redraw();
	             }
      }
      else scope.dataError = true;
    }
  }


  /**
    * @ngdoc service
    * @name vljslib.pie
    * @description
    * # component
    * Service to draw highCharts pie components
  */
  angular
      .module('vljslib')
      .factory('pie',pie)


  function pie(){
    //define variables

    var service = {
      drawPiechart : drawPiechart,
      formatPieData : formatPieData,
      reflow: reflow
    };

    return service;

    /**
     * @ngdoc function
     * @name vljslib.pie#formatPieData
     * @module vljslib
     * @kind function
     * @methodOf vljslib.pie
     *
     * @description
     * Method to format data for pieChart component
     *
     * @param {Object}  Data DataSource of pieChart
     * @return {Object} Formatted Data
     **/
     function formatPieData(data){

       var _data = {};

       _data.data = [];
       _data.title = data.title;
       _data.legendTitle = data.legendTitle;

       for(var val in data.data){
         var obj = {};
         obj.color = data.data[val].color;
         obj.y = data.data[val].levelValue;
         obj.name = data.data[val].name;
         _data.data.push(obj);
       }

       return _data;
     }


    /**
     * @ngdoc function
     * @name vljslib.pie#drawPiechart
     * @module vljslib
     * @kind function
     * @methodOf vljslib.pie
     *
     * @description
     * Method to draw highCharts pie component
     * #The Data format is
     *<pre>
     *  var data = {
     *     title : '',
     *     legendTitle : '',
     *     data : [{
     *       name : '',
     *       color : '',
     *       levelValue : '',
     *     },{
     *       .....
     *     }]
     * }
     *</pre>
     *
     * @example
       <example module="exampleApp">
         <file name="index.html">
           <div ng-controller="ExampleController">
           <p>window.document title: <b ng-bind="title"></b></p>
            <div id="piechart" style="min-width: 310px; height: 400px; margin: 0 auto"></div>


         </file>
       <file name="script.js">
         angular.module('exampleApp', ['vljslib'])
           .controller('ExampleController', ['$scope','pie', function($scope,pie) {

             $scope.title = "HighCharts Pie Chart"
             var data = JSON.parse('{"1":{"name":"<2m","color":"#0000FF","levelValue":8.2},"2":{"name":"2m-5m","color":"#73b2ff","levelValue":8.2},"3":{"name":"5m-10m","color":"#38a700","levelValue":16.39},"4":{"name":"10m-20m","color":"#ffaa01","levelValue":50.82},"5":{"name":">20m","color":"#fe0000","levelValue":16.39}}');
             var _data = pie.formatPieData(data);
             pie.drawPiechart('piechart',_data,'Fluctuation in Meters');
         }]);
       </file>
     </example>
     *
     * @param {String} elementId String id passed from div in html
     * @param {Object} data Data as specified above
     * @param {String} legendTitle legendTitle
     */

    function drawPiechart(elementId,data,legendTitle){

      if(angular.element("#"+elementId).highcharts()){
          angular.element("#"+elementId).highcharts().destroy();
      }

      angular.element("#"+elementId).highcharts({
        chart: {
          alignTicks: true,
          animation: true,
          type: 'pie',
          options3d: {
            enabled: true,
            alpha: 57,
            beta: 0
          },
        },
        title: {
          text: ''
        },
        tooltip: {
          pointFormat: ' <b>{point.percentage:.0f}%</b>'
        },
        plotOptions: {
          pie: {
            shadow:true,
            allowPointSelect: true,
            cursor: 'pointer',
            borderColor: "#FFFFFF",
            borderWidth: 2,
            innerSize: 100,
            depth: 45,
            showInLegend: true,
            dataLabels: {
              enabled: true,
              format: "{point.percentage:.0f}%"
            }
          }
        },
        legend: {
          title: {
            text: '<div style="width:500px">'+legendTitle+'</div>',
            style: {
              fontStyle: 'italic',
              textAlign: '100%'
            },
            useHTML:true
          }
        },
        series: [{
          type: 'pie',
          name: 'Regions',
          data: data,
          slicedOffset: 20
        }]
      });



    }

    function reflow(elementId){

      var elId = '#'+elementId;

      if(angular.element(elId).length){
         angular.element(elId).highcharts().reflow();
      }

    }




  }


  angular
      .module('vljslib')
      .directive('vlStackBar',vlStackBar)

  vlStackBar.$inject = ['$timeout','stackBar','$compile','$document','$templateCache','vljslibConstants'];

  /**
    * @ngdoc directive
    * @name vljslib.directive:vlStackBar
    * @description
    * The data format this directive requires is
    *<pre>
    *  $scope.data = {
    *     title : '',
    *     legendTitle : '',
    *     xAxisArray : ['col1','col2','col3',.....],
    *     seriesData : [{
    *       name : 'first',
    *       color: '',
    *       data : ['1','2','3',....]
    *     },{
    *       .....
    *     }]
    * }
    *</pre>
    *#Usage
    *<pre>
    * <vl-stack-bar data="data" throbber="boolean_var" id="gw_bar"></vl-stack-bar>
    *</pre>
    * @restrict E
    * @module vljslib
    * # component
    * @example
      <example module="exampleApp">
        <file name="index.html">
          <div ng-controller="ExampleController">
          <p>window.document title: <b ng-bind="title"></b></p>
           <vl-stack-bar data="data" throbber="gw_barchart" id="gw_bar"></vl-stack-bar>


      </file>

      <file name="script.js">
        angular.module('exampleApp', ['vljslib'])
          .controller('ExampleController', ['$scope','$timeout','stackBar', function($scope,$timeout,stackBar) {

            $scope.title = "HighCharts Stock Bar Chart"
            $scope.gw_barchart = true;


            $timeout(function() {
            var data = JSON.parse('{"title":null,"legendTitle":"Fluctuation In Meters","xAxisArray":["East Godavari","Kadapa","Anantapur","Nellore","West Godavari","Srikakulam","Chittoor","Kurnool","Krishna","Visakhapatnam","Prakasam","Vizianagaram","Guntur"],"seriesData":[{"name":"<2m","color":"#0000FF","data":[0,0,33.33,25,0,50,0,20,20,20,0,20,0]},{"name":"2m-5m","color":"#73b2ff","data":[0,0,16.67,0,60,0,0,0,20,0,0,0,40]},{"name":"5m-10m","color":"#38a700","data":[0,0,16.67,50,20,0,40,0,0,20,60,0,0]},{"name":"10m-20m","color":"#ffaa01","data":[100,80,33.33,25,0,50,40,60,40,60,40,60,60]},{"name":">20m","color":"#fe0000","data":[0,20,0,0,20,0,20,20,20,0,0,20,0]}]}');
            $scope.data = data;
                  $scope.gw_barchart = false;
            }, 4000);


        }]);
      </file>
    </example>
    *
    * Directive to draw highCharts components
  */
  function vlStackBar($timeout,stackBar,$compile,$document,$templateCache,vljslibConstants){
    var directive = {
        restrict: 'E',
        transclude: true,
        template: $templateCache.get('vljslib/stackBarchartTmpl'),
        scope: {
          id: '@',
          class: '@',
          data: '=',
          value: '=',
          showThrobber: '=throbber',
          options: '=',
          nodataimage: '@',
        },
        controller:['$scope',function($scope){
              $scope.nodataimage = angular.isDefined($scope.nodataimage) ? $scope.nodataimage : "img/NoDataImages/DefaultImages/stackBarChartNoData.png";
        }],
        link: linkFunc,

    };

    return directive;

    function linkFunc(scope, el, attr, ctrl) {

      var throbberl = attr.showthrobber;
      var unregisterDataWatch;
      var unregisterThrobberWatch;
      var id = scope.id;

      $timeout(function () {

          unregisterThrobberWatch =  scope.$watch('showThrobber', function (newVal,oldval) {
             $compile(el.contents())(scope.$new());
          });

          unregisterDataWatch = scope.$watch('data', function (dataValue) {

            scope.dataError = false;
            if(angular.element("#"+id+'bar').highcharts()){
                angular.element("#"+id+'bar').highcharts().destroy();
            }
            //this thing is fastest
            if(dataValue == undefined || dataValue==null || Object.keys(dataValue).length === 0){
              scope.dataError = true;
            } else {
              //surely data will be there after ajax success
              drawComponent(scope,dataValue)
            }

            scope.showError = !scope.showThrobber && scope.dataError;
          }
        );

        });

        function toggleSideBarHandler(){
          stackBar.reflow(id+'bar');
        }

        /** This is related to toggle event reflow **/
        $document.on("click", ".toggle-sidebar", toggleSideBarHandler);

        scope.$on('$destroy',function(){

          console.log("vljslib:: StackBarchart : $destroy called started deregistering the events");

          $document.off('click',toggleSideBarHandler);

          if(angular.element("#"+id+'bar').highcharts()){
              angular.element("#"+id+'bar').highcharts().destroy();
          }

          if(unregisterDataWatch){
            unregisterDataWatch();
            unregisterDataWatch = null;
          }

          if(unregisterThrobberWatch){
            unregisterThrobberWatch();
            unregisterThrobberWatch = null;
          }
        })

    }

   function isEmptyData(data){
      if(data.xAxisArray==null || data.xAxisArray.length <= 0)
        return true;

      for(var key in data.seriesData) {
        for (var key2 in data.seriesData[key].data) {
          if(data.seriesData[key].data[key2] !=null && data.seriesData[key].data[key2] !=undefined)
            return false;
        }
      }

      return true;
    }


    function drawComponent(scope,data){

      var _data = data;
      var chartId = scope.id;

      if(_data!=null && Object.keys(_data).length !== 0) {
	        var _lgTitle  = (_data.legendTitle == undefined || _data.legendTitle == null) ? vljslibConstants.legendTitle : _data.legendTitle ;
	        scope.title = (_data.title == undefined || _data.title == null) ? vljslibConstants.title : _data.title ;
	        if(!isEmptyData( _data )) {
              scope.dataError = false;
		          stackBar.drawBarchart(chartId+'bar',_data,_lgTitle);
	        } else {
              var chart = angular.element("#"+chartId+'bar').highcharts();
		          if(chart !== undefined) {
		             if(chart.series !== undefined) {
		                 while(chart.series.length > 0) {
			                   chart.series[0].remove( false );
		                 }
		                 chart.redraw();
		             }
		          }

		          scope.dataError = true;
		          if(angular.element("#"+chartId+'bar').highcharts() !== undefined)
		              angular.element("#"+chartId+'bar').highcharts().redraw();
		     }
      }
      else scope.dataError = true;
    }
  }


  /**
    * @ngdoc service
    * @name vljslib.stackBar
    * @description
    * # component
    * Service to draw highCharts stackBar components
  */
  angular
      .module('vljslib')
      .factory('stackBar',stackBar)


  function stackBar(){
    //define variables

    var service = {
      drawBarchart : drawBarchart,
      formatBarData : formatBarData,
      reflow : reflow
    };

    return service;

    /**
     * @ngdoc function
     * @name vljslib.stackBar#formatBarData
     * @module vljslib
     * @kind function
     * @methodOf vljslib.stackBar
     *
     * @description
     * Method to format data for stack barchart component

     * @param {Object}  Data DataSource for stackedBarChart
     * @return {Object} Formatted Data
     **/
     function formatBarData(data){
       return data;
     }


    /**
     * @ngdoc function
     * @name vljslib.stackBar#drawBarchart
     * @module vljslib
     * @kind function
     * @methodOf vljslib.stackBar
     *
     * @description
     * Method to draw highCharts stackedBarChart component
     * #The Data format is
     *<pre>
     *  var data = {
     *     title : '',
     *     legendTitle : '',
     *     xAxisArray : ['col1','col2','col3',.....],
     *     seriesData : [{
     *       name : 'first',
     *       color: '',
     *       data : ['1','2','3',....]
     *     },{
     *       .....
     *     }]
     * }
     *</pre>
     *
     * @example
       <example module="exampleApp">
         <file name="index.html">
           <div ng-controller="ExampleController">
           <p>window.document title: <b ng-bind="title"></b></p>
            <div id="barchart" style="min-width: 310px; height: 400px; margin: 0 auto"></div>


         </file>
       <file name="script.js">
         angular.module('exampleApp', ['vljslib'])
           .controller('ExampleController', ['$scope','stackBar', function($scope,stackBar) {

             $scope.title = "HighCharts Stock Bar Chart"
             var data = JSON.parse('{"xAxisArray":["East Godavari","Kadapa","Anantapur","Nellore","West Godavari","Srikakulam","Chittoor","Kurnool","Krishna","Visakhapatnam","Prakasam","Vizianagaram","Guntur"],"seriesData":[{"name":"<2m","color":"#0000FF","data":[0,0,33.33,25,0,50,0,20,20,20,0,20,0]},{"name":"2m-5m","color":"#73b2ff","data":[0,0,16.67,0,60,0,0,0,20,0,0,0,40]},{"name":"5m-10m","color":"#38a700","data":[0,0,16.67,50,20,0,40,0,0,20,60,0,0]},{"name":"10m-20m","color":"#ffaa01","data":[100,80,33.33,25,0,50,40,60,40,60,40,60,60]},{"name":">20m","color":"#fe0000","data":[0,20,0,0,20,0,20,20,20,0,0,20,0]}]}');
             stackBar.drawBarchart('barchart',data,'Fluctuation in Meters');
         }]);
       </file>
     </example>
     *
     * @param {String} elementId String id passed from div in html
     * @param {Object} data Object as specified above
     * @param {String} legendTitle legendTitle
     */

    function drawBarchart(elementId,data,legendTitle){

      if(angular.element("#"+elementId).highcharts()){
          angular.element("#"+elementId).highcharts().destroy();
      }

      var elId = '#'+elementId;

      angular.element(elId).highcharts({
        chart: {
          type: 'column',
        },
        title: {
          text: '<br>',
          useHTML:true,
        },
        xAxis: {
          categories: data.xAxisArray,
        },
        yAxis: {
          min: 0,
          title: {
            text: null
          }
        },
        tooltip: {
          pointFormat: '<span style="color:{series.color}">{series.name} : <b></b> {point.percentage:.0f}%</span><br/>',
          shared: true
        },
        plotOptions: {
          column: {
            stacking: 'percent',
            depth: 25,
            shadow: {
              width: 5,
              offsetX:2,
              offsetY:2,
              opacity:0.2
            }
          }
        },legend: {
          align: 'center',
          title: {
            text: '<span style="text-align:center">'+legendTitle+'</span>',
            style: {
              fontStyle: 'italic'
            },
            useHTML:true,
          }
        },
        series: data.seriesData
      });



    }

    function reflow(elementId){

      var elId = '#'+elementId;

      if(angular.element(elId).length){
         angular.element(elId).highcharts().reflow();
      }

    }



  }
})(window, window.angular);

(function () {
    'use strict';

    angular
        .module('madApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('madApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'JhiTrackerService'];

    function Principal ($q, Account, JhiTrackerService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                // JhiTrackerService.connect();
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'JhiTrackerService'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, JhiTrackerService) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data && $rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    // JhiTrackerService.sendActivity();
                    deferred.resolve(data);
                });
                deferred.resolve(data);
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('home',{
                parent : 'app',
                url : '/',
                redirectTo : 'vl.dashboards.revenue'
            })
/*            .state('home', {
                parent: 'app',
                url: '/',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/home.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })*/
            // .state('zone', {
            //     parent: 'app',
            //     url: '/:type/:id',
            //     //reloadOnSearch: false,
            //     data: {
            //         authorities: ['ROLE_USER']
            //     },
            //     params : {fromDate:null, toDate:null},
            //     views: {
            //         'content@': {
            //             templateUrl: 'app/home/home.html',
            //             controller: 'HomeController',
            //             controllerAs: 'vm'
            //         }
            //     },
            //     resolve: {
            //         mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
            //             $translatePartialLoader.addPart('home');
            //             return $translate.refresh();
            //         }]
            //     }
            // });
    }

    // angular
    //     .module('madApp')
    //     .directive('revenueSummary', revenueSummaryDirective)
    //
    // revenueSummaryDirective.$inject = [];
    //
    // function revenueSummaryDirective() {
    //     var directive = {
    //         restrict: 'A',
    //         templateUrl: 'app/home/summary.html',
    //         scope: {
    //             title: "@title",
    //             icon: "&icon",
    //             summary: "=summary"
    //         },
    //         link: linkFunc,
    //         controller: 'RevenueSummaryDirectiveController',
    //
    //     };
    //
    //     return directive;
    //
    //     function linkFunc(scope, element, attrs) {
    //         scope.icon = attrs.icon;
    //         scope.title = attrs.title;
    //     }
    // }
    //
    // angular
    //     .module('madApp')
    //     .controller('RevenueSummaryDirectiveController', RevenueSummaryDirectiveController)
    // ;
    //
    // RevenueSummaryDirectiveController.$inject = ['$scope', '$state', '$stateParams', '$filter', 'ParseLinks', 'AlertService'];
    // function RevenueSummaryDirectiveController($scope, $state, $stateParams, $filter, ParseLinks, AlertService) {
    //     var rsdc = this;
    //     rsdc.name = "test";
    // }
    //
    // angular
    //     .module('madApp')
    //     .directive('revenueDetail', revenueDetailDirective);
    //
    //
    //
    // function revenueDetailDirective() {
    //     var directive = {
    //         restrict: 'A',
    //         templateUrl: 'app/home/revenue.detail.template.html',
    //         link: linkFunc,
    //         controller: 'RevenueDetailDirectiveController',
    //         scope: {
    //             title: "@title",
    //             icon: "&icon",
    //             chartData: "=chartData",
    //             revenueDetails: "=revenueDetails",
    //             summary: "=summary",
    //             totalSummary: "=totalSummary",
    //             ulbList: '=ulbList',
    //             chartopt:"=chartopt",
    //             graphid:"=graphId",
    //             key:"=key",
    //             type:"=type",
    //             callfunc:"&callfunc"
    //         }
    //
    //     };
    //     return directive;
    //
    //
    //     function linkFunc(scope, element, attrs) {
    //         scope.icon = attrs.icon;
    //         scope.title = attrs.title;
    //     }
    //
    // }
    //
    // angular
    //     .module('madApp')
    //     .controller('RevenueDetailDirectiveController', RevenueDetailDirectiveController)
    // ;
    //
    // RevenueDetailDirectiveController.$inject = ['$scope', '$state', '$stateParams', '$filter', '$translate', '$translatePartialLoader', 'ParseLinks', 'AlertService','StateRevenueService'];
    // function RevenueDetailDirectiveController($scope, $state, $stateParams, $filter, $translate, $translatePartialLoader, ParseLinks, AlertService, StateRevenueService) {
    //     $translatePartialLoader.addPart('vassar');
    //     $translate.refresh();
    //     /**
    //      * Mont constant, fixed to April of this year
    //      *
    //      * @type {Date}
    //      */
    //     var minMonth = new Date();
    //     minMonth.setMonth(3); //TODO: Constant - make it configurable
    //     minMonth.setDate(1);
    //     /**
    //      * Query data to be populated from the UI.
    //      * @type {{fromDate: null, toDate: null, gradeType: string, grade: null, selectedULB: null}}
    //      */
    //     $scope.queryData = {
    //         fromDate: null,
    //         toDate: null,
    //         gradeType: 'district',
    //         grade: null,
    //         selectedULB: null
    //     };
    //
    //     $scope.formHidden = true;
    //     /**
    //      * toggle form
    //      */
    //     $scope.toggleForm = function () {
    //         $scope.formHidden = !$scope.formHidden;
    //     };
    //     // Date picker format
    //     $scope.format = 'shortDate';
    //     $scope.fromDate = {
    //         opened: false
    //     };
    //
    //     $scope.toDate = {
    //         opened: false
    //     };
    //     /**
    //      * From date picker configuration
    //      * @type {{minDate: Date, maxDate: Date, datepickerMode: string, maxMode: string, minMode: string}}
    //      */
    //     $scope.fromDateOptions = {
    //         minDate: minMonth,
    //         maxDate: new Date(),
    //         datepickerMode: 'day',
    //         maxMode: 'day',
    //         minMode: 'day'
    //     };
    //     /**
    //      * To date picker configuration
    //      * @type {{minDate: Date, maxDate: Date, datepickerMode: string, maxMode: string, minMode: string}}
    //      */
    //     $scope.toDateOptions = {
    //         minDate: $scope.queryData.fromDate || minMonth,
    //         maxDate: new Date(),
    //         datepickerMode: 'day',
    //         maxMode: 'day',
    //         minMode: 'day'
    //     };
    //     /**
    //      * Open from-date date-picker popup.
    //      */
    //     $scope.fromDatePickerOpen = function () {
    //         $scope.fromDate.opened = true;
    //     };
    //     /**
    //      * Open the to-date date-picker popup.
    //      */
    //     $scope.toDatePickerOpen = function () {
    //         $scope.toDate.opened = true;
    //     };
    //
    //
    //     $scope.$watch('queryData.fromDate', function (newValue, oldValue) {
    //         if (newValue) {
    //             $scope.toDateOptions.minDate = newValue;
    //         }
    //     });
    //
    //     $scope.$watch('queryData.gradeType', function (newValue, oldValue) {
    //         if (newValue) {
    //             $scope.queryData.grade = null;
    //             $scope.queryData.selectedULB = null;
    //         }
    //     });
    //     $scope.$watch('queryData.grade', function (newValue, oldValue) {
    //         if (newValue) {
    //             $scope.queryData.selectedULB = null;
    //         }
    //     });
    //
    //     /**
    //      * Get all ULB for based on selected Grade and Grade-Type
    //      * @returns {*}
    //      */
    //     $scope.getULBForGrade = function () {
    //         var searchFilter = {};
    //         searchFilter[$scope.queryData.gradeType] = $scope.queryData.grade;
    //         return $filter('filter')($scope.ulbList, searchFilter);
    //
    //     };
    //     /**
    //      * Get labels for null option, sets a new value based on the gradeType selected
    //      * @returns {*}
    //      */
    //     $scope.getDefaultGradeTypeLabel = function () {
    //         if ('district' === $scope.queryData.gradeType) return $filter('translate')('vassar.directives.revenue.detail.option.label.All Districts');
    //         if ('region' === $scope.queryData.gradeType) return $filter('translate')('vassar.directives.revenue.detail.option.label.All Regions');
    //         if ('grade' === $scope.queryData.gradeType) return $filter('translate')('vassar.directives.revenue.detail.option.label.All ULB Types');
    //     };
    //
    //     /**
    //      * Process request
    //      */
    //
    //     $scope.submit = function () {
    //         if($scope.queryData.selectedULB){
    //           $state.go('zone', {id: $scope.queryData.selectedULB,type:"ULB",
    //               fromDate:$scope.queryData.fromDate.toLocaleDateString(),
    //               toDate:$scope.queryData.toDate},{notify:false, reload:false});
    //             $scope.callfunc({key:$scope.queryData.selectedULB,type:"ULB",
    //                 from:$scope.queryData.fromDate,to:$scope.queryData.toDate
    //             });
    //         }
    //         else {
    //           $state.go('zone', {
    //               id: $scope.queryData.grade, type: $scope.queryData.gradeType.toUpperCase(),
    //               fromDate: $scope.queryData.fromDate,
    //               toDate: $scope.queryData.toDate},{notify:false, reload:false});
    //             $scope.callfunc({key:$scope.queryData.grade,type:$scope.queryData.gradeType.toUpperCase(),
    //                 from:$scope.queryData.fromDate,to:$scope.queryData.toDate
    //             });
    //
    //         }
    //     };
    //
    //     $scope.send = function (type,key) {
    //         if(type && key){
    //             $state.go('zone', {id: key,type:type},{notify:false, reload:false});
    //         }
    //         else {
    //             $state.go('home', {},{notify:false, reload:false});
    //         }
    //         $scope.callfunc({key:key,type:type})
    //     };
    //
    //     $scope.call2 = function (key,type) {
    //         $scope.callfunc({key:key,type:type})
    //     };
    //
    //
    //     $scope.getULBGradeDesc = function (ulbGrade) {
    //         if(ulbGrade === "I") return "Grade I";
    //         else if(ulbGrade === "II") return "Grade II";
    //         else if(ulbGrade === "III") return "Grade III";
    //         else if(ulbGrade === "NP") return "Nagar Panchayat";
    //         else if(ulbGrade === "Special") return "Special Grade";
    //         else if(ulbGrade === "Corp") return "Corporation";
    //         else return ulbGrade;
    //     };
    //
    // }

    // angular
    //     .module('madApp')
    //     .directive('collectionSummary', collectionSummaryDirective);
    //
    // function collectionSummaryDirective() {
    //     var directive = {
    //         restrict: 'A',
    //         scope: {
    //             title: "@title",
    //             totalSummary: "=totalSummary"
    //         },
    //         controller: CollectionSummaryDirectiveController,
    //         templateUrl: 'app/home/collection.summary.template.html',
    //         link: linkFunc,
    //
    //
    //     };
    //
    //     return directive;
    //
    //     function linkFunc(scope, element, attrs) {
    //         //scope.title = attrs.title;
    //         //scope.trend = attrs.summary;
    //     }
    // }
    //
    // angular
    //     .module('madApp')
    //     .controller('CollectionSummaryDirectiveController', CollectionSummaryDirectiveController)
    // ;
    //
    // CollectionSummaryDirectiveController.$inject = ['$scope', '$state', '$stateParams', '$filter', 'ParseLinks', 'AlertService'];
    // function CollectionSummaryDirectiveController($scope, $state, $stateParams, $filter, ParseLinks, AlertService) {
    //     $scope.parseFloat = parseFloat;
    // }
    //
    //
    // angular
    //     .module('madApp')
    //     .directive('revenueTable', revenueTableDirective);
    //
    // function revenueTableDirective() {
    //     var directive = {
    //         restrict: 'A',
    //         templateUrl: 'app/home/revenuetable.template.html',
    //         link: linkFunc,
    //         controller: 'RevenueTableDirectiveController',
    //         scope: {
    //             //title: "@title",
    //             details: "=details",
    //             totalSummary: "=totalSummary",
    //             callfunc:"&callfunc"
    //         }
    //     };
    //
    //     return directive;
    //
    //     function linkFunc(scope, element, attrs) {
    //         //scope.title = attrs.title;
    //         //scope.revenue = attrs.summary;
    //     }
    // }

    // angular
    //     .module('madApp')
    //     .controller('RevenueTableDirectiveController', RevenueTableDirectiveController)
    // ;
    //
    // RevenueTableDirectiveController.$inject = ['$scope', '$state', '$stateParams', '$filter', 'ParseLinks', 'AlertService','StateRevenueService',];
    // function RevenueTableDirectiveController($scope, $state, $stateParams, $filter, ParseLinks, AlertService, StateRevenueService) {
    //     $scope.parseFloat = parseFloat;
    //
    //     $scope.submit = function (key) {
    //          $state.go('zone', {id: key,type:$scope.details.locType},{notify:false, reload:false});
    //          $scope.callfunc({key: key,type:$scope.details.locType})
    //         //$state.go('zone', {id: key,type:$scope.details.locType});
    //     };
    //
    //
    //     $scope.compare = function (v1,v2) {
    //         // console.log(a);
    //         // console.log(b);
    //         //return a.value < b.value;
    //         if (v1.type !== 'string' || v2.type !== 'string') {
    //             return (v1.index < v2.index) ? -1 : 1;
    //         }
    //
    //         // Compare strings alphabetically, taking locale into account
    //         return v1.value.localeCompare(v2.value);
    //         //return 1;
    //     //| orderBy:'this['+record.sortIndex+'].value':record.sortOrder:compare
    //         //ng-click="setSortOrder($index,$parent.$index)"
    //     };
    //
    //     $scope.setSortOrder = function(index,parentIndex){
    //         if($scope.details.records[parentIndex].sortIndex ===index){
    //             $scope.details.records[parentIndex].sortOrder = !$scope.details.records[parentIndex].sortOrder;
    //         }else{
    //             $scope.details.records[parentIndex].sortOrder = false;
    //         }
    //         $scope.details.records[parentIndex].sortIndex = index;
    //     };
    // }



})();

(function () {
    'use strict';


    angular
        .module('madApp')
        .factory('StateRevenueService', StateRevenueService);

    StateRevenueService.$inject = ['$resource'];

    function StateRevenueService($resource) {

        var service = {
            getStateSummariesData: getStateSummariesData,
            getChildCollectionData:getChildCollectionData,
            getAllULBData:getAllULBData,
            getChildDCBData:getChildDCBData,
            getCollectionTableData:getCollectionTableData,
            getChildReceiptsData:getChildReceiptsData,
            getTop10Data:getTop10Data,
            getBottom10Data:getBottom10Data,
            getTop100DefaultersData:getTop100DefaultersData
        };
        return service;

        function getStateSummariesData() {
            var resourceUrl = 'api/stateSummaries';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET', isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }


        function getChildCollectionData() {
            var resourceUrl = 'api/childCollectionData';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET', isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

        function getChildDCBData() {
            var resourceUrl = 'api/childDCBData';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET', isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

        function getChildReceiptsData() {
            var resourceUrl = 'api/childReceiptsData';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET', isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

        function getTop10Data() {
            var resourceUrl = 'api/top10Data';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET', isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

        function getTop100DefaultersData() {
            var resourceUrl = 'api/top100DefaultersData';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET', isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

        function getBottom10Data() {
            var resourceUrl = 'api/bottom10Data';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET', isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

        function getAllULBData() {
            var resourceUrl = 'api/getAllULBData';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET', isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

        function getCollectionTableData() {
            var resourceUrl = 'api/collectionTableData';

            return $resource(resourceUrl, {}, {
                'query': {
                    method: 'GET', isArray: false,
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                }
            });
        }

    };


    angular
        .module('madApp')
        .controller('HomeController', HomeController)
        .filter('positive', function() {
            return function(input) {
                if (!input) {
                    return 0;
                }

                return Math.abs(input);
            };
        })
        .filter( 'camelCase', function () {
           return function ( input )
            {
                if (input) {
                    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
                }

            };

        })
        .filter( 'getLastYear', function () {
            return function ( input )
            {
                if (input) {
                    var start = new Date(input);
                    var y = start.getFullYear();
                    return start.setFullYear(y-1);
                }

            };

        });

    var activetab = 0;

    HomeController.$inject = ['$scope','Principal', 'LoginService', 'StateRevenueService', 'AlertService', '$state', '$filter'];

    function HomeController($scope,Principal, LoginService, StateRevenueService, AlertService, $state, $filter) {
        var vm = this;
        vm.account = null;
        vm.isAuthenticated = null;
        // vm.login = LoginService.open;
        // vm.register = register;
        vm.stateSummaryData = {};
        vm.collectionTrendData ={};
        vm.collectionTotalSummary ={};
        vm.collectionTableData ={};
        vm.ulbList = [];
        vm.firstcall = 0;

        // $scope.$on('authenticationSuccess', function () {
        //     getAccount();
        // });
        //
        // getAccount();
        // stateSummary();
        // getAllULBData();

        // $scope.setActiveTab = function(input){
        //     $state.params.fromDate=null;
        //     $state.params.toDate=null;
        //     if(vm.firstcall != 0){
        //       $state.params.id=null;
        //       $state.params.type=null;
        //       $state.go('home', {},{notify:false, reload:false});
        //     }
        //     if(input===0)
        //         $scope.callCollection();
        //     else if(input===1)
        //         $scope.callDCB();
        //     else if(input===2)
        //         $scope.callreceipts();
        //     else if(input===3)
        //         $scope.calltop10();
        //     else if(input===4)
        //         $scope.callbottom10();
        //     else if(input===5)
        //         $scope.calldefaulters();
        //     activetab = input;
        //
        // };

        // $scope.getActiveTab = function(){
        //     return activetab;
        // };
        //
        // function setdates(from,to){
        //     if (from) {
        //         $state.params.fromDate = from;
        //     }
        //     if (to) {
        //         $state.params.toDate =  to;
        //     }
        // }

        // $scope.callCollection =function(key,type,from,to){
        //     setdates(from,to);
        //     collectionData(key,type);
        // };
        // $scope.callDCB =function(key,type,from,to){
        //     setdates(from,to);
        //     dcbData(key,type);
        // };
        // $scope.callreceipts =function(key,type,from,to){
        //     setdates(from,to);
        //     receiptsData(key,type);
        // };
        // $scope.calltop10 =function(key,type,from,to){
        //     setdates(from,to);
        //     top10Data(key,type);
        // };
        // $scope.callbottom10 =function(key,type,from,to){
        //     setdates(from,to);
        //     bottom10Data(key,type);
        // };
        // $scope.calldefaulters =function(key,type,from,to){
        //     setdates(from,to);
        //     top100DefaultersData(key,type);
        // };


        function getAccount() {

            // Principal.identity().then(function (account) {
            //     vm.account = account;
            //     vm.isAuthenticated = Principal.isAuthenticated;
            // });
            //stateSummary();
            //getAllULBData();
            // collectionData();
            // dcbData();
            // receiptsData();
            // top10Data();
            // bottom10Data();
            // top100DefaultersData();
        }

        function stateSummary() {
            StateRevenueService.getStateSummariesData().query(null, onSuccess, onError);
            function onSuccess(data) {
                vm.stateSummaryData = {
                    formattedDate: $filter('date')(data.calculatedOn, "dd-MMM-yyyy"),
                    formattedTime: $filter('date')(data.calculatedOn, "hh:mm a"),
                    totalRevenueAmount: ($filter('number')(data.totalRevenueCollected.amount)),
                    totalRevenueUnit: "Crs",
                    propertyTax: {
                        collected: {
                            amount: ($filter('number')(data.propertyTax.collected.amount)),
                            amountUnit: 'Crs',
                            variance: (data.propertyTax.varianceOverLastYear),
                            achievement: (data.propertyTax.achievementPercent)
                        },
                        lastYear: {
                            amount: ($filter('number')(data.propertyTax.collectedLastYear.amount)),
                            amountUnit: 'Crs'
                        },
                        target: {amount: ($filter('number')(data.propertyTax.target.amount)), amountUnit: 'Crs'}
                    },
                    waterCharges: {
                        collected: {
                            amount: ($filter('number')(data.waterCharges.collected.amount)),
                            amountUnit: 'Crs',
                            variance: (data.waterCharges.varianceOverLastYear),
                            achievement: (data.waterCharges.achievementPercent)
                        },
                        lastYear: {
                            amount: ($filter('number')(data.waterCharges.collectedLastYear.amount)),
                            amountUnit: 'Crs'
                        },
                        target: {amount: ($filter('number')(data.waterCharges.target.amount)), amountUnit: 'Crs'}

                    },
                    others: {
                        collected: {
                            amount: ($filter('number')(data.others.collected.amount)),
                            amountUnit: 'Crs',
                            variance: (data.others.varianceOverLastYear),
                            achievement: (data.others.achievementPercent)
                        },
                        lastYear: {
                            amount: ($filter('number')(data.others.collectedLastYear.amount)),
                            amountUnit: 'Crs'
                        },
                        target: {amount: ($filter('number')(data.others.target.amount)), amountUnit: 'Crs'}
                     }
                };

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

        }

        function convertDateTimezone(input){
            if(input){
                var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
                var localISOTime = (new Date(input - tzoffset)).toISOString();
                return localISOTime;
            }else{
                return input;
            }

        }

        function collectionData(key,type) {
            var query = {};

            if ($state.params.id && vm.firstcall === 0) {
                query.locKey = $state.params.id;
            }
            if ($state.params.type && vm.firstcall === 0) {
                query.locationType = $state.params.type;
            }
            if ($state.params.fromDate) {
                query.fromDate = convertDateTimezone($state.params.fromDate);
            }
            if ($state.params.toDate) {
                query.toDate =  convertDateTimezone($state.params.toDate);
            }

            if (type) {
                query.locationType = type;
            }
            if (key) {
                query.locKey = key;
            }

            StateRevenueService.getChildCollectionData().query(query, onSuccess, onError);
            function onSuccess(data) {
                vm.collid="coll_line";
                if (data.revenueRecords) {
                    vm.revenueRecords = data.revenueRecords;
                }
                vm.collectionTrendData = {
                    formattedFromDate: $filter('date')(data.trendData.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.trendData.toDate, "dd-MMM-yyyy"),
                    monthArray: ['Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
                    chartData: data.trendData.chartData
                };
                vm.collectionTotalSummary ={
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy"),
                    totalSummary:data.totalSummary
                };
                vm.collectionTableData = {
                    records:data.revenueRecords,
                    locType:data.locationType,
                    formattedFromDate: data.fromDate,
                    formattedToDate: data.toDate,
                };
                vm.colloptions= {
                    xAxisArray: ['Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
                    seriesData: data.trendData.chartData
                };
                vm.collkey=  query.locKey;
                vm.colltype = query.locationType;
                vm.firstcall+=1;

            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.firstcall+=1;
            }

        }

        function getAllULBData() {
            if ($state.params.id && $state.params.type) {
                vm.key=  $state.params.id;
                vm.type = $state.params.type;
            }
            StateRevenueService.getAllULBData().query(null, onSuccess, onError);
            function onSuccess(data) {
                if(data.data){
                    vm.ulbList = data.data;
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function dcbData(key,type) {
            var query = {};
            if ($state.params.id && vm.firstcall === 0) {
                query.locKey = $state.params.id;
            }
            if ($state.params.type && vm.firstcall === 0) {
                query.locationType = $state.params.type;
            }
            if ($state.params.fromDate) {
                query.fromDate = convertDateTimezone($state.params.fromDate);
            }
            if ($state.params.toDate) {
                query.toDate =  convertDateTimezone($state.params.toDate);
            }

            if (type) {
                query.locationType = type;
            }
            if (key) {
                query.locKey = key;
            }

            StateRevenueService.getChildDCBData().query(query, onSuccess, onError);
            function onSuccess(data) {
                vm.dcbid="dcb_line";
                if (data.revenueRecords) {
                    vm.dcbRecords = data.revenueRecords;
                }
                vm.dcbTrendData = {
                    formattedFromDate: $filter('date')(data.trendData.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.trendData.toDate, "dd-MMM-yyyy"),
                    monthArray: ['Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
                    chartData: data.trendData.chartData
                };
                vm.dcbTotalSummary ={
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy"),
                    totalSummary:data.totalSummary
                };
                vm.dcbTableData = {
                    records:data.revenueRecords,
                    locType:data.locationType,
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy")
                };
                vm.dcboptions= {
                    xAxisArray: ['Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
                    seriesData: data.trendData.chartData
                    // seriesData: [
                    //     {name: "2016", data: [7.0, 6.9, 33.2, 2.5, 33.6, 88.2, null, null, null, null, null, null]},
                    //     {name: "2015", data: [0.2, 0.8, 5.7, 11.3, 17.0, 22.0, 24.8, 24.1, 20.1, 14.1, 8.6, 2.5]},
                    //     {name: "2014", data: [0.9, 0.6, 3.5, 8.4, 13.5, 17.0, 18.6, 17.9, 14.3, 9.0, 3.9, 1.0]}
                    // ]
                }
                vm.dcbkey=  query.locKey;
                vm.dcbtype = query.locationType;

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

        }

        function receiptsData(key,type) {
            var query = {};

            if ($state.params.id && vm.firstcall === 0) {
                query.locKey = $state.params.id;
            }
            if ($state.params.type && vm.firstcall === 0) {
                query.locationType = $state.params.type;
            }
            if ($state.params.fromDate) {
                query.fromDate = convertDateTimezone($state.params.fromDate);
            }
            if ($state.params.toDate) {
                query.toDate =  convertDateTimezone($state.params.toDate);
            }

            if (type) {
                query.locationType = type;
            }
            if (key) {
                query.locKey = key;
            }
            StateRevenueService.getChildReceiptsData().query(query, onSuccess, onError);
            function onSuccess(data) {
                vm.receiptsid="receipts_line";
                if (data.revenueRecords) {
                    vm.receiptsRecords = data.revenueRecords;
                }
                vm.receiptsTrendData = {
                    formattedFromDate: $filter('date')(data.trendData.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.trendData.toDate, "dd-MMM-yyyy"),
                    monthArray: ['Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
                    chartData: data.trendData.chartData
                };
                vm.receiptsTotalSummary ={
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy"),
                    totalSummary:data.totalSummary
                };
                vm.receiptsTableData = {
                    records:data.revenueRecords,
                    locType:data.locationType,
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy")
                };
                vm.receiptsoptions= {
                    xAxisArray: ['Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
                    seriesData: data.trendData.chartData
                };

                vm.receiptskey=  query.locKey;
                vm.receiptstype = query.locationType;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

        }

        function top10Data(key,type) {
            var query = {};

            if ($state.params.id && vm.firstcall === 0) {
                query.locKey = $state.params.id;
            }
            if ($state.params.type && vm.firstcall === 0) {
                query.locationType = $state.params.type;
            }
            if ($state.params.fromDate) {
                query.fromDate = convertDateTimezone($state.params.fromDate);
            }
            if ($state.params.toDate) {
                query.toDate =  convertDateTimezone($state.params.toDate);
            }

            if (type) {
                query.locationType = type;
            }
            if (key) {
                query.locKey = key;
            }
            StateRevenueService.getTop10Data().query(query, onSuccess, onError);
            function onSuccess(data) {
                if (data.receiptsRecords) {
                    vm.top10Records = data.revenueRecords;
                }
                vm.top10TrendData = {};
                vm.top10TotalSummary ={};
                vm.top10TableData = {
                    records:data.revenueRecords,
                    locType:data.locationType,
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy"),
                };
                vm.top10options= {}
                vm.top10key=  query.locKey;
                vm.top10type = query.locationType;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

        }

        function bottom10Data(key,type) {
            var query = {};

            if ($state.params.id && vm.firstcall === 0) {
                query.locKey = $state.params.id;
            }
            if ($state.params.type && vm.firstcall === 0) {
                query.locationType = $state.params.type;
            }
            if ($state.params.fromDate) {
                query.fromDate = convertDateTimezone($state.params.fromDate);
            }
            if ($state.params.toDate) {
                query.toDate =  convertDateTimezone($state.params.toDate);
            }

            if (type) {
                query.locationType = type;
            }
            if (key) {
                query.locKey = key;
            }
            StateRevenueService.getBottom10Data().query(query, onSuccess, onError);
            function onSuccess(data) {
                if (data.bottom10Records) {
                    vm.bottom10Records = data.revenueRecords;
                }
                vm.bottom10TrendData = {};
                vm.bottom10TotalSummary ={};
                vm.bottom10TableData = {
                    records:data.revenueRecords,
                    locType:data.locationType,
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy")
                };
                vm.bottom10options= {}
                vm.bottom10key=  query.locKey;
                vm.bottom10type = query.locationType;

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

        }

        function top100DefaultersData(key,type) {
            var query = {};

            if ($state.params.id && vm.firstcall === 0) {
                query.locKey = $state.params.id;
            }
            if ($state.params.type && vm.firstcall === 0) {
                query.locationType = $state.params.type;
            }
            if ($state.params.fromDate) {
                query.fromDate = convertDateTimezone($state.params.fromDate);
            }
            if ($state.params.toDate) {
                query.toDate =  convertDateTimezone($state.params.toDate);
            }

            if (type) {
                query.locationType = type;
            }
            if (key) {
                query.locKey = key;
            }
            StateRevenueService.getTop100DefaultersData().query(query, onSuccess, onError);
            function onSuccess(data) {
                if (data.receiptsRecords) {
                    vm.top100DefaultersRecords = data.revenueRecords;
                }
                vm.top100DefaultersTrendData = {};
                vm.top100DefaultersTotalSummary ={};
                vm.top100DefaultersTableData = {
                    records:data.revenueRecords,
                    locType:data.locationType,
                    formattedFromDate: $filter('date')(data.fromDate, "dd-MMM-yyyy"),
                    formattedToDate: $filter('date')(data.toDate, "dd-MMM-yyyy")
                };
                vm.top100Defaultersoptions= {}
                vm.top100Defaulterskey=  query.locKey;
                vm.top100Defaulterstype = query.locationType;

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

        }


        function register() {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('madApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('madApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('madApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('madApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = "";
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = "";

        //$timeout(function (){angular.element('#username').focus();});
        // login();
        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('madApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('madApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('madApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('madApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-madApp-error');
                var entityKey = httpResponse.headers('X-madApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('madApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('madApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-madApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-madApp-params')});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('madApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data && toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('madApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function () {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);


    stateConfig.$inject = ['$stateProvider', '$locationProvider'];

    function stateConfig($stateProvider, $locationProvider) {
        //$locationProvider.html5Mode({enabled: true, requireBase: true});
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        //return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('madApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-tracker', {
            parent: 'admin',
            url: '/tracker',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tracker.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/tracker/tracker.html',
                    controller: 'JhiTrackerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tracker');
                    return $translate.refresh();
                }]
            },
            onEnter: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.subscribe();
            }],
            onExit: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.unsubscribe();
            }]
        });
    }
})();

(function() {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('madApp')
        .factory('JhiTrackerService', JhiTrackerService);

    JhiTrackerService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q', 'AuthServerProvider'];

    function JhiTrackerService ($rootScope, $window, $cookies, $http, $q, AuthServerProvider) {
        var stompClient = null;
        var subscriber = null;
        var listener = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            sendActivity: sendActivity,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect () {
            //building absolute path so that websocket doesnt fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket/tracker';
            var authToken = AuthServerProvider.getToken();
            if(authToken){
                url += '?access_token=' + authToken;
            }
            var socket = new SockJS(url);
            stompClient = Stomp.over(socket);
            var stateChangeStart;
            var headers = {};
            stompClient.connect(headers, function() {
                connected.resolve('success');
                sendActivity();
                if (!alreadyConnectedOnce) {
                    stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
                        sendActivity();
                    });
                    alreadyConnectedOnce = true;
                }
            });
            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
            });
        }

        function disconnect () {
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
        }

        function receive () {
            return listener.promise;
        }

        function sendActivity() {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/activity',
                    {},
                    angular.toJson({'page': $rootScope.toState.name}));
            }
        }

        function subscribe () {
            connected.promise.then(function() {
                subscriber = stompClient.subscribe('/topic/tracker', function(data) {
                    listener.notify(angular.fromJson(data.body));
                });
            }, null, null);
        }

        function unsubscribe () {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('madApp')
        .controller('JhiTrackerController', JhiTrackerController);

    JhiTrackerController.$inject = ['$cookies', '$http', 'JhiTrackerService'];

    function JhiTrackerController ($cookies, $http, JhiTrackerService) {
        // This controller uses a Websocket connection to receive user activities in real-time.
        var vm = this;

        vm.activities = [];

        JhiTrackerService.receive().then(null, null, function(activity) {
            showActivity(activity);
        });

        function showActivity(activity) {
            var existingActivity = false;
            for (var index = 0; index < vm.activities.length; index++) {
                if(vm.activities[index].sessionId === activity.sessionId) {
                    existingActivity = true;
                    if (activity.page === 'logout') {
                        vm.activities.splice(index, 1);
                    } else {
                        vm.activities[index] = activity;
                    }
                }
            }
            if (!existingActivity && (activity.page !== 'logout')) {
                vm.activities.push(activity);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey,
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('madApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('madApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('madApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('madApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/collection.summary.template.html','<div class="col-md-6 col-xs-12 dashboard-maincontent grid-block"><div class="panel ng-isolate-scope clearfix p20" style="height: 514px"><h4 ng-repeat="head in totalSummary.totalSummary.headers" class="irrigation-h4" style="margin-bottom: 5px">{{\'home.table.title\' |translate:head }}<br>{{\'home.table.sub-title\' |translate:head }} : <span class="ng-binding" ng-show="head.dataType === \'CUMULATIVE\'">{{totalSummary.totalSummary.recordData[$index][0].value | currency}} Crs ({{totalSummary.totalSummary.recordData[$index][1].value | number:2 }}%) , ( {{totalSummary.totalSummary.recordData[$index][2].value | number:2 | positive}}% <span ng-show="parseFloat(totalSummary.totalSummary.recordData[$index][2].value) > 0"><i style="color: rgb(14, 150, 0)" class="fa fa-long-arrow-up" aria-hidden="true"></i> )</span><!--TODO : Get a new color ode when negative --> <span ng-show="parseFloat(totalSummary.totalSummary.recordData[$index][2].value) < 0"><i style="color:red" class="fa fa-long-arrow-down" aria-hidden="true"></i> )</span> <span ng-show="parseFloat(totalSummary.totalSummary.recordData[$index][2].value) === 0"><i style="color: rgb(0,0,0);" class="fa fa-arrows-h" aria-hidden="true"></i> )</span> </span><span class="ng-binding" ng-show="head.dataType === \'CUMMNUM\'">{{totalSummary.totalSummary.recordData[$index][0].value}} ( {{totalSummary.totalSummary.recordData[$index][1].value | number:2 | positive}}% <span ng-show="parseFloat(totalSummary.totalSummary.recordData[$index][1].value) > 0"><i style="color: rgb(14, 150, 0)" class="fa fa-long-arrow-up" aria-hidden="true"></i> )</span><!--TODO : Get a new color ode when negative --> <span ng-show="parseFloat(totalSummary.totalSummary.recordData[$index][1].value) < 0"><i style="color:red" class="fa fa-long-arrow-down" aria-hidden="true"></i> )</span> <span ng-show="parseFloat(totalSummary.totalSummary.recordData[$index][1].value) === 0"><i style="color: rgb(0,0,0);" class="fa fa-arrows-h" aria-hidden="true"></i> )</span> </span><span class="ng-binding" ng-show="head.dataType === \'NUMBER\'">{{totalSummary.totalSummary.recordData[$index][0].value}} </span><span class="ng-binding" ng-show="head.dataType === \'CURRENCY\'">{{totalSummary.totalSummary.recordData[$index][0].value | currency}} Crs</span></h4><div class="legends text-right mt15"><span><i aria-hidden="true" class="fa fa-long-arrow-up" style="color: rgb(14, 150, 0)"></i> Increase from last year</span> <span><i style="color:red" class="fa fa-long-arrow-down" aria-hidden="true"></i> Decrease from last year</span> <span><i style="color:black" class="fa fa-arrows-h" aria-hidden="true"></i> No Change from last year</span></div></div></div>');
$templateCache.put('app/home/home.html','<div class="jumbotron p20"><h1 style="font-size:2.1em; line-height:150%"><center class="ng-binding">{{ \'home.State Revenue Collected Title\' | translate }}<br>{{ \'home.State Revenue as of\' | translate:vm.stateSummaryData }} : <b>{{ \'home.Total Revenue\' | translate:vm.stateSummaryData}}</b></center></h1></div><!--<pre class="row well">{{vm.stateParams}}</pre>--><div revenue-summary icon="property-tax" title="{{\'home.section.property-tax.title\' | translate}}" summary="vm.stateSummaryData.propertyTax"></div><div revenue-summary icon="water-charge" title="{{\'home.section.water-charge.title\' | translate}}" summary="vm.stateSummaryData.waterCharges"></div><!--<div revenue-summary icon="others" title="{{\'home.section.others.title\' | translate}}" summary="vm.stateSummaryData.others"></div>--><div class="col-lg-12" ng-init="indextab = getActiveTab()" ng-hide="vm.firstcall===0"><uib-tabset active="indextab"><uib-tab index="0" select="setActiveTab(0)"><uib-tab-heading><z data-translate="home.tabs.collections.title">Collections</z></uib-tab-heading><div revenue-detail title="{{\'home.chart title\' | translate}}" chart-data="vm.collectionTrendData" chartopt="vm.colloptions" revenue-details="vm.collectionTableData" total-summary="vm.collectionTotalSummary" ulb-list="vm.ulbList" graph-id="vm.collid" key="vm.collkey" type="vm.colltype" callfunc="callCollection(key,type,from,to)"></div></uib-tab><!--<uib-tab index="$index + 1" ng-repeat="tab in tabs" heading="{{tab.title}}" disable="tab.disabled">\n            {{tab.content}}\n        </uib-tab>--><uib-tab index="1" select="setActiveTab(1)"><uib-tab-heading>DCB</uib-tab-heading><div revenue-detail title="{{\'home.chart title\' | translate}}" chart-data="vm.dcbTrendData" chartopt="vm.dcboptions" revenue-details="vm.dcbTableData" total-summary="vm.dcbTotalSummary" ulb-list="vm.ulbList" graph-id="vm.dcbid" key="vm.dcbkey" type="vm.dcbtype" callfunc="callDCB(key,type,from,to)"></div></uib-tab><uib-tab index="2" select="setActiveTab(2)"><uib-tab-heading>Receipts</uib-tab-heading><div revenue-detail title="{{\'home.receipt chart title\' | translate}}" chart-data="vm.receiptsTrendData" chartopt="vm.receiptsoptions" revenue-details="vm.receiptsTableData" total-summary="vm.receiptsTotalSummary" ulb-list="vm.ulbList" graph-id="vm.receiptsid" key="vm.receiptskey" type="vm.receiptstype" callfunc="callreceipts(key,type,from,to)"></div></uib-tab><uib-tab index="3" select="setActiveTab(3)"><uib-tab-heading>Top 10</uib-tab-heading><div revenue-detail title="{{\'home.chart title\' | translate}}" chart-data="vm.top10TrendData" chartopt="vm.top10options" revenue-details="vm.top10TableData" total-summary="vm.top10TotalSummary" ulb-list="vm.ulbList" graph-id="vm.top10id" key="vm.top10key" type="vm.top10type" callfunc="calltop10(key,type,from,to)"></div></uib-tab><uib-tab index="4" select="setActiveTab(4)"><uib-tab-heading>Bottom 10</uib-tab-heading><div revenue-detail title="{{\'home.chart title\' | translate}}" chart-data="vm.bottom10TrendData" chartopt="vm.bottom10options" revenue-details="vm.bottom10TableData" total-summary="vm.bottom10TotalSummary" ulb-list="vm.ulbList" graph-id="vm.bottom10id" key="vm.bottom10key" type="vm.bottom10type" callfunc="callbottom10(key,type,from,to)"></div></uib-tab><uib-tab index="5" select="setActiveTab(5)"><uib-tab-heading>Top 100 Defaulters</uib-tab-heading><div revenue-detail title="{{\'home.chart title\' | translate}}" chart-data="vm.top100DefaultersTrendData" chartopt="vm.top100Defaultersoptions" revenue-details="vm.top100DefaultersTableData" total-summary="vm.btop100DefaultersTotalSummary" ulb-list="vm.ulbList" graph-id="vm.top100Defaultersid" key="vm.top100Defaulterskey" type="vm.top100Defaulterstype" callfunc="calldefaulters(key,type,from,to)"></div></uib-tab></uib-tabset></div><!-- <div collection-highchart title="{{\'home.chart title\' | translate}}" summary="collectionTrend()"></div>\n<div revenue-table summary="vm.collectionTrendData"></div> -->');
$templateCache.put('app/home/revenue.detail.template.html','<div class="no-p col-lg-12"><!---- button space ----><div style="text-align:left; box-shadow:none; line-height:240%" class="breadcrumb mi-breadcum col-md-12"><h4 style="font-size:15px" class="ng-binding ng-scope pull-left">State : <b class="ng-binding" ng-click="send()">ANDHRA PRADESH</b></h4><h4 style="font-size:15px" class="ng-binding ng-scope pull-left ml10" ng-show="type && key">{{type}} : <b class="ng-binding" ng-click="send(type,key)">{{key}}</b></h4><button class="btn btn-primary pull-right" style="font-size:14px" id="filter_togle" ng-click="toggleForm()"><i class="fa fa-hourglass-end" aria-hidden="true"></i> Filter</button></div><!---- button space end ----><!---- form space ----><form ng-submit="submit()"><div class="clearfix" id="filter_box" ng-hide="formHidden"><div class="col-md-2"><div><label data-translate="vassar.directives.revenue.detail.form.control.label.Top Level View">Top Level View</label></div><div class="form-group"><select class="form-control" ng-model="queryData.gradeType"><option value="district" data-translate="vassar.directives.revenue.detail.option.label.district">District</option><option value="region" data-translate="vassar.directives.revenue.detail.option.label.region">Region</option><option value="grade" data-translate="vassar.directives.revenue.detail.option.label.grade">ULB Type</option></select></div></div><div class="col-md-5"><div><label data-translate="vassar.directives.revenue.detail.form.control.label.Select Region">Select Region</label></div><div class="col-md-5 no-p mr10"><div class="form-group"><select class="form-control" ng-model="queryData.grade" ng-disabled="!(queryData.gradeType)"><option ng-selected="!(queryData.grade)" value="">{{getDefaultGradeTypeLabel()}}</option><option ng-show="\'district\' === queryData.gradeType" ng-repeat="option in ulbList | unique: queryData.gradeType" value="{{option[queryData.gradeType]}}">{{option[queryData.gradeType]}}</option><option ng-show="\'grade\' === queryData.gradeType && option[queryData.gradeType] !==\'Selecti\' && option[queryData.gradeType] !==\'Selection\'" ng-repeat="option in ulbList | unique: queryData.gradeType" value="{{option[queryData.gradeType]}}">{{getULBGradeDesc(option[queryData.gradeType])}}</option><option ng-show="\'region\' === queryData.gradeType" ng-repeat="option in ulbList | unique: queryData.gradeType" value="{{option[queryData.gradeType]}}">{{option[queryData.gradeType]}}</option></select></div></div><div class="col-md-5 no-p"><div class="form-group"><select class="form-control" ng-model="queryData.selectedULB" ng-disabled="!(queryData.grade)||\'\'== queryData.grade"><option ng-selected="!(queryData.selectedULB)" value="">All ULBs</option><option ng-repeat="option in getULBForGrade()" value="{{option.ulbCode}}">{{option.city}}</option></select></div></div></div><div class="col-md-4" ng-show="graphid !== undefined"><div><label data-translate="vassar.directives.revenue.detail.form.control.label.Select Month Range">Select Month Range</label></div><div class="col-md-5 no-p"><div class="input-group"><input type="text" readonly="readonly" class="form-control" uib-datepicker-popup="{{format}}" ng-model="queryData.fromDate" is-open="fromDate.opened" datepicker-options="fromDateOptions" ng-required="true" close-text="Close"><div class="input-group-btn"><button type="button" class="btn btn-default" ng-click="fromDatePickerOpen()"><i class="glyphicon glyphicon-calendar"></i></button></div></div></div><div class="col-md-2 no-p text-center mt5">To</div><div class="col-md-5 no-p"><div class="input-group"><input type="text" class="form-control" readonly="readonly" uib-datepicker-popup="{{format}}" ng-model="queryData.toDate" is-open="toDate.opened" datepicker-options="toDateOptions" ng-required="true" close-text="Close"><div class="input-group-btn"><button type="button" class="btn btn-default" ng-click="toDatePickerOpen()"><i class="glyphicon glyphicon-calendar"></i></button></div></div></div></div><div class="col-md-1"><div><label>&nbsp;&nbsp;&nbsp;</label></div><button style="font-size:14px" class="btn btn-primary pull-right"><i aria-hidden="true" class="fa fa-hourglass-end"></i><z>Submit</z></button><!--<button type="submit" style="font-size:14px;" class="btn btn-primary pull-right"><i aria-hidden="true" class="fa fa-hourglass-end"></i> Submit</button>\n            --></div></div></form><!---- form space end ----></div><div class="clearfix"></div><!-- Revenue Details --><div class="DCB_menu mt25 clearfix"><!--Summary overview and charts --><!--<ul class="tabs14" ng-show="graphid === \'dcb_line\'">--><!--<li><a >Total</a></li>--><!--<li><a >Private</a></li>--><!--<li><a >State Govt</a></li>--><!--<li><a >Central Govt</a></li>--><!--</ul>--><div class="col-md-12 mt20 no-p" ng-show="graphid !== undefined"><div collection-summary total-summary="totalSummary"></div><div class="col-lg=6"><div class="col-md-6 col-xs-12 dashboard-maincontent grid-block"><div class="panel ng-isolate-scope clearfix p20"><strong class="no-m text-center mb20">{{title}}<br>{{ \'home.chart range\' | translate:chartData}} </strong><!-- <vl-line data="chartopt" id={{graphid}} class="no-shadow" nodataimage="#" ></vl-line> --></div></div></div></div><!-- Tabular Data --><div class="col-12"><div revenue-table details="revenueDetails" total-summary="totalSummary" callfunc="call2(key,type)"></div></div></div>');
$templateCache.put('app/home/revenuetable.template.html','<div class="col-md-12 no-p"><div class="panel-body sm_no_p pb0"><div class="ng-scope"><div ng-repeat="record in details.records track by $index" class="table-responsive no-m ng-scope dashboard-maincontent"><strong style="text-transform:none;font-weight: 600;font-size: 17px;color: #4472c4" class="no-m ng-binding">{{record.tableHeading}}</strong><table class="table table-striped table-bordered responsive no-m ng-scope"><thead><tr><th width="8%" style="vertical-align:middle">S.No<br></th><th style="text-align:center; vertical-align:middle" ng-repeat="header in record.headers">{{\'home.table.title\' |translate:header }}<br>{{\'home.table.sub-title\' |translate:header }}<!--<span ><img style="width: 24px;" src="data:image/gif;base64,R0lGODlhFQAJAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAkAAAIXjI+AywnaYnhUMoqt3gZXPmVg94yJVQAAOw=="></span>--></th></tr></thead><tbody><tr ng-class-even="\'ng-scope ws_odd\'" ng-class-odd="\'ws_odd\'" class="ng-scope ws_odd" ng-repeat="tableData in record.recordData"><td class="ng-binding">{{$index + 1}}</td><td class="ng-binding ng-scope" ng-repeat="dat in tableData"><span ng-show="record.headers[$index].dataType === \'LOCATION\'"><p ng-click="submit(dat.key)">{{dat.value}}</p></span><span ng-show="record.headers[$index].dataType === \'FINALLOCATION\'">{{dat.value}} </span><span ng-show="record.headers[$index].dataType === \'NUMBER\'">{{dat.value |number}} </span><span ng-show="record.headers[$index].dataType === \'CURRENCY\'">{{dat.value |currency}} </span><span ng-show="record.headers[$index].dataType === \'PERCENTAGE\'">{{dat.value |number:2}}% </span><span ng-show="record.headers[$index].dataType === \'VARIANCE\'">{{dat.value | number:2 | positive}}% <span ng-show="parseFloat(dat.value) > 0"><i style="color: rgb(14, 150, 0)" class="fa fa-long-arrow-up" aria-hidden="true"></i> </span><!--TODO : Get a new color ode when negative --> <span ng-show="parseFloat(dat.value) < 0"><i style="color:red" class="fa fa-long-arrow-down" aria-hidden="true"></i> </span><span ng-show="parseFloat(dat.value) === 0"><i style="color: rgb(0,0,0);" class="fa fa-arrows-h" aria-hidden="true"></i></span></span></td></tr><tr ng-class-even="\'ng-scope ws_odd\'" ng-class-odd="\'ws_odd\'" class="ng-scope ws_odd"><td class="ng-binding"></td><td class="ng-binding ng-scope" ng-repeat="dat in record.totalData"><span ng-show="record.headers[$index].dataType === \'LOCATION\'"><a ng-click="submit(dat.key)">{{dat.value}}</a> </span><span ng-show="record.headers[$index].dataType === \'FINALLOCATION\'">{{dat.value}} </span><span ng-show="record.headers[$index].dataType === \'NUMBER\'">{{dat.value|number}} </span><span ng-show="record.headers[$index].dataType === \'CURRENCY\'">{{dat.value |currency}} </span><span ng-show="record.headers[$index].dataType === \'PERCENTAGE\'">{{dat.value |number}}% </span><span ng-show="record.headers[$index].dataType === \'VARIANCE\'">{{dat.value | number:2 | positive}}% <span ng-show="parseFloat(dat.value) > 0"><i style="color: rgb(14, 150, 0)" class="fa fa-long-arrow-up" aria-hidden="true"></i> </span><!--TODO : Get a new color ode when negative --> <span ng-show="parseFloat(dat.value) < 0"><i style="color:red" class="fa fa-long-arrow-down" aria-hidden="true"></i> </span><span ng-show="parseFloat(dat.value) === 0"><i style="color: rgb(0,0,0);" class="fa fa-arrows-h" aria-hidden="true"></i></span></span></td></tr></tbody></table><div class="legends text-right mt15"><span><i aria-hidden="true" class="fa fa-long-arrow-up" style="color: rgb(14, 150, 0)"></i> Increase from last year</span> <span><i style="color:red" class="fa fa-long-arrow-down" aria-hidden="true"></i> Decrease from last year</span> <span><i style="color:black" class="fa fa-arrows-h" aria-hidden="true"></i> No Change from last year</span></div></div></div></div></div>');
$templateCache.put('app/home/summary.html','<div class="col-md-6 col-xs-12 main_tab"><div class="grid-block col-md-12 bi-map-block-bdr sm_no_p"><section class="panel" ng-class="{\'active\': title === \'Property Tax\'}"><div class="panel-body sm_no_p no-p bal_d no-m-xs"><header class="col-md-12 h4 no-m no-p grid-block"><div class="col-sm-12 pl0 mb10"><span class="no-m ng-binding" style="text-transform:none; line-height:270%" ng-show="icon === \'property-tax\'"><img src="/content/images/property-tax.png" class="pull-left"> &nbsp;&nbsp;&nbsp;{{title}}</span></div><div class="col-sm-12 pl0 mb10"><span class="no-m ng-binding" style="text-transform:none; line-height:270%" ng-show="icon === \'water-charge\'"><img src="/content/images/water-charge.png" class="pull-left" ng-show="icon === \'water-charge\'"> &nbsp;&nbsp;&nbsp;{{title}}</span></div></header><div class="col-sm-12 no-p"><div class="table-responsive ng-scope" style="border: 0px solid #c5c5c5"><table class="table table-striped table-bordered responsive no-m ng-scope"><tbody><tr style="" class="ng-scope ws_odd" ng-class-odd="\'ws_odd\'" ng-class-even="\'ws_even\'"><td style="text-align:left" data-translate="home.section.common.label.collected"></td><td style="text-align:left">{{ \'home.section.common.revenue\' | translate:summary.collected}} ({{summary.collected.variance | number:2| positive}}% <span ng-show="summary.collected.variance > 0"><i style="color: rgb(14, 150, 0)" class="fa fa-long-arrow-up" aria-hidden="true" ng-show="[summary.collected.variance > 0]"></i> )</span><!--TODO : Get a new color ode when negative --> <span ng-show="summary.collected.variance < 0"><i style="color:red" class="fa fa-long-arrow-down" aria-hidden="true" ng-show="[summary.collected.variance < 0]"></i> )</span> <span ng-show="summary.collected.variance === 0"><i style="color: rgb(0,0,0);" class="fa fa-arrows-h" aria-hidden="true"></i> )</span></td></tr><tr class="ng-scope ws_even" ng-class-odd="\'ws_odd\'" ng-class-even="\'ws_even\'"><td style="text-align:left" data-translate="home.section.common.label.target">aaaa</td><td style="text-align:left">{{ \'home.section.common.target\' | translate:summary.target}}</td></tr><tr style="" class="ng-scope ws_odd" ng-class-odd="\'ws_odd\'" ng-class-even="\'ws_even\'"><td style="text-align:left" data-translate="home.section.common.label.lastYear">Last Year</td><td style="text-align:left">{{ \'home.section.common.lastYear\' | translate:summary.lastYear}}</td></tr></tbody></table></div></div></div></section></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.ehcache.title">Ehcache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.ehcache.cachename">Cache name</th><th class="text-right" data-translate="metrics.ehcache.objects">Objects</th><th class="text-right" data-translate="metrics.ehcache.hits">Hits</th><th class="text-right" data-translate="metrics.ehcache.misses">Misses</th><th class="text-right" data-translate="metrics.ehcache.evictioncount">Eviction count</th><th class="text-right" data-translate="metrics.ehcache.mean">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/tracker/tracker.html','<div><h2 data-translate="tracker.title">Real-time user activities</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="tracker.table.userlogin">User</th><th data-translate="tracker.table.ipaddress">IP Address</th><th data-translate="tracker.table.page">Current page</th><th data-translate="tracker.table.time">Time</th><th></th></tr></thead><tbody><tr ng-repeat="activity in vm.activities"><td>{{activity.userLogin}}</td><td>{{activity.ipAddress}}</td><td>{{activity.page}}</td><td>{{activity.time}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" data-translate="userManagement.activated" style="cursor: pointer">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><!-- <div class="alert alert-warning">\n                <a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a>\n            </div>\n            <div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>\n                You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a>\n            </div> --></div></div></div><!-- <div class="well">\n    <p class="small" data-translate="login.auth-message"></p>\n</div> -->');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><!-- <h1 data-translate="error.title">Error Page!</h1>\n\n            <div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.\n            </div> --></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default header" role="navigation"><div><div class="brand"><a data-move="ltr" data-toggle="offscreen" class="ti-menu off-left visible-xs" href="javascript:;"></a> <a style="width:700px" class="navbar-brand" href="#"><img alt="" src="/content/images/logo.png"><p class="heading-font" data-translate="home.title">A Home Title..</p></a></div><div class="pull-right col-md-4 col-xs-12" style="padding: 13px 15px" ng-switch="vm.isAuthenticated()"><a href="" ng-click="vm.login()" class="btn btn-primary pull-right" style="font-size: 14px" ng-switch-when="false"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span> </a><a href="" ng-click="vm.logout()" id="logout" class="btn btn-primary pull-right" style="font-size: 14px" ng-switch-when="true"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></div><!-- TODO Optionally remove admin stuff --><!--<div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()">\n            <ul class="nav navbar-nav navbar-right">\n                <li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu">\n                        <span>\n                            <span class="glyphicon glyphicon-user"></span>\n                            <span class="hidden-sm" data-translate="global.menu.account.main">\n                                Account\n                            </span>\n                            <b class="caret"></b>\n                        </span>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu>\n                        <li ui-sref-active="active" ng-switch-when="true">\n                            <a ui-sref="settings" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-wrench"></span>&nbsp;\n                                <span data-translate="global.menu.account.settings">Settings</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" ng-switch-when="true">\n                            <a ui-sref="password" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-lock"></span>&nbsp;\n                                <span data-translate="global.menu.account.password">Password</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" ng-switch-when="true">\n                            <a href="" ng-click="vm.logout()" id="logout">\n                                <span class="glyphicon glyphicon-log-out"></span>&nbsp;\n                                <span data-translate="global.menu.account.logout">Sign out</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" ng-switch-when="false">\n                            <a href="" ng-click="vm.login()" id="login">\n                                <span class="glyphicon glyphicon-log-in"></span>&nbsp;\n                                <span data-translate="global.menu.account.login">Sign in</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" ng-switch-when="false">\n                            <a ui-sref="register" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-plus-sign"></span>&nbsp;\n                                <span data-translate="global.menu.account.register">Register</span>\n                            </a>\n                        </li>\n                    </ul>\n                </li>--><!--\n                <li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu">\n                        <span>\n                            <span class="glyphicon glyphicon-tower"></span>\n                            <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span>\n                            <b class="caret"></b>\n                        </span>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu>\n                        <li ui-sref-active="active">\n                            <a ui-sref="user-management" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-user"></span>&nbsp;\n                                <span data-translate="global.menu.admin.userManagement">User management</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="jhi-tracker" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-eye-open"></span>&nbsp;\n                                <span data-translate="global.menu.admin.tracker">User tracker</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-dashboard"></span>&nbsp;\n                                <span data-translate="global.menu.admin.metrics">Metrics</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="jhi-health" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-heart"></span>&nbsp;\n                                <span data-translate="global.menu.admin.health">Health</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-list-alt"></span>&nbsp;\n                                <span data-translate="global.menu.admin.configuration">Configuration</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="audits" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-bell"></span>&nbsp;\n                                <span data-translate="global.menu.admin.audits">Audits</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active">\n                            <a ui-sref="logs" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-tasks"></span>&nbsp;\n                                <span data-translate="global.menu.admin.logs">Logs</span>\n                            </a>\n                        </li>\n                        <li ng-show="vm.swaggerEnabled" ui-sref-active="active">\n                            <a ui-sref="docs" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-book"></span>&nbsp;\n                                <span data-translate="global.menu.admin.apidocs">API</span>\n                            </a>\n                        </li>\n                        &lt;!&ndash; jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here &ndash;&gt;\n                        <li ng-hide="vm.inProduction">\n                            <a href=\'/h2-console\' target="_tab" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-hdd"></span>&nbsp;\n                                <span data-translate="global.menu.admin.database">Database</span>\n                            </a>\n                        </li>\n                    </ul>\n                </li>\n                <li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1">\n                        <span>\n                            <span class="glyphicon glyphicon-flag"></span>\n                            <span class="hidden-sm" data-translate="global.menu.language">Language</span>\n                            <b class="caret"></b>\n                        </span>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1">\n                        <li active-menu="{{language}}" ng-repeat="language in languageVm.languages">\n                            <a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a>\n                        </li>\n                    </ul>\n                </li>\n--></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');
$templateCache.put('app/vl/dashboards/directives/consolidated/consolidated.summary.html','<div class="col-md-6 col-xs-12 dashboard-maincontent grid-block no-p-s"><div class="three-quarters-loader" ng-show="throb"></div><div class="panel ng-isolate-scope clearfix p20 no-p-s" style="min-height:514px"><h4 ng-repeat="head in totalSummary.totalSummary.headers" class="irrigation-h4 no-padd" style="margin-bottom: 5px">{{\'home.table.title\' |translate:head }}<br>{{\'home.table.sub-title\' |translate:head }} : <span class="ng-binding" ng-if="head.dataType === \'CUMULATIVE\'">{{(totalSummary.totalSummary.recordData[$index][0].value | currency)|| "N/A"}} {{ currencyUnits }} ({{(totalSummary.totalSummary.recordData[$index][1].value | number:2) || "N/A"}}%) , ( {{(totalSummary.totalSummary.recordData[$index][2].value | positive | number:2) || "N/A"}}% <span ng-if="parseFloat(totalSummary.totalSummary.recordData[$index][2].value) > 0"><i style="color: rgb(14, 150, 0)" class="fa fa-long-arrow-up" aria-hidden="true"></i> )</span><!--TODO : Get a new color ode when negative --> <span ng-if="parseFloat(totalSummary.totalSummary.recordData[$index][2].value) < 0"><i style="color:red" class="fa fa-long-arrow-down" aria-hidden="true"></i> )</span> <span ng-if="parseFloat(totalSummary.totalSummary.recordData[$index][2].value) === 0"><i style="color: rgb(0,0,0);" class="fa fa-arrows-h" aria-hidden="true"></i> )</span> </span><span class="ng-binding" ng-if="head.dataType === \'CUMMNUM\'">{{(totalSummary.totalSummary.recordData[$index][0].value)|| "N/A"}} ( {{(totalSummary.totalSummary.recordData[$index][1].value | positive | number:2) || "N/A"}}% <span ng-if="parseFloat(totalSummary.totalSummary.recordData[$index][1].value) > 0"><i style="color: rgb(14, 150, 0)" class="fa fa-long-arrow-up" aria-hidden="true"></i> )</span><!--TODO : Get a new color ode when negative --> <span ng-if="parseFloat(totalSummary.totalSummary.recordData[$index][1].value) < 0"><i style="color:red" class="fa fa-long-arrow-down" aria-hidden="true"></i> )</span> <span ng-if="parseFloat(totalSummary.totalSummary.recordData[$index][1].value) === 0"><i style="color: rgb(0,0,0);" class="fa fa-ssarrows-h" aria-hidden="true"></i> )</span> </span><span class="ng-binding" ng-if="head.dataType === \'NUMBER\'">{{(totalSummary.totalSummary.recordData[$index][0].value) || "N/A"}} </span><span class="ng-binding" ng-if="head.dataType === \'CURRENCY\'">{{(totalSummary.totalSummary.recordData[$index][0].value | currency) || "N/A"}} {{ currencyUnits }}</span></h4><div class="legends text-right mt15"><span><i aria-hidden="true" class="fa fa-long-arrow-up" style="color: rgb(14, 150, 0)"></i> Increase from last year</span> <span><i style="color:red" class="fa fa-long-arrow-down" aria-hidden="true"></i> Decrease from last year</span> <span><i style="color:black" class="fa fa-arrows-h" aria-hidden="true"></i> No Change from last year</span></div></div></div>');
$templateCache.put('app/vl/dashboards/directives/filterForm/filterForm.html','<div style="text-align:left; box-shadow:none; line-height:240%" class="breadcrumb mi-breadcum col-md-12"><h4 style="font-size:15px" class="ng-binding ng-scope pull-left">State : <b class="ng-binding" ng-click="send()">ANDHRA PRADESH</b></h4><h4 style="font-size:15px" class="ng-binding ng-scope pull-left ml10" ng-show="type && key && type.indexOf(\'ULB\') == -1">{{type}} : <b class="ng-binding" ng-click="send(type,key)">{{key}}</b></h4><h4 style="font-size:15px" class="ng-binding ng-scope pull-left ml10" ng-show="type && key && type.indexOf(\'ULB\')!= -1">ULB : <b class="ng-binding" ng-click="send(type,key)">{{key}}</b></h4><!-- <h4 style="font-size:15px;" class="ng-binding ng-scope pull-left ml10" ng-show="type && key && type!==\'ULB_BILL\' && type!==\'ULB_REVENUE_OFFICER\' && type!==\'ULB_REVENUE_INSPECTOR\'">{{type}} : <b class="ng-binding" ng-click="send(type,key)"> {{key}} </b></h4>\n    <h4 style="font-size:15px;" class="ng-binding ng-scope pull-left ml10" ng-show="type && key && type===\'ULB_BILL\'">ULB : <b class="ng-binding" ng-click="send(type,key)"> {{key}} </b></h4>\n    <h4 style="font-size:15px;" class="ng-binding ng-scope pull-left ml10" ng-show="type && key && type===\'ULB_REVENUE_INSPECTOR\'">ULB : <b class="ng-binding" ng-click="send(type,key)"> {{key}} </b></h4>\n    <h4 style="font-size:15px;" class="ng-binding ng-scope pull-left ml10" ng-show="type && key && type===\'ULB_REVENUE_OFFICER\'">ULB : <b class="ng-binding" ng-click="send(type,key)"> {{key}} </b></h4> --><div class="pull-right col-md-4 col-xs-12"><div class="iph" ng-show="ulbtype"><div class="switch_trigger analysis-switch pull-left"><div class="col-md-5 no-p mr10"><div class="form-group"><select class="form-control" ng-model="parentulbtype"><option value="ULB_WARD">Revenue Ward</option><option value="ULB">Ward Secretariat</option></select></div></div><div class="col-md-5 no-p mr10"><div class="form-group"><select class="form-control" ng-model="ulbtype"><option value="ULB_WARD" ng-if="checkULBWardType()">Revenue Ward</option><!-- <option value="ULB_BILL" ng-if="checkULBWardType()">Bill Collector</option> --><option value="ULB_REVENUE_INSPECTOR" ng-if="revenueOfficerOrInspectorFilter && checkULBWardType()">Revenue Inspector</option><option value="ULB_REVENUE_OFFICER" ng-if="revenueOfficerOrInspectorFilter && checkULBWardType()">Revenue Officer</option><option value="ULB" ng-if="checkSecretariatWardType()">Ward Secretariat</option><option value="ULB_SEC_WARD_SECRETARY" ng-if="revenueOfficerOrInspectorFilter&&checkSecretariatWardType()">Ward Administrative Secretary</option><option value="ULB_SEC_REVENUE_INSPECTOR" ng-if="revenueOfficerOrInspectorFilter && checkSecretariatWardType()">Revenue Inspector</option><option value="ULB_SEC_REVENUE_OFFICER" ng-if="revenueOfficerOrInspectorFilter && checkSecretariatWardType()">Revenue Officer</option></select></div></div><!-- <div class="switch switch-blue no-m">\n          <input type="radio" class="switch-input" id="billcollector" value="ULB" ng-model="ulbtype">\n          <label for="billcollector" class="switch-label switch-label-off">Ward</label>\n          <input type="radio" class="switch-input" id="ward" value="ULB_BILL" ng-model="ulbtype" ng-click="alert(\'hi\')">\n          <label for="ward" class="switch-label switch-label-on"> Bill Collector </label>\n          <span class="switch-selection"></span>\n         </div> --></div></div><!-- <div class="iph" ng-show="officertype">\n        <div class="switch_trigger analysis-switch pull-left ">\n          <div class="form-group">\n              <select class="form-control" ng-model="officertype">\n                <option value="billcollector">Bill Collector</option>\n                <option value="revenueinspector">Revenue Inspector</option>\n                <option value="revenueofficer">Revenue Officer </option>\n              </select>\n          </div>\n      </div>\n    </div> --><div class="pull-right"><button class="btn btn-primary pull-right" style="font-size:14px" id="filter_togle" ng-click="toggleForm()"><i class="fa fa-hourglass-end" aria-hidden="true"></i> Filter</button><div class="form-group pull-right mr20 col-md-8" ng-show="showProperty==true"><select style="border:1px solid #666666" class="form-control" ng-model="propertyType"><option ng-selected="!propertyType" value="">All Property Types</option><option value="State Government">State Government</option><option value="Private">Private</option><option value="Central Government">Central Government</option><option value="Vacant Land">Vacant Land</option></select></div></div></div></div><!-- form space ----><form ng-submit="vlSubmit()"><div class="clearfix" id="filter_box" ng-hide="formHidden"><div class="col-md-2"><div><label data-translate="vassar.directives.revenue.detail.form.control.label.Top Level View">Top Level View</label></div><div class="form-group"><select class="form-control" ng-model="queryData.gradeType"><option value="district" data-translate="vassar.directives.revenue.detail.option.label.district">District</option><option value="region" data-translate="vassar.directives.revenue.detail.option.label.region">Region</option><option value="grade" data-translate="vassar.directives.revenue.detail.option.label.grade">ULB Type</option><option ng-if="showAll()" value="all_ulb">All ULB</option><option ng-if="showAll()" value="all_ward">All Revenue Wards</option><option ng-if="showAll()" value="all_sec_ward">All Secretariat Wards</option></select></div></div><div class="col-md-5" ng-if="checkTopLevel()"><div><label>Select {{queryData.gradeType | camelCase}}</label></div><div class="col-md-5 no-p mr10"><div class="form-group"><select class="form-control" ng-model="queryData.grade" ng-disabled="!(queryData.gradeType)"><option ng-selected="!(queryData.grade)" value="">{{getDefaultGradeTypeLabel()}}</option><option ng-show="\'district\' === queryData.gradeType" ng-repeat="option in ulbList | unique: queryData.gradeType" value="{{option[queryData.gradeType]}}">{{option[queryData.gradeType]}}</option><option ng-show="\'grade\' === queryData.gradeType && option[queryData.gradeType] !==\'Selecti\' && option[queryData.gradeType] !==\'Selection\'" ng-repeat="option in ulbList | unique: queryData.gradeType" value="{{option[queryData.gradeType]}}">{{getULBGradeDesc(option[queryData.gradeType])}}</option><option ng-show="\'region\' === queryData.gradeType" ng-repeat="option in ulbList | unique: queryData.gradeType" value="{{option[queryData.gradeType]}}">{{option[queryData.gradeType]}}</option></select></div></div><div class="col-md-5 no-p"><div class="form-group"><select class="form-control" ng-model="queryData.selectedULB" ng-disabled="!(queryData.grade)||\'\'== queryData.grade"><option ng-selected="!(queryData.selectedULB)" value="">All ULBs</option><option ng-repeat="option in getULBForGrade()" value="{{option.city}}">{{option.city}}</option></select></div></div></div><div class="col-md-4" ng-show="showDates==true"><div><label data-translate="vassar.directives.revenue.detail.form.control.label.Select Month Range">Select Month Range</label></div><div class="col-md-5 no-p"><div class="input-group"><input type="text" readonly="readonly" class="form-control" uib-datepicker-popup="{{format}}" ng-model="queryData.fromDate" is-open="fromDate.opened" datepicker-options="fromDateOptions" ng-required="true" close-text="Close"><div class="input-group-btn"><button type="button" class="btn btn-default" ng-click="fromDatePickerOpen()"><i class="glyphicon glyphicon-calendar"></i></button></div></div></div><div class="col-md-2 no-p text-center mt5">To</div><div class="col-md-5 no-p"><div class="input-group"><input type="text" class="form-control" readonly="readonly" uib-datepicker-popup="{{format}}" ng-model="queryData.toDate" is-open="toDate.opened" datepicker-options="toDateOptions" ng-required="true" close-text="Close"><div class="input-group-btn"><button type="button" class="btn btn-default" ng-click="toDatePickerOpen()"><i class="glyphicon glyphicon-calendar"></i></button></div></div></div></div><div class="col-md-1"><div><label>&nbsp;&nbsp;&nbsp;</label></div><button style="font-size:14px" class="btn btn-primary pull-right"><i aria-hidden="true" class="fa fa-hourglass-end"></i><z>Submit</z></button></div></div></form><!-- form space end ---->');
$templateCache.put('app/vl/dashboards/directives/summary/state.summary.html','<div class="col-md-4 col-xs-12 main_tab"><div class="grid-block col-md-12 bi-map-block-bdr sm_no_p"><a ng-class="{\'disabled\':!url}" href="{{url}}"><section class="panel" ng-class="{\'active\': title === \'Property Tax\'}"><div class="panel-body sm_no_p no-p bal_d no-m-xs"><header class="col-md-12 h4 no-m no-p grid-block"><div class="col-sm-12 pl0 mb10"><span class="no-m ng-binding" style="text-transform:none; line-height:270%" ng-show="icon === \'property-tax\'"><img src="/content/images/property-tax.png" class="pull-left"> &nbsp;&nbsp;&nbsp;{{title}}</span></div><div class="col-sm-12 pl0 mb10"><span class="no-m ng-binding" style="text-transform:none; line-height:270%" ng-show="icon === \'water-charge\'"><img src="/content/images/water-charge.png" class="pull-left" ng-show="icon === \'water-charge\'"> &nbsp;&nbsp;&nbsp;{{title}}</span></div><div class="col-sm-12 pl0 mb10"><span class="no-m ng-binding" style="text-transform:none; line-height:270%" ng-show="icon === \'other-charge\'"><img src="/content/images/others.png" class="pull-left" ng-show="icon === \'other-charge\'"> &nbsp;&nbsp;&nbsp;{{title}}</span></div></header><div class="col-sm-12 no-p"><div class="table-responsive ng-scope" style="border: 0px solid #c5c5c5"><table class="table table-striped table-bordered responsive no-m ng-scope"><tbody><tr class="ng-scope ws_odd" ng-class-odd="\'ws_odd\'" ng-class-even="\'ws_even\'"><td style="text-align:left" data-translate="home.section.common.label.target">Target</td><td style="text-align:left">{{ \'home.section.common.target\' | translate:summary.target}}</td></tr><tr style="" class="ng-scope ws_even" ng-class-odd="\'ws_odd\'" ng-class-even="\'ws_even\'"><td style="text-align:left" data-translate="home.section.common.label.collected"></td><td style="text-align:left">{{ \'home.section.common.revenue\' | translate:summary.collected}} ({{summary.collected.variance | positive| number:2}}% <span ng-show="summary.collected.variance > 0"><i style="color: rgb(14, 150, 0)" class="fa fa-long-arrow-up" aria-hidden="true" ng-show="[summary.collected.variance > 0]"></i> )</span><!--TODO : Get a new color ode when negative --> <span ng-show="summary.collected.variance < 0"><i style="color:red" class="fa fa-long-arrow-down" aria-hidden="true" ng-show="[summary.collected.variance < 0]"></i> )</span> <span ng-show="summary.collected.variance === 0"><i style="color: rgb(0,0,0);" class="fa fa-arrows-h" aria-hidden="true"></i> )</span></td></tr><tr style="" class="ng-scope ws_odd" ng-class-odd="\'ws_odd\'" ng-class-even="\'ws_even\'"><td style="text-align:left" data-translate="home.section.common.label.lastYear">Last Year</td><td style="text-align:left">{{ \'home.section.common.lastYear\' | translate:summary.lastYear}}</td></tr></tbody></table></div></div></div></section></a></div></div>');
$templateCache.put('app/vl/dashboards/directives/table/revenue.table.html','<div class="three-quarters-loader" ng-show="throb && !(details.records.length >0)" id="table0" style="position:relative;top:50px;left:50%"></div><div class="pull-right col-md-4 col-xs-12" style="padding:10px;margin-right:55px"><div class="iph" ng-show="ulbtype"><div class="col-md-5 no-p mr10"><div class="form-group"><select class="form-control" ng-model="parentulbtype"><option value="ULB_WARD">Revenue Ward</option><option value="ULB">Ward Secretariat</option></select></div></div><div class="col-md-5 no-p mr10"><div class="form-group"><select class="form-control" ng-model="ulbtype"><option value="ULB_WARD" ng-if="checkULBWardType()">Revenue Ward</option><!-- <option value="ULB_BILL" ng-if="checkULBWardType()">Bill Collector</option> --><option value="ULB_REVENUE_INSPECTOR" ng-if="revenueOfficerOrInspector && checkULBWardType()">Revenue Inspector</option><option value="ULB_REVENUE_OFFICER" ng-if="revenueOfficerOrInspector && checkULBWardType()">Revenue Officer</option><option value="ULB" ng-if="checkSecretariatWardType()">Ward Secretariat</option><option value="ULB_SEC_WARD_SECRETARY" ng-if="revenueOfficerOrInspector&&checkSecretariatWardType()">Ward Administrative Secretary</option><option value="ULB_SEC_REVENUE_INSPECTOR" ng-if="revenueOfficerOrInspector && checkSecretariatWardType()">Revenue Inspector</option><option value="ULB_SEC_REVENUE_OFFICER" ng-if="revenueOfficerOrInspector && checkSecretariatWardType()">Revenue Officer</option></select></div></div></div><div class="iph" ng-show="officertype"><div class="col-md-5 no-p mr10"><div class="form-group"><select class="form-control" ng-model="parentofficertype"><option value="ward">Revenue Ward</option><option value="secretariatward">Ward Secretariat</option></select></div></div><div class="col-md-5 no-p"><div class="form-group"><select class="form-control" ng-model="officertype"><!-- <option value="billcollector">Bill Collector</option> --><option value="wardsecretary" ng-if="parentofficertype == \'secretariatward\'">Ward Administrative Secretary</option><option value="revenueinspector">Revenue Inspector</option><option value="revenueofficer">Revenue Officer</option></select></div></div></div></div><div style="text-align:left; box-shadow:none; line-height:240%" class="col-md-12" ng-if="show"><h4 style="font-size:15px" class="ng-binding ng-scope pull-left">State : <b class="ng-binding" ng-click="send()">ANDHRA PRADESH</b></h4><h4 style="font-size:15px" class="ng-binding ng-scope pull-left ml10" ng-show="type && key && type.indexOf(\'ULB\') == -1">{{type}} : <b class="ng-binding" ng-click="send(type,key)">{{key}}</b></h4><h4 style="font-size:15px" class="ng-binding ng-scope pull-left ml10" ng-show="type && key && type.indexOf(\'ULB\')!= -1">ULB : <b class="ng-binding" ng-click="send(type,key)">{{key}}</b></h4><!-- <h4 style="font-size:15px;" class="ng-binding ng-scope pull-left ml10" ng-show="type && key && type===\'ULB_BILL\'">ULB : <b class="ng-binding" ng-click="send(type,key)"> {{key}} </b></h4>\n    <h4 style="font-size:15px;" class="ng-binding ng-scope pull-left ml10" ng-show="type && key && type===\'ULB_REVENUE_INSPECTOR\'">ULB : <b class="ng-binding" ng-click="send(type,key)"> {{key}} </b></h4>\n    <h4 style="font-size:15px;" class="ng-binding ng-scope pull-left ml10" ng-show="type && key && type===\'ULB_REVENUE_OFFICER\'">ULB : <b class="ng-binding" ng-click="send(type,key)"> {{key}} </b></h4> --></div><div class="col-md-12 no-p"><div class="panel-body sm_no_p pb0"><div class="ng-scope"><div ng-repeat="record in details.records track by $index" class="table-responsive no-m ng-scope dashboard-maincontent" ng-init="tableIndex =$index;"><div class="constrained"><strong style="text-transform:none;font-weight: 600;font-size: 17px;color: #4472c4" class="no-m ng-binding">{{record.tableHeading}}</strong></div><table class="table table-striped table-bordered responsive no-m ng-scope" infinite-scroll="loadMore(tableIndex)" infinite-scroll-distance="3"><thead><!-- <tr>\n                        <th width="8%" style="vertical-align:middle">S.No<br></th>\n                        <th style="text-align:center; vertical-align:middle" ng-repeat="header in record.headers" ng-click="setSortOrder($index,$parent.$index)">\n                                {{\'home.table.title\' |translate:header }}<br>{{\'home.table.sub-title\' |translate:header }}\n                            <span ><img style="width: 24px;" src="data:image/gif;base64,R0lGODlhFQAJAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAkAAAIXjI+AywnaYnhUMoqt3gZXPmVg94yJVQAAOw=="></span>\n                        </th>\n                    </tr> --><tr ng-repeat="headerdata in record.headers track by $index"><th width="8%" style="vertical-align:middle" rowspan="2" ng-if="$index == 0">S.No</th><th style="text-align:center; vertical-align:middle" ng-repeat="header in headerdata track by $index" ng-click="setSortOrder(header.sortIndex,tableIndex)" rowspan="{{header.rows}}" colspan="{{header.cols}}" ng-class="{\'color1\':getColorClass(header.colour,1),\'color2\':getColorClass(header.colour,2)}">{{header.name}}<br ng-if="header.subTitle">{{header.subTitle}}<br><span ng-if="header.subUnits">{{header.subUnits}}</span> <span ng-if="header.sortIndex!=null && header.sortIndex!=undefined"><img style="width: 24px" src="data:image/gif;base64,R0lGODlhFQAJAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAkAAAIXjI+AywnaYnhUMoqt3gZXPmVg94yJVQAAOw=="></span></th></tr></thead><tbody><div class="three-quarters-loader" ng-show="throb"></div><tr ng-if="record.recordData!=null" ng-repeat="tableData in record.recordData | filter:search | orderBy:\'this[\'+record.sortIndex+\'].value\':record.sortOrder:compare | limitTo:record.limit"><td class="ng-binding">{{$index + 1}}</td><td class="ng-binding ng-scope" ng-repeat="dat in tableData" ng-class="{\'textleft\':$first,\'color1\':getColorClass(dat.colour,1),\'color2\':getColorClass(dat.colour,2)}"><span ng-if="record.dataTypes[$index] === \'LOCATION\'"><p ng-click="submit(dat.key)">{{dat.value}}</p></span><span ng-if="record.dataTypes[$index] === \'FINALLOCATION\'">{{dat.value || "N/A"}} </span><span ng-if="record.dataTypes[$index] === \'NUMBER\'">{{dat.value |number}} </span><span ng-if="record.dataTypes[$index] === \'CURRENCY\'">{{dat.value |currency}} </span><span ng-if="record.dataTypes[$index] === \'PERCENTAGE\'">{{dat.value |number:2}}% </span><span ng-if="record.dataTypes[$index] === \'VARIANCE\'">{{dat.value | positive |number:2}}% <span ng-if="parseFloat(dat.value) > 0"><i style="color: rgb(14, 150, 0)" class="fa fa-long-arrow-up" aria-hidden="true"></i> </span><!--TODO : Get a new color ode when negative --> <span ng-if="parseFloat(dat.value) < 0"><i style="color:red" class="fa fa-long-arrow-down" aria-hidden="true"></i> </span><span ng-if="parseFloat(dat.value) === 0"><i style="color: rgb(0,0,0)" class="fa fa-arrows-h" aria-hidden="true"></i></span></span></td></tr><tr ng-if="record.totalData.length>0 && record.recordData.length>0" class="last_table_row"><td class="ng-binding"></td><td class="ng-binding ng-scope" ng-repeat="dat in record.totalData" ng-class="{\'textleft\':$first,\'color1\':getColorClass(dat.colour,1),\'color2\':getColorClass(dat.colour,2)}"><span ng-if="record.dataTypes[$index] === \'LOCATION\'">{{dat.value}} </span><span ng-if="record.dataTypes[$index] === \'FINALLOCATION\'">{{dat.value}} </span><span ng-if="record.dataTypes[$index] === \'NUMBER\'">{{dat.value|number}} </span><span ng-if="record.dataTypes[$index] === \'CURRENCY\'">{{dat.value |currency}} </span><span ng-if="record.dataTypes[$index] === \'PERCENTAGE\'">{{dat.value |number:2}}% </span><span ng-if="record.dataTypes[$index] === \'VARIANCE\'">{{dat.value | positive | number:2 }}% <span ng-if="parseFloat(dat.value) > 0"><i style="color: rgb(14, 150, 0)" class="fa fa-long-arrow-up" aria-hidden="true"></i> </span><!--TODO : Get a new color ode when negative --> <span ng-if="parseFloat(dat.value) < 0"><i style="color:red" class="fa fa-long-arrow-down" aria-hidden="true"></i> </span><span ng-if="parseFloat(dat.value) === 0"><i style="color: rgb(0,0,0);" class="fa fa-arrows-h" aria-hidden="true"></i></span></span></td></tr><tr ng-class-even="\'ng-scope ws_odd\'" ng-class-odd="\'ws_odd\'" class="ng-scope ws_odd" ng-if="record.recordData.length==0"><td class="ng-binding" colspan="{{record.headers.length+1}}" style="text-align: center">No Data To Display</td></tr></tbody></table><br><br></div></div><div class="legends text-right mt15"><span><i aria-hidden="true" class="fa fa-long-arrow-up" style="color: rgb(14, 150, 0)"></i> Increase from last year</span> <span><i style="color:red" class="fa fa-long-arrow-down" aria-hidden="true"></i> Decrease from last year</span> <span><i style="color:black" class="fa fa-arrows-h" aria-hidden="true"></i> No Change from last year</span></div></div></div>');
$templateCache.put('app/vl/dashboards/revenue/views/blocked.html','<!-- <h1 style="text-align: center;">403</h1> --><h2 style="text-align: center">Site is temporarily down. Please try after 6 PM.</h2>');
$templateCache.put('app/vl/dashboards/revenue/views/revenue.bottom10.html','<div><!--<h2 data-translate="revenue.tabs.collections.section.title">Collections</h2>--><!-- <div class="splash" ng-show="vm.loadingAllUlbDataRecords">\n        <span>Loading ULB Data  <i class="fa fa-spinner fa-spin fa-3x"></i></span>\n    </div> --><div class="clearfix"></div><!-- Revenue Details --><!-- <div class="splash" ng-show="vm.tabs[0].loadingData">\n        Loading Revenue Details <i class="fa fa-spinner fa-spin fa-5x "></i>\n    </div> --><div class="DCB_menu mt25 clearfix"><!-- Tabular Data --><div class="col-12"><div class="pull-right col-md-2 col-xs-12" style="padding:10px"><div class="iph" ng-show="vm.conversionType"><div class="switch_trigger analysis-switch pull-left currency"><div class="switch switch-blue no-m"><input type="radio" class="switch-input" id="lakhs" value="Crores" ng-model="vm.conversionType"><label for="lakhs" class="switch-label switch-label-off">Crores</label><input type="radio" class="switch-input" id="crores" value="Lakhs" ng-model="vm.conversionType"><label for="crores" class="switch-label switch-label-on">Lakhs</label><span class="switch-selection"></span></div></div></div></div><div revenue-table ulbtype="vm.ulbtype" details="vm.bottom10.TableData" total-summary="totalSummary" throb="vm.tabs[4].loadingData"></div></div></div></div>');
$templateCache.put('app/vl/dashboards/revenue/views/revenue.collectionranking.html','<div><div class="clearfix"></div><div class="DCB_menu mt25 clearfix"><!-- Tabular Data --><div class="col-12"><div class="pull-right col-md-2 col-xs-12" style="padding:10px"><div class="iph" ng-show="vm.conversionType"><div class="switch_trigger analysis-switch pull-left currency"><div class="switch switch-blue no-m"><input type="radio" class="switch-input" id="lakhs" value="Crores" ng-model="vm.conversionType"><label for="lakhs" class="switch-label switch-label-off">Crores</label><input type="radio" class="switch-input" id="crores" value="Lakhs" ng-model="vm.conversionType"><label for="crores" class="switch-label switch-label-on">Lakhs</label><span class="switch-selection"></span></div></div></div></div><div revenue-table ulbtype="vm.ulbtype" details="vm.collectionRankingData.TableData" ftype="vm.ftype" fkey="vm.fkey" officertype="vm.officerType" throb="vm.tabs[6].loadingData" parentofficertype="vm.parentofficerType"></div></div></div></div>');
$templateCache.put('app/vl/dashboards/revenue/views/revenue.collections.html','<style>/*.no-padd {\n  padding : 10px 10px 10px 20px;\n  font-size : 13px;\n}*/</style><div><!--<h2 data-translate="revenue.tabs.collections.section.title">Collections</h2>--><!-- <div class="three-quarters-loader" ng-show="vm.loadingAllUlbDataRecords">\n    </div> --><!-- <div ng-hide="vm.loadingAllUlbDataRecords">\n        <div vl-filter-form query-data="vm.queryData" ulb-list="vm.ulbList" graphid="collections"></div>\n    </div> --><div class="clearfix"></div><!-- Revenue Details --></div><div class="DCB_menu mt25 clearfix"><div class="col-md-12 mt20 no-p no-m-s" ng-show="vm.collection.id !== undefined && !vm.showAll"><div consolidated-summary currency-units="vm.currencyUnits" total-summary="vm.collection.TotalSummary" throb="vm.tabs[0].loadingData"></div><div><div class="col-md-6 col-xs-12 dashboard-maincontent grid-block"><div class="panel ng-isolate-scope clearfix p20"><strong class="no-m text-center mb20">{{\'home.chart title\' | translate}}<br>{{ \'home.chart range\' | translate:vm.collection.TrendData}}</strong><vl-line data="vm.collection.options" throbber="vm.tabs[0].loadingData" id="{{vm.collection.id}}" class="no-shadow" nodataimage="#"></vl-line></div></div></div></div><!-- Tabular Data --><div class="col-12"><div class="pull-right col-md-2 col-xs-12" style="padding:10px"><div class="iph" ng-show="vm.conversionType"><div class="switch_trigger analysis-switch pull-left currency"><div class="switch switch-blue no-m"><input type="radio" class="switch-input" id="lakhs" value="Crores" ng-model="vm.conversionType"><label for="lakhs" class="switch-label switch-label-off">Crores</label><input type="radio" class="switch-input" id="crores" value="Lakhs" ng-model="vm.conversionType"><label for="crores" class="switch-label switch-label-on">Lakhs</label><span class="switch-selection"></span></div></div></div></div><div revenue-table ulbtype="vm.ulbtype" details="vm.collection.TableData" total-summary="totalSummary" ftype="vm.ftype" fkey="vm.fkey" throb="vm.tabs[0].loadingData" show="1"></div></div></div>');
$templateCache.put('app/vl/dashboards/revenue/views/revenue.dcb.html','<style>/*.no-padd {\n  padding : 10px 10px 10px 20px;\n  font-size : 13px;\n}*/</style><div><!--<h2 data-translate="revenue.tabs.collections.section.title">Collections</h2>--><!-- <div class="splash" ng-show="vm.loadingAllUlbDataRecords">\n        <span>Loading ULB Data  <i class="fa fa-spinner fa-spin fa-3x"></i></span>\n    </div> --><div class="clearfix"></div><!-- Revenue Details --><!-- <div class="splash" ng-show="!vm.tabs[0] || vm.tabs[0].loadingData">\n        Loading Revenue Details <i class="fa fa-spinner fa-spin fa-5x "></i>\n    </div> --><div class="DCB_menu mt25 clearfix"><ul class="tabs14"><li ui-sref-active="active"><a ui-sref="vl.dashboards.revenue.dcbprivate">Private</a></li><li ui-sref-active="active"><a ui-sref="vl.dashboards.revenue.dcbstate">State Govt</a></li><li ui-sref-active="active"><a ui-sref="vl.dashboards.revenue.dcbcentral">Central Govt</a></li><li ui-sref-active="active"><a ui-sref="vl.dashboards.revenue.dcbcourt">Court Cases</a></li><li ui-sref-active="active"><a ui-sref="vl.dashboards.revenue.dcbvacant">Vacant Land</a></li><li ui-sref-active="active"><a ui-sref="vl.dashboards.revenue.dcb">Total</a></li></ul><div class="col-md-12 mt20 no-p no-m-s" ng-show="vm.dcb.id !== undefined && !vm.showAll"><div consolidated-summary currency-units="vm.currencyUnits" total-summary="vm.dcb.TotalSummary" throb="vm.tabs[1].loadingData"></div><div class="col-lg=6"><div class="col-md-6 col-xs-12 dashboard-maincontent grid-block"><div class="panel ng-isolate-scope clearfix p20"><strong class="no-m text-center mb20">{{\'home.chart title\' | translate}}<br>{{ \'home.chart range\' | translate:vm.dcb.TrendData}}</strong><vl-line data="vm.dcb.options" throbber="vm.tabs[1].loadingData" id="{{vm.dcb.id}}" class="no-shadow" nodataimage="#"></vl-line></div></div></div></div><!-- Tabular Data --><div class="col-12"><div class="pull-right col-md-2 col-xs-12" style="padding:10px"><div class="iph" ng-show="vm.conversionType"><div class="switch_trigger analysis-switch pull-left currency"><div class="switch switch-blue no-m"><input type="radio" class="switch-input" id="lakhs" value="Crores" ng-model="vm.conversionType"><label for="lakhs" class="switch-label switch-label-off">Crores</label><input type="radio" class="switch-input" id="crores" value="Lakhs" ng-model="vm.conversionType"><label for="crores" class="switch-label switch-label-on">Lakhs</label><span class="switch-selection"></span></div></div></div></div><div class="pull-right col-md-2 col-xs-12" style="padding:10px"><div class="iph" ng-show="vm.showdcbpenalties()"><div class="switch_trigger analysis-switch pull-left penalties"><div class="switch switch-blue no-m"><input type="radio" class="switch-input" id="wop" value="without_penalties" ng-model="vm.dcbpenaltyType"><label for="wop" class="switch-label switch-label-off">Without Penalties</label><input type="radio" class="switch-input" id="wp" value="with_penalties" ng-model="vm.dcbpenaltyType"><label for="wp" class="switch-label switch-label-on">With Penalties</label><span class="switch-selection"></span></div></div></div></div><div revenue-table ulbtype="vm.ulbtype" details="vm.dcb.TableData" total-summary="totalSummary" ftype="vm.ftype" fkey="vm.fkey" throb="vm.tabs[1].loadingData" show="1"></div></div></div></div>');
$templateCache.put('app/vl/dashboards/revenue/views/revenue.html','<div class="jumbotron p20"><h1 style="font-size:2.1em; line-height:150%"><center class="ng-binding">{{ \'home.State Revenue Collected Title\' | translate }}<br>{{ \'home.State Revenue as of\' | translate:vm.stateSummaryData }} : <b>{{ \'home.Total Revenue\' | translate:vm.stateSummaryData}}</b></center></h1></div><div ng-show="vm.loadingStateSummary" class="splash three-quarters-loader"></div><div><div dor-state-summary icon="property-tax" title="{{\'home.section.property-tax.title\' | translate}}" summary="vm.stateSummaryData.propertyTax"></div><div dor-state-summary icon="water-charge" title="{{\'home.section.water-charge.title\' | translate}}" summary="vm.stateSummaryData.waterCharges" url="https://propertytaxdashboard.allvy.com/wc"></div><div dor-state-summary icon="other-charge" title="{{\'home.section.others.title\' | translate}}" summary="vm.stateSummaryData.others" url="https://propertytaxdashboard.allvy.com/or"></div></div><!-- <div class="col-lg-12 no-p-s">\n    <uib-tabset>\n        <uib-tab ng-repeat="tab in vm.tabs" ui-sref="{{tab.route}}" ui-sref-active="active" heading="{{tab.title}}" active="{{tab.active}}" disable="tab.disabled" >\n          <div ng-hide="vm.loadingAllUlbDataRecords">\n              <div vl-filter-form query-data="vm.queryData" ftype="vm.ftype" fkey="vm.fkey" ulb-list="vm.ulbList" graphid="collections"></div>\n          </div>\n            <ng-include src="tab.content"></ng-include>\n            <div ui-view></div>\n        </uib-tab>\n    </uib-tabset>\n</div> --><div class="col-lg-12 col-md-12"><ul class="nav nav-pills"><li ui-sref-active="active"><a ui-sref="vl.dashboards.revenue.collections">Collections</a></li><li ng-class="{active: state.current.name.indexOf(\'dcb\')!= -1}"><a ui-sref="vl.dashboards.revenue.dcbprivate">DCB</a></li><li ui-sref-active="active"><a ui-sref="vl.dashboards.revenue.receipts">Transactions</a></li><li ui-sref-active="active"><a ui-sref="vl.dashboards.revenue.top10">Top 10</a></li><li ui-sref-active="active"><a ui-sref="vl.dashboards.revenue.bottom10">Bottom 10</a></li><li ui-sref-active="active"><a ui-sref="vl.dashboards.revenue.top100defaulters">Top 100 Defaulters</a></li><li ui-sref-active="active"><a ui-sref="vl.dashboards.revenue.collectionranking">Collection Ranking</a></li></ul><div ng-hide="vm.loadingAllUlbDataRecords"><div vl-filter-form ulbtype="vm.ulbtype" query-data="vm.queryData" ftype="vm.ftype" fkey="vm.fkey" ulb-list="vm.ulbList" show-dates="vm.showDates" show-property="vm.showProperty" form-hidden="vm.formHidden"></div></div></div><div ui-view></div><!--\n<div class="col-lg-12" ng-init="indextab = getActiveTab()" ng-hide="vm.firstcall===0">\n    <uib-tabset  active="indextab">\n        <uib-tab index="0" select="setActiveTab(0)">\n            <uib-tab-heading >\n                <z data-translate="home.tabs.collections.title">\n                    Collections\n                </z>\n            </uib-tab-heading>\n            <div revenue-detail title="{{\'home.chart title\' | translate}}"\n                 chart-data="vm.collectionTrendData"\n                 chartopt="vm.colloptions"\n                 revenue-details="vm.collectionTableData"\n                 total-summary="vm.collectionTotalSummary"\n                 ulb-list="vm.ulbList"\n                 graph-id="vm.collid"\n                 key="vm.collkey"\n                 type="vm.colltype"\n                 callfunc = "callCollection(key,type,from,to)"\n            ></div>\n        </uib-tab>\n\n        &lt;!&ndash;<uib-tab index="$index + 1" ng-repeat="tab in tabs" heading="{{tab.title}}" disable="tab.disabled">\n            {{tab.content}}\n        </uib-tab>&ndash;&gt;\n        <uib-tab index="1" select="setActiveTab(1)" >\n            <uib-tab-heading>\n                DCB\n            </uib-tab-heading>\n            <div revenue-detail title="{{\'home.chart title\' | translate}}"\n                 chart-data="vm.dcbTrendData"\n                 chartopt="vm.dcboptions"\n                 revenue-details="vm.dcbTableData"\n                 total-summary="vm.dcbTotalSummary"\n                 ulb-list="vm.ulbList"\n                 graph-id="vm.dcbid"\n                 key="vm.dcbkey"\n                 type="vm.dcbtype"\n                 callfunc = "callDCB(key,type,from,to)"\n            ></div>\n        </uib-tab>\n        <uib-tab index="2" select="setActiveTab(2)">\n            <uib-tab-heading>\n                Receipts\n            </uib-tab-heading>\n            <div revenue-detail title="{{\'home.receipt chart title\' | translate}}"\n                 chart-data="vm.receiptsTrendData"\n                 chartopt="vm.receiptsoptions"\n                 revenue-details="vm.receiptsTableData"\n                 total-summary="vm.receiptsTotalSummary"\n                 ulb-list="vm.ulbList"\n                 graph-id="vm.receiptsid"\n                 key="vm.receiptskey"\n                 type="vm.receiptstype"\n                 callfunc = "callreceipts(key,type,from,to)"\n            ></div>\n\n        </uib-tab>\n        <uib-tab index="3" select="setActiveTab(3)">\n            <uib-tab-heading>\n                Top 10\n            </uib-tab-heading>\n            <div revenue-detail title="{{\'home.chart title\' | translate}}"\n                 chart-data="vm.top10TrendData"\n                 chartopt="vm.top10options"\n                 revenue-details="vm.top10TableData"\n                 total-summary="vm.top10TotalSummary"\n                 ulb-list="vm.ulbList"\n                 graph-id="vm.top10id"\n                 key="vm.top10key"\n                 type="vm.top10type"\n                 callfunc = "calltop10(key,type,from,to)"\n            ></div>\n\n        </uib-tab>\n        <uib-tab index="4" select="setActiveTab(4)">\n            <uib-tab-heading>\n                Bottom 10\n            </uib-tab-heading>\n            <div revenue-detail title="{{\'home.chart title\' | translate}}"\n                 chart-data="vm.bottom10TrendData"\n                 chartopt="vm.bottom10options"\n                 revenue-details="vm.bottom10TableData"\n                 total-summary="vm.bottom10TotalSummary"\n                 ulb-list="vm.ulbList"\n                 graph-id="vm.bottom10id"\n                 key="vm.bottom10key"\n                 type="vm.bottom10type"\n                 callfunc = "callbottom10(key,type,from,to)"\n            ></div>\n\n        </uib-tab>\n        <uib-tab index="5" select="setActiveTab(5)">\n            <uib-tab-heading>\n                Top 100 Defaulters\n            </uib-tab-heading>\n            <div revenue-detail title="{{\'home.chart title\' | translate}}"\n                 chart-data="vm.top100DefaultersTrendData"\n                 chartopt="vm.top100Defaultersoptions"\n                 revenue-details="vm.top100DefaultersTableData"\n                 total-summary="vm.btop100DefaultersTotalSummary"\n                 ulb-list="vm.ulbList"\n                 graph-id="vm.top100Defaultersid"\n                 key="vm.top100Defaulterskey"\n                 type="vm.top100Defaulterstype"\n                 callfunc = "calldefaulters(key,type,from,to)"\n            ></div>\n        </uib-tab>\n    </uib-tabset>\n</div>\n-->');
$templateCache.put('app/vl/dashboards/revenue/views/revenue.receipts.html','<div><!--<h2 data-translate="revenue.tabs.collections.section.title">Collections</h2>--><!-- <div class="splash" ng-show="vm.loadingAllUlbDataRecords">\n        <span>Loading ULB Data  <i class="fa fa-spinner fa-spin fa-3x"></i></span>\n    </div> --><div class="clearfix"></div><!-- Revenue Details --><!-- <div class="splash" ng-show="!vm.tabs[0] || vm.tabs[0].loadingData">\n        Loading Revenue Details <i class="fa fa-spinner fa-spin fa-5x "></i>\n    </div> --><div class="DCB_menu mt25 clearfix"><div class="col-md-12 mt20 no-p no-m-s" ng-show="vm.receipts.id !== undefined && !vm.showAll"><div consolidated-summary total-summary="vm.receipts.TotalSummary" throb="vm.tabs[2].loadingData"></div><div class="col-lg=6"><div class="col-md-6 col-xs-12 dashboard-maincontent grid-block"><div class="panel ng-isolate-scope clearfix p20"><strong class="no-m text-center mb20">{{\'home.receipt chart title\' | translate}}<br>{{ \'home.chart range\' | translate:vm.receipts.TrendData}}</strong><vl-line data="vm.receipts.options" throbber="vm.tabs[2].loadingData" id="{{vm.receipts.id}}" class="no-shadow" nodataimage="#"></vl-line></div></div></div></div><!-- Tabular Data --><div class="col-12"><div revenue-table ulbtype="vm.ulbtype" details="vm.receipts.TableData" total-summary="totalSummary" ftype="vm.ftype" fkey="vm.fkey" throb="vm.tabs[2].loadingData" show="1"></div></div></div></div>');
$templateCache.put('app/vl/dashboards/revenue/views/revenue.top10.html','<div><!--<h2 data-translate="revenue.tabs.collections.section.title">Collections</h2>--><!-- <div class="splash" ng-show="vm.loadingAllUlbDataRecords">\n        <span>Loading ULB Data  <i class="fa fa-spinner fa-spin fa-3x"></i></span>\n    </div> --><div class="clearfix"></div><!-- Revenue Details --><!-- <div class="splash" ng-show="!vm.tabs[0] || vm.tabs[0].loadingData">\n        Loading Revenue Details <i class="fa fa-spinner fa-spin fa-5x "></i>\n    </div> --><div class="DCB_menu mt25 clearfix"><!-- Tabular Data --><div class="col-12"><div class="pull-right col-md-2 col-xs-12" style="padding:10px"><div class="iph" ng-show="vm.conversionType"><div class="switch_trigger analysis-switch pull-left currency"><div class="switch switch-blue no-m"><input type="radio" class="switch-input" id="lakhs" value="Crores" ng-model="vm.conversionType"><label for="lakhs" class="switch-label switch-label-off">Crores</label><input type="radio" class="switch-input" id="crores" value="Lakhs" ng-model="vm.conversionType"><label for="crores" class="switch-label switch-label-on">Lakhs</label><span class="switch-selection"></span></div></div></div></div><div revenue-table ulbtype="vm.ulbtype" details="vm.top10.TableData" total-summary="totalSummary" ftype="vm.ftype" fkey="vm.fkey" throb="vm.tabs[3].loadingData"></div></div></div></div>');
$templateCache.put('app/vl/dashboards/revenue/views/revenue.top100defaulters.html','<div><!--<h2 data-translate="revenue.tabs.collections.section.title">Collections</h2>--><!-- <div class="splash" ng-show="vm.loadingAllUlbDataRecords">\n        <span>Loading ULB Data  <i class="fa fa-spinner fa-spin fa-3x"></i></span>\n    </div> --><div class="clearfix"></div><!-- Revenue Details --><!-- <div class="splash" ng-show="!vm.tabs[0] || vm.tabs[0].loadingData">\n        Loading Revenue Details <i class="fa fa-spinner fa-spin fa-5x "></i>\n    </div> --><div class="DCB_menu mt25 clearfix"><!-- Tabular Data --><div class="col-md-12"><div class="pull-right col-md-2 col-xs-12" style="padding:10px"><div class="iph" ng-show="vm.conversionType"><div class="switch_trigger analysis-switch pull-left currency"><div class="switch switch-blue no-m"><input type="radio" class="switch-input" id="lakhs" value="Crores" ng-model="vm.conversionType"><label for="lakhs" class="switch-label switch-label-off">Crores</label><input type="radio" class="switch-input" id="crores" value="Lakhs" ng-model="vm.conversionType"><label for="crores" class="switch-label switch-label-on">Lakhs</label><span class="switch-selection"></span></div></div></div></div><div revenue-table details="vm.top100Defaulters.TableData" total-summary="totalSummary" ftype="vm.ftype" fkey="vm.fkey" throb="vm.tabs[5].loadingData"></div></div></div></div>');}]);})();